(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/dipendenti-report/dipendenti.report.html":
/*!*************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/dipendenti-report/dipendenti.report.html ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-spin [nzSpinning]=\"isSpinning\">\r\n  <nz-card class=\"newCard\">\r\n    <nz-form-label>Selezionare il dipendente ed il periodo</nz-form-label>\r\n    <div nz-row nzGutter=\"6\">\r\n\r\n      <div nz-col nzSpan=\"6\">\r\n        <nz-form-control>\r\n          <nz-select [(ngModel)]=\"selectedCompany\" (ngModelChange)=\"selectUsers()\" nzPlaceHolder=\"Selezionare l'azienda\">\r\n            <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\r\n          </nz-select>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"8\">\r\n        <nz-form-control>\r\n          <nz-select [(ngModel)]=\"selectedUser\" nzPlaceHolder=\"Selezionare il dipendente\" [disabled]=\"!selectedCompany\">\r\n            <nz-option *ngFor=\"let u of selectedUsers\" [nzValue]=\"u\" [nzLabel]=\"u.name + ' ' + u.surname\"></nz-option>\r\n          </nz-select>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"6\">\r\n        <nz-form-control>\r\n          <nz-range-picker [nzFormat]=\"dateFormat\" [(ngModel)]=\"rangeDate\" [nzPlaceHolder]=\"rangePlace\"></nz-range-picker>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"4\" class=\"no-print\">\r\n        <nz-form-control>\r\n          <button nz-button nzType=\"primary\" (click)=\"loadTimes()\" [disabled]=\"!selectedCompany || !selectedUser\">\r\n            <i nz-icon nzType=\"search\"></i>Cerca\r\n          </button>\r\n        </nz-form-control>\r\n      </div>\r\n    </div>\r\n    \r\n    <div nz-row nzGutter=\"6\">\r\n      <div nz-col  style=\"padding: 20px 0 0 0\">\r\n        {{ currentTotale }}\r\n      </div>\r\n    </div>\r\n  </nz-card>\r\n</nz-spin>\r\n\r\n\r\n<nz-table #editRowTable [nzBordered]=\"true\" [nzData]=\"displayData\" [nzShowPagination]=\"false\" [nzFrontPagination]=\"false\"\r\n  [nzLoading]=\"isLoading\">\r\n  <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\r\n    <tr>\r\n      <th nzShowSort nzSortKey=\"status\" nzWidth=\"15%\">Data</th>\r\n      <th nzShowSort nzSortKey=\"code\" nzWidth=\"20%\">Stato</th>\r\n      <th nzShowSort nzSortKey=\"name\" nzWidth=\"50%\">Ordine</th>\r\n      <th nzShowSort nzSortKey=\"company\" nzWidth=\"15%\">Ore</th>\r\n    </tr>\r\n  </thead>\r\n\r\n  <tbody>\r\n    <tr *ngFor=\"let data of editRowTable.data\">\r\n      <td>\r\n        <ng-container>\r\n          {{data.date | date: 'yyyy-MM-dd' }}\r\n        </ng-container>\r\n      </td>\r\n      <td>\r\n        <ng-container>\r\n          <nz-switch class=\"no-print\" [ngModel]=\"data.status\" [nzDisabled]=\"true\" [nzCheckedChildren]=\"checkedTemplate\" [nzUnCheckedChildren]=\"unCheckedTemplate\"></nz-switch>\r\n          <ng-template #checkedTemplate>\r\n            <i nz-icon nzType=\"check\"></i>\r\n          </ng-template>\r\n          <ng-template #unCheckedTemplate>\r\n            <i nz-icon nzType=\"close\"></i>\r\n          </ng-template>\r\n          <div class=\"only-print\">{{data.status && 'Attivo' || 'Non attivo' }}</div>\r\n        </ng-container>\r\n      </td>\r\n      <td>\r\n        <ng-container>\r\n          {{ data.orderId }} - {{ data.title }}\r\n        </ng-container>\r\n      </td>\r\n      <td>\r\n        <ng-container>\r\n          {{data.h}}\r\n        </ng-container>\r\n      </td>\r\n    </tr>\r\n  </tbody>\r\n</nz-table>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/dipendenti/dipendenti.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/dipendenti/dipendenti.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-card class=\"newCard\">\n  <nz-form-label>Nuovo inserimento</nz-form-label>\n  <div nz-row nzGutter=\"6\">\n    <div nz-col nzSpan=\"2\">\n      <nz-form-control nzValidateStatus=\"{{newCodeError}}\">\n        <nz-input-number (keydown)=\"g.numberLimit($event, 5)\" nzMin=\"10000\" nzMax=\"99999\" nzPlaceHolder=\"Codice\" [(ngModel)]=\"newDipendente.code\"></nz-input-number>\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"4\">\n      <nz-form-control>\n        <input nz-input placeholder=\"Nome\" [(ngModel)]=\"newDipendente.name\">\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"4\">\n      <nz-form-control>\n        <input nz-input placeholder=\"Cognome\" [(ngModel)]=\"newDipendente.surname\">\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"4\">\n      <nz-form-control>\n        <nz-select style=\"min-width: 120px;\" nzPlaceHolder=\"Azienda\" [(ngModel)]=\"newDipendente.company\">\n          <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\n        </nz-select>\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"4\">\n      <nz-form-control>\n        <input nz-input placeholder=\"Email\" [(ngModel)]=\"newDipendente.email\">\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"3\">\n      <nz-form-control>\n        <input nz-input placeholder=\"RFID\" [(ngModel)]=\"newDipendente.rfid\">\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"3\">\n      <nz-form-control>\n        <button nz-button nzType=\"primary\" (click)=\"saveNew()\" [disabled]=\"newDipendente.code.length < 5 || newDipendente.name.length < 2 || newDipendente.surname.length < 2 || !newDipendente.company\">\n          <i nz-icon nzType=\"save\"></i>Salva\n        </button>\n      </nz-form-control>\n    </div>\n  </div>\n</nz-card>\n<nz-table #editRowTable [nzNoResult]=\"noResultTemplate\" nzBordered [nzData]=\"displayData\" [nzPageSize]=\"30\" [nzLoading]=\"isLoading\">\n\n  <ng-template #noResultTemplate>\n    <button nz-button nzType=\"danger\" (click)=\"loadData()\">\n      <i nz-icon nzType=\"retweet\"></i>Riprova\n    </button>\n  </ng-template>\n\n  <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\n    <tr>\n      <th nzShowSort nzSortKey=\"code\" nzWidth=\"5%\">Codice</th>\n      <th nzShowSort nzSortKey=\"name\" nzWidth=\"20%\">Nome</th>\n      <th nzShowSort nzSortKey=\"surname\" nzWidth=\"20%\">Cognome</th>\n      <th nzShowSort nzSortKey=\"company\" nzWidth=\"10%\">Azienda</th>\n      <th nzShowSort nzSortKey=\"company\" nzWidth=\"20%\">Email</th>\n      <th nzShowSort nzSortKey=\"company\" nzWidth=\"10%\">RFID</th>\n      <th>Azioni</th>\n    </tr>\n  </thead>\n\n  <tbody>\n    <tr *ngFor=\"let data of editRowTable.data\" [ngClass]=\"{active: editCache[data.id].edit}\">\n      <td>\n        <div class=\"editable-cell\">\n          <div class=\"editable-cell-text-wrapper\">\n            <ng-container *ngIf=\"!editCache[data.id].edit\">\n              {{data.code}}\n            </ng-container>\n            <ng-container *ngIf=\"editCache[data.id].edit\">\n              <input type=\"text\" nz-input [(ngModel)]=\"editCache[data.id].data.code\">\n            </ng-container>\n          </div>\n        </div>\n      </td>\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{data.name}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <input type=\"text\" nz-input [(ngModel)]=\"editCache[data.id].data.name\">\n        </ng-container>\n      </td>\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{data.surname}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <input type=\"text\" nz-input [(ngModel)]=\"editCache[data.id].data.surname\">\n        </ng-container>\n      </td>\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{data.company}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <nz-select style=\"width: 120px;\" [(ngModel)]=\"editCache[data.id].data.company\">\n            <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\n          </nz-select>\n        </ng-container>\n      </td>\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{data.email}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <input type=\"text\" nz-input [(ngModel)]=\"editCache[data.id].data.email\">\n        </ng-container>\n      </td>\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{data.rfid}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <input type=\"text\" nz-input [(ngModel)]=\"editCache[data.id].data.rfid\">\n        </ng-container>\n      </td>\n      <td>\n        <div class=\"editable-row-operations\">\n          <ng-container *ngIf=\"!editCache[data.id].edit\">\n            <button nz-button (click)=\"startEdit(data.id)\">\n              <i nz-icon nzType=\"edit\"></i>\n            </button>\n            &nbsp;\n            <button nz-button nzType=\"danger\" (click)=\"deleteRow(data.id)\">\n              <i nz-icon nzType=\"delete\"></i>\n            </button>\n          </ng-container>\n          <ng-container *ngIf=\"editCache[data.id].edit\">\n            <button nz-button (click)=\"saveEdit(data.id)\">\n              <i nz-icon nzType=\"save\"></i>\n            </button>\n            &nbsp;\n            <button nz-button (click)=\"cancelEdit(data.id)\">\n              <i nz-icon nzType=\"rollback\"></i>\n            </button>\n          </ng-container>\n        </div>\n      </td>\n    </tr>\n  </tbody>\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/excel-report/excel-report.html":
/*!***************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/excel-report/excel-report.html ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-spin [nzSpinning]=\"isSpinning\">\r\n  <nz-card class=\"newCard\">\r\n    <nz-form-label>Selezionare l'azienda</nz-form-label>\r\n    <div nz-row nzGutter=\"6\">\r\n\r\n      <div nz-col nzSpan=\"9\">\r\n        <nz-form-control>\r\n          <nz-select [(ngModel)]=\"selectedCompany\" (ngModelChange)=\"selectUsers()\"\r\n            nzPlaceHolder=\"Selezionare l'azienda\">\r\n            <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\r\n          </nz-select>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"9\">\r\n        <nz-form-control>\r\n          <nz-month-picker [(ngModel)]=\"selectedMonth\" nzPlaceHolder=\"Seleziona il mese\" [disabled]=\"!selectedCompany\">\r\n          </nz-month-picker>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"6\" class=\"no-print\">\r\n        <nz-form-control>\r\n          <button nz-button nzType=\"primary\" (click)=\"loadTimes()\" [disabled]=\"!selectedCompany || !selectedMonth\">\r\n            <i nz-icon nzType=\"copy\"></i>Esporta negli appunti\r\n          </button>\r\n        </nz-form-control>\r\n      </div>\r\n    </div>\r\n\r\n    <div nz-row nzGutter=\"6\">\r\n      <div nz-col style=\"padding: 20px 0 0 0\">\r\n        {{ currentTotale }}\r\n      </div>\r\n    </div>\r\n  </nz-card>\r\n</nz-spin>\r\n\r\n<br>\r\n\r\n<textarea #textArea nz-input rows=\"10\" class=\"export\" [(ngModel)]=\"txtExport\" placeholder=\"Testo per Excel\"></textarea>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/home.component.html":
/*!****************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/home.component.html ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-layout>\n  <nz-sider class=\"no-print\" nz-menu [nzTheme]=\"'dark'\" [nzMode]=\"'inline'\" nzCollapsible [(nzCollapsed)]=\"isCollapsed\">\n    <div class=\"logo\">\n      <img class=\"logoImg\" [ngClass]=\"{logoSmall: isCollapsed}\" src=\"../assets/logo.png\">\n    </div>\n    <ul nz-menu [nzTheme]=\"'dark'\" [nzMode]=\"'inline'\" [nzInlineCollapsed]=\"isCollapsed\">\n      <li *ngIf=\"!isRestricted\" nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'dipendenti' }}\" [nzSelected]=\"g.menuState == 1\">\n        <span>\n          <i nz-icon nzType=\"team\"></i>\n          <span class=\"nav-text\">Tabella Dipendenti</span>\n        </span>\n      </li>\n      <li nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'ordini' }}\" [nzSelected]=\"g.menuState == 2\">\n        <span>\n          <i nz-icon nzType=\"profile\"></i>\n          <span class=\"nav-text\">Tabella Ordini</span>\n        </span>\n      </li>\n      <li *ngIf=\"!isRestricted\" nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'tempi' }}\" [nzSelected]=\"g.menuState == 3\">\n        <span>\n          <i nz-icon nzType=\"clock-circle\"></i>\n          <span class=\"nav-text\">Tabella Tempi</span>\n        </span>\n      </li>\n      <li *ngIf=\"!isRestricted\" nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'rfid' }}\" [nzSelected]=\"g.menuState == 4\">\n        <span>\n          <i nz-icon nzType=\"retweet\"></i>\n          <span class=\"nav-text\">Tabella Ingressi</span>\n        </span>\n      </li>\n      <li *ngIf=\"!isRestricted\" nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'rfid-gg' }}\" [nzSelected]=\"g.menuState == 5\">\n        <span>\n          <i nz-icon nzType=\"retweet\"></i>\n          <span class=\"nav-text\">Tabella Ingressi Gg</span>\n        </span>\n      </li>\n      <li *ngIf=\"!isRestricted\" nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'ordini.report' }}\" [nzSelected]=\"g.menuState == 6\">\n        <span>\n          <i nz-icon nzType=\"file-text\"></i>\n          <span class=\"nav-text\">Report Ordini</span>\n        </span>\n      </li>\n      <li *ngIf=\"!isRestricted\" nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'incidenze.report' }}\" [nzSelected]=\"g.menuState == 7\">\n        <span>\n          <i nz-icon nzType=\"file-text\"></i>\n          <span class=\"nav-text\">Report Incidenze</span>\n        </span>\n      </li>\n      <li *ngIf=\"!isRestricted\" nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'dipendenti.report' }}\" [nzSelected]=\"g.menuState == 8\">\n        <span>\n          <i nz-icon nzType=\"file-text\"></i>\n          <span class=\"nav-text\">Report Dipendenti</span>\n        </span>\n      </li>\n      <li *ngIf=\"!isRestricted\" nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'mese.report' }}\" [nzSelected]=\"g.menuState == 9\">\n        <span>\n          <i nz-icon nzType=\"calendar\"></i>\n          <span class=\"nav-text\">Report Mese</span>\n        </span>\n      </li>\n      <li *ngIf=\"!isRestricted\" nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'premi.report' }}\" [nzSelected]=\"g.menuState == 10\">\n        <span>\n          <i nz-icon nzType=\"calendar\"></i>\n          <span class=\"nav-text\">Report Premi</span>\n        </span>\n      </li>\n      <li *ngIf=\"!isRestricted\" nz-menu-item [routerLink]=\"{ outlets: { homeContent: 'excel.report' }}\" [nzSelected]=\"g.menuState == 11\">\n        <span>\n          <i nz-icon nzType=\"file-excel\"></i>\n          <span class=\"nav-text\">Report Excel</span>\n        </span>\n      </li>\n      <li nz-menu-item title=\"logout\" (click)=\"logOut()\">\n        <span>\n          <i nz-icon nzType=\"logout\"></i>\n          <span class=\"nav-text\">Esci</span>\n        </span>\n      </li>\n    </ul>\n  </nz-sider>\n\n  <nz-layout>\n    <nz-header class=\"fixed-header\">\n      <i nz-icon nzType=\"menu-unfold\" *ngIf=\"isCollapsed\" class=\"no-print\" (click)=\"isCollapsed=false\"></i>\n      <i nz-icon nzType=\"menu-fold\" *ngIf=\"!isCollapsed\" class=\"no-print\" (click)=\"isCollapsed=true\"></i>\n      {{g.homeTitle}}\n    </nz-header>\n    <nz-content class=\"content\">\n      <div class=\"inner-content\">\n        <router-outlet name=\"homeContent\">\n        </router-outlet>\n      </div>\n    </nz-content>\n    <nz-footer style=\"text-align: center;\">{{g.footerTitle}}</nz-footer>\n  </nz-layout>\n</nz-layout>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/incidenze-report/incidenze.report.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/incidenze-report/incidenze.report.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-spin [nzSpinning]=\"isSpinning\">\r\n  <nz-card class=\"newCard\">\r\n    <nz-form-label>Selezionare l'ordine</nz-form-label>\r\n    <div nz-row nzGutter=\"6\">\r\n\r\n      <div nz-col nzSpan=\"6\">\r\n        <nz-form-control>\r\n          <nz-select [(ngModel)]=\"selectedCompany\" (ngModelChange)=\"selectOrders()\" nzPlaceHolder=\"Selezionare l'azienda\">\r\n            <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\r\n          </nz-select>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"12\">\r\n        <nz-form-control>\r\n          <nz-select [(ngModel)]=\"selectedOrder\" nzPlaceHolder=\"Selezionare l'ordine\" [disabled]=\"!selectedCompany\">\r\n            <nz-option *ngFor=\"let o of selectedOrders\" [nzValue]=\"o\" [nzLabel]=\"o.code + ' - ' + o.title\"></nz-option>\r\n          </nz-select>\r\n        </nz-form-control>\r\n      </div>\r\n      <div nz-col nzSpan=\"2\">\r\n        <nz-form-control>\r\n          <nz-switch class=\"ordini-select\" [(ngModel)]=\"statusFilter\" (click)=\"loadData(true)\" nzCheckedChildren=\"Attivi\" nzUnCheckedChildren=\"Non attivi\"></nz-switch>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"4\" class=\"no-print\">\r\n        <nz-form-control>\r\n          <button nz-button nzType=\"primary\" (click)=\"loadTimes()\" [disabled]=\"!selectedCompany || !selectedOrder\">\r\n            <i nz-icon nzType=\"search\"></i>Cerca\r\n          </button>\r\n        </nz-form-control>\r\n      </div>\r\n    </div>\r\n\r\n    <div nz-row nzGutter=\"6\">\r\n      <div nz-col style=\"height: 50px; display: flex; align-items: center;\">\r\n        <strong style=\" padding: 0 20px 0 0\">{{ currentTotale }}</strong>\r\n      </div>\r\n    </div>\r\n  </nz-card>\r\n</nz-spin>\r\n\r\n\r\n<nz-table #editRowTable [nzBordered]=\"true\" [nzData]=\"displayData\" [nzShowPagination]=\"false\" [nzFrontPagination]=\"false\" [nzLoading]=\"isLoading\">\r\n  <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\r\n    <tr>\r\n      <th nzShowSort nzSortKey=\"userId\" nzWidth=\"10%\">Codice</th>\r\n      <th nzShowSort nzSortKey=\"name\" nzWidth=\"55%\">Dipendente</th>\r\n      <th nzShowSort nzSortKey=\"Sum_h\" nzWidth=\"15%\">Totale Ore</th>\r\n      <th nzShowSort nzSortKey=\"incidenza\" nzWidth=\"25%\">Incidenza %</th>\r\n    </tr>\r\n  </thead>\r\n\r\n  <tbody>\r\n    <tr *ngFor=\"let data of editRowTable.data\">\r\n      <td>\r\n        <ng-container>\r\n          {{data.userId}}\r\n        </ng-container>\r\n      </td>\r\n      <td>\r\n        <ng-container>\r\n          {{ data.name }} {{ data.surname }}\r\n        </ng-container>\r\n      </td>\r\n      <td>\r\n        <ng-container>\r\n          {{data.Sum_h}}\r\n        </ng-container>\r\n      </td>\r\n      <td>\r\n        <ng-container>\r\n          {{ data.incidenza }}\r\n        </ng-container>\r\n      </td>\r\n    </tr>\r\n  </tbody>\r\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/mese-report/mese-report.html":
/*!*************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/mese-report/mese-report.html ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-spin [nzSpinning]=\"isSpinning\">\r\n  <nz-card class=\"newCard\">\r\n    <nz-form-label>Selezionare l'azienda</nz-form-label>\r\n    <div nz-row nzGutter=\"6\">\r\n\r\n      <div nz-col nzSpan=\"11\">\r\n        <nz-form-control>\r\n          <nz-select [(ngModel)]=\"selectedCompany\" (ngModelChange)=\"selectUsers()\"\r\n            nzPlaceHolder=\"Selezionare l'azienda\">\r\n            <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\r\n          </nz-select>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"9\">\r\n        <nz-form-control>\r\n          <nz-month-picker [(ngModel)]=\"selectedMonth\" nzPlaceHolder=\"Seleziona il mese\" [disabled]=\"!selectedCompany\">\r\n          </nz-month-picker>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"4\" class=\"no-print\">\r\n        <nz-form-control>\r\n          <button nz-button nzType=\"primary\" (click)=\"loadTimes()\" [disabled]=\"!selectedCompany || !selectedMonth\">\r\n            <i nz-icon nzType=\"search\"></i>Cerca\r\n          </button>\r\n        </nz-form-control>\r\n      </div>\r\n    </div>\r\n\r\n    <div nz-row nzGutter=\"6\">\r\n      <div nz-col style=\"padding: 20px 0 0 0\">\r\n        {{ currentTotale }}\r\n      </div>\r\n    </div>\r\n  </nz-card>\r\n</nz-spin>\r\n\r\n<nz-table #nestedTable [nzData]=\"daysData\" [nzShowPagination]=\"false\">\r\n  <thead>\r\n    <tr>\r\n      <th nzShowExpand>\r\n        <button *ngIf=\"daysData.length > 0\" nz-button (click)=\"copyToClipboard()\" nzType=\"default\"><i class=\"anticon anticon-copy\"></i></button>\r\n      </th>\r\n      <th>{{ selectedMonthName | titlecase}}</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n      <ng-template ngFor let-data [ngForOf]=\"daysData\">\r\n        <tr>\r\n          <td nzShowExpand [(nzExpand)]=\"data.expand\"></td>\r\n          <td>{{data.day}}</td>\r\n        </tr>\r\n        <tr [nzExpand]=\"data.expand\">\r\n            <td></td>\r\n            <td class=\"userRow\">\r\n              <nz-table #editRowTable [nzBordered]=\"true\" [nzData]=\"data.users\" nzSize=\"small\" [nzShowPagination]=\"false\" [nzLoading]=\"isLoading\">\r\n                <thead>\r\n                    <tr>\r\n                      <th>Dipendente</th>\r\n                      <th>Ore</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    <tr *ngFor=\"let user of data.users;\" [class.alertRow]=\"user.Sum_h <= 6\">\r\n                      <td>\r\n                          {{ user.name }} {{ user.surname }}\r\n                      </td>\r\n                      <td>\r\n                          {{user.Sum_h}}\r\n                      </td>\r\n                    </tr>\r\n                </tbody>\r\n              </nz-table>\r\n            </td>\r\n          </tr>  \r\n      </ng-template>\r\n    </tbody>\r\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/ordini-report/ordini.report.html":
/*!*****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/ordini-report/ordini.report.html ***!
  \*****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-spin [nzSpinning]=\"isSpinning\">\r\n  <nz-card class=\"newCard\">\r\n    <nz-form-label>Selezionare l'ordine</nz-form-label>\r\n    <div nz-row nzGutter=\"6\">\r\n\r\n      <div nz-col nzSpan=\"6\">\r\n        <nz-form-control>\r\n          <nz-select [(ngModel)]=\"selectedCompany\" (ngModelChange)=\"selectOrders()\" nzPlaceHolder=\"Selezionare l'azienda\">\r\n            <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\r\n          </nz-select>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"8\">\r\n        <nz-form-control>\r\n          <nz-select [(ngModel)]=\"selectedOrder\" nzPlaceHolder=\"Selezionare l'ordine\" [disabled]=\"!selectedCompany\">\r\n            <nz-option *ngFor=\"let o of selectedOrders\" [nzValue]=\"o\" [nzLabel]=\"o.code + ' - ' + o.title\"></nz-option>\r\n          </nz-select>\r\n        </nz-form-control>\r\n      </div>\r\n      \r\n      <div nz-col nzSpan=\"2\">\r\n        <nz-form-control>\r\n          <nz-switch class=\"ordini-select\" [(ngModel)]=\"statusFilter\" (click)=\"loadData(true)\" nzCheckedChildren=\"Attivi\" nzUnCheckedChildren=\"Non attivi\"></nz-switch>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n      <div nz-col nzSpan=\"4\">\r\n        <nz-form-control>\r\n          <nz-month-picker [(ngModel)]=\"selectedMonth\" nzPlaceHolder=\"Seleziona il mese\" [disabled]=\"!selectedCompany\"></nz-month-picker>\r\n        </nz-form-control>\r\n      </div>\r\n\r\n\r\n\r\n      <div nz-col nzSpan=\"4\" class=\"no-print\">\r\n        <nz-form-control>\r\n          <button nz-button nzType=\"primary\" (click)=\"loadTimes()\" [disabled]=\"!selectedCompany || !selectedOrder\">\r\n            <i nz-icon nzType=\"search\"></i>Cerca\r\n          </button>\r\n        </nz-form-control>\r\n      </div>\r\n    </div>\r\n\r\n    <div nz-row nzGutter=\"6\">\r\n      <div nz-col style=\"height: 50px; display: flex; align-items: center;\">\r\n        <strong style=\" padding: 0 20px 0 0\">{{ currentTotale }}</strong>\r\n        <nz-switch class=\"ordini-select\" [(ngModel)]=\"totalSwitch\" (click)=\"processData()\" nzCheckedChildren=\"Totali\" nzUnCheckedChildren=\"Dettaglio\"></nz-switch>\r\n      </div>\r\n    </div>\r\n  </nz-card>\r\n</nz-spin>\r\n\r\n\r\n<nz-table #editRowTable [nzBordered]=\"true\" [nzData]=\"displayData\" [nzShowPagination]=\"false\" [nzFrontPagination]=\"false\" [nzLoading]=\"isLoading\">\r\n  <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\r\n    <tr>\r\n      <th nzShowSort nzSortKey=\"status\" nzWidth=\"15%\">Data</th>\r\n      <th nzShowSort nzSortKey=\"code\" nzWidth=\"10%\">Stato</th>\r\n      <th nzShowSort nzSortKey=\"code\" nzWidth=\"60%\">Dipendente</th>\r\n      <th nzShowSort nzSortKey=\"company\" nzWidth=\"15%\">Ore</th>\r\n    </tr>\r\n  </thead>\r\n\r\n  <tbody>\r\n    <tr *ngFor=\"let data of editRowTable.data\">\r\n      <td>\r\n        <ng-container>\r\n          {{data.date | date: 'yyyy-MM-dd' }}\r\n        </ng-container>\r\n      </td>\r\n      <td>\r\n        <ng-container>\r\n          <nz-switch class=\"no-print\" [ngModel]=\"data.status\" [nzDisabled]=\"true\" [nzCheckedChildren]=\"checkedTemplate\" [nzUnCheckedChildren]=\"unCheckedTemplate\"></nz-switch>\r\n          <ng-template #checkedTemplate>\r\n            <i nz-icon nzType=\"check\"></i>\r\n          </ng-template>\r\n          <ng-template #unCheckedTemplate>\r\n            <i nz-icon nzType=\"close\"></i>\r\n          </ng-template>\r\n          <div class=\"only-print\">{{data.status && 'Attivo' || 'Non attivo' }}</div>\r\n        </ng-container>\r\n      </td>\r\n      <td>\r\n        <ng-container>\r\n          {{ data.name }} {{ data.surname }}\r\n        </ng-container>\r\n      </td>\r\n      <td>\r\n        <ng-container>\r\n          {{data.h}}\r\n        </ng-container>\r\n      </td>\r\n    </tr>\r\n  </tbody>\r\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/ordini/ordini.component.html":
/*!*************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/ordini/ordini.component.html ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-card *ngIf=\"!isRestricted\" class=\"newCard\">\n  <div nz-row nzGutter=\"6\">\n    <nz-col nzSpan=\"16\">\n      <nz-form-label>Nuovo inserimento</nz-form-label>\n    </nz-col>\n\n    <nz-col nzSpan=\"2\">\n      <nz-form-label>Costo materiale</nz-form-label>\n    </nz-col>\n\n    <nz-col nzSpan=\"2\">\n      <nz-form-label>Costo orario</nz-form-label>\n\n    </nz-col>\n    <nz-col nzSpan=\"1\">\n      <nz-form-label>Premio</nz-form-label>\n    </nz-col>\n  </div>\n  <div nz-row nzGutter=\"6\">\n    <div nz-col nzSpan=\"1\">\n      <nz-form-control>\n        <nz-switch [ngModel]=\"newOrdine.status\" [nzCheckedChildren]=\"checkedTemplate\" [nzUnCheckedChildren]=\"unCheckedTemplate\"></nz-switch>\n        <ng-template #checkedTemplate>\n          <i nz-icon nzType=\"check\"></i>\n        </ng-template>\n        <ng-template #unCheckedTemplate>\n          <i nz-icon nzType=\"close\"></i>\n        </ng-template>\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"2\">\n      <nz-form-control>\n        <input nz-input maxlength=\"10\" placeholder=\"Codice\" [(ngModel)]=\"newOrdine.code\">\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"7\">\n      <nz-form-control>\n        <input nz-input maxlength=\"60\" placeholder=\"Descrizione\" [(ngModel)]=\"newOrdine.title\">\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"2\">\n      <nz-form-control>\n        <nz-input-number [nzMin]=\"0\" [nzMax]=\"9999\" [nzPlaceHolder]=\"'Stima'\" [(ngModel)]=\"newOrdine.forecast\"></nz-input-number>\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"4\">\n      <nz-form-control>\n        <nz-select nzPlaceHolder=\"Azienda\" style=\"width: 120px;\" [(ngModel)]=\"newOrdine.company\">\n          <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\n        </nz-select>\n      </nz-form-control>\n    </div>\n    <!-- COSTO MATERIALE -->\n    <div nz-col nzSpan=\"2\">\n      <nz-form-control>\n        <nz-input-number maxlength=\"10\" [nzPrecision]=\"2\" [nzMin]=\"0\" [nzParser]=\"parserEuro\" [nzFormatter]=\"formatterEuro\" [(ngModel)]=\"newOrdine.costM\"></nz-input-number>\n      </nz-form-control>\n    </div>\n    <!-- COSTO ORARIO -->\n    <div nz-col nzSpan=\"2\">\n      <nz-form-control>\n        <nz-input-number maxlength=\"10\" [nzPrecision]=\"2\" [nzMin]=\"0\" [nzParser]=\"parserEuro\" [nzFormatter]=\"formatterEuro\" [nzPrecision]=\"2\" [(ngModel)]=\"newOrdine.costH\"></nz-input-number>\n      </nz-form-control>\n    </div>\n    <!-- PREMIO: TRUE/FALSE -->\n    <div nz-col nzSpan=\"1\">\n      <nz-form-control>\n        <nz-switch [ngModel]=\"newOrdine.prize\" [nzCheckedChildren]=\"checkedTemplate\" [nzUnCheckedChildren]=\"unCheckedTemplate\"></nz-switch>\n      </nz-form-control>\n    </div>\n    <div nz-col nzSpan=\"3\">\n      <nz-form-control>\n        <button nz-button nzType=\"primary\" (click)=\"saveNew()\" [disabled]=\"newOrdine.code.length < 2 || newOrdine.title.length < 2 || !newOrdine.company\">\n          <i nz-icon nzType=\"save\"></i>Salva\n        </button>\n      </nz-form-control>\n    </div>\n  </div>\n</nz-card>\n\n\n<nz-table #editRowTable [nzNoResult]=\"noResultTemplate\" nzBordered [nzData]=\"displayData\" [nzPageSize]=\"20\" [nzLoading]=\"isLoading\">\n  <ng-template #noResultTemplate>\n    <button nz-button nzType=\"danger\" (click)=\"loadData()\">\n      <i nz-icon nzType=\"retweet\"></i>Riprova</button>\n  </ng-template>\n\n  <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\n    <tr class=\"ordini-select-wrapper\">\n      <nz-switch class=\"ordini-select\" (click)=\"loadData()\" [(ngModel)]=\"activeFilter\" nzCheckedChildren=\"Ordini attivi\" nzUnCheckedChildren=\"Ordini disattivati\"></nz-switch>\n      <nz-switch class=\"ordini-select\" (click)=\"loadData()\" [(ngModel)]=\"prizeFilter\" nzCheckedChildren=\"Ordini con premi\" nzUnCheckedChildren=\"Tutti gli ordini\"></nz-switch>\n      <nz-form-control class=\"filter-control\">\n        <nz-input-group [nzSuffix]=\"suffixIconSearch\">\n          <input nz-input maxlength=\"10\" placeholder=\"Filtro descrizione\" [(ngModel)]=\"orderFilter\" (ngModelChange)=\"filterChange($event)\">\n        </nz-input-group>\n        <ng-template #suffixIconSearch>\n          <i nz-icon nzType=\"filter\"></i>\n        </ng-template>\n      </nz-form-control>\n\n      <ng-container><span class=\"ext\"><b>Stimato: </b>{{totStimato| number}}</span></ng-container>\n      <ng-container><span class=\"tot\"><b>Lavorato: </b>{{totLavorato| number}}</span></ng-container>\n    </tr>\n    <tr>\n      <th nzShowSort nzWidth=\"5%\">Stato</th>\n      <th nzShowSort nzSortKey=\"code\" nzWidth=\"6%\">Codice</th>\n      <th nzShowSort nzSortKey=\"name\" nzWidth=\"22%\">Descrizione</th>\n      <th nzShowSort nzWidth=\"6%\">Stima</th>\n      <th nzShowSort nzWidth=\"8%\">Reale</th>\n      <th nzShowSort nzSortKey=\"company\" nzWidth=\"9%\">Azienda</th>\n      <th nzShowSort nzWidth=\"8%\">Costo Orario</th>\n      <th nzShowSort nzWidth=\"8%\">Costo Materiale stimato</th>\n      <th nzShowSort nzWidth=\"8%\">Costo Materiale reale</th>\n      <th nzShowSort nzWidth=\"11%\" nzAlign=\"center\">Premio</th>\n      <th *ngIf=\"!isRestricted\">Azioni</th>\n    </tr>\n  </thead>\n\n  <tbody>\n    <tr *ngFor=\"let data of editRowTable.data\" [ngClass]=\"{active: editCache[data.id].edit}\">\n      <td>\n        <ng-container>\n          <nz-switch (click)=\"saveCheck(data.id)\" [(ngModel)]=\"data.status\" [disabled]=\"isRestricted\"></nz-switch>\n          <!-- [nzCheckedChildren]=\"checkedTemplate\" [nzUnCheckedChildren]=\"unCheckedTemplate\" -->\n        </ng-container>\n      </td>\n      <td>\n        <div class=\"editable-cell\">\n          <div class=\"editable-cell-text-wrapper\">\n            <ng-container *ngIf=\"!editCache[data.id].edit\">\n              {{data.code}}\n            </ng-container>\n            <ng-container *ngIf=\"editCache[data.id].edit\">\n              <input type=\"text\" nz-input [(ngModel)]=\"editCache[data.id].data.code\">\n            </ng-container>\n          </div>\n        </div>\n      </td>\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{data.title}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <input type=\"text\" nz-input [(ngModel)]=\"editCache[data.id].data.title\">\n        </ng-container>\n      </td>\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{data.forecast}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <nz-input-number [nzMin]=\"0\" [nzMax]=\"9999\" [(ngModel)]=\"editCache[data.id].data.forecast\"></nz-input-number>\n        </ng-container>\n      </td>\n      <!-- STIMA REALE -->\n      <td>\n        <ng-container *ngIf=\"data.total == null\">\n          <button nz-button nzType=\"default\" (click)=\"calcH(data.id)\"><i nz-icon nzType=\"retweet\"></i> Calcola</button>\n        </ng-container>\n        <ng-container *ngIf=\"data.total >= 0\">\n          {{data.total}}\n        </ng-container>\n      </td>\n      <!-- AZIENDA -->\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{data.company}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <nz-select style=\"width: 120px;\" [(ngModel)]=\"editCache[data.id].data.company\">\n            <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\n          </nz-select>\n        </ng-container>\n      </td>\n      <!-- COSTO ORARIO -->\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          € {{data.costH}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <nz-input-number maxlength=\"10\" [nzPrecision]=\"2\" [nzMin]=\"0\" [nzParser]=\"parserEuro\" [nzFormatter]=\"formatterEuro\" [(ngModel)]=\"editCache[data.id].data.costH\"></nz-input-number>\n        </ng-container>\n      </td>\n      <!-- COSTO ORARIO STIMATO -->\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          € {{data.costM}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <nz-input-number maxlength=\"10\" [nzPrecision]=\"2\" [nzMin]=\"0\" [nzParser]=\"parserEuro\" [nzFormatter]=\"formatterEuro\" [(ngModel)]=\"editCache[data.id].data.costM\"></nz-input-number>\n        </ng-container>\n      </td>\n      <!-- COSTO ORARIO REALE -->\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          € {{data.costMReal}}\n        </ng-container>\n        <ng-container *ngIf=\"editCache[data.id].edit\">\n          <nz-input-number maxlength=\"10\" [nzPrecision]=\"2\" [nzMin]=\"0\" [nzParser]=\"parserEuro\" [nzFormatter]=\"formatterEuro\" [(ngModel)]=\"editCache[data.id].data.costMReal\"></nz-input-number>\n        </ng-container>\n      </td>\n      <!-- PREMIO: VERO/FALSO -->\n      <td nzAlign=\"center\">\n        <ng-container>\n          <nz-switch class=\"prize-select\" (click)=\"savePrize(data.id)\" [(ngModel)]=\"data.prize\" [disabled]=\"isRestricted\"></nz-switch>\n          <!-- [nzCheckedChildren]=\"checkedTemplate\" [nzUnCheckedChildren]=\"unCheckedTemplate\" -->\n          <nz-form-label *ngIf=\"data.prize\" [nzNoColon]=\"true\" style=\"padding-left: 10px;\"> € {{calcPrize(data)}}</nz-form-label>\n        </ng-container>\n      </td>\n      <!-- AZIONI -->\n      <td *ngIf=\"!isRestricted\">\n        <div class=\"editable-row-operations\">\n          <ng-container *ngIf=\"!editCache[data.id].edit\">\n            <button nz-button (click)=\"startEdit(data.id)\">\n              <i nz-icon nzType=\"edit\"></i>\n            </button>\n            &nbsp;\n            <button nz-button nzType=\"danger\" (click)=\"deleteRow(data.id)\">\n              <i nz-icon nzType=\"delete\"></i>\n            </button>\n          </ng-container>\n          <ng-container *ngIf=\"editCache[data.id].edit\">\n            <button nz-button (click)=\"saveEdit(data.id)\">\n              <i nz-icon nzType=\"save\"></i>\n            </button>\n            &nbsp;\n            <button nz-button (click)=\"cancelEdit(data.id)\">\n              <i nz-icon nzType=\"rollback\"></i>\n            </button>\n          </ng-container>\n        </div>\n      </td>\n    </tr>\n  </tbody>\n\n  <nz-dropdown-menu #menu=\"nzDropdownMenu\">\n    <div class=\"ant-table-filter-dropdown\">\n      <div class=\"search-box\">\n        <input type=\"text\" nz-input placeholder=\"Search name\" [(ngModel)]=\"orderFilter\" />\n        <button nz-button nzSize=\"small\" nzType=\"primary\" (click)=\"search()\" class=\"search-button\">\n          Search\n        </button>\n        <button nz-button nzSize=\"small\" (click)=\"reset()\">Reset</button>\n      </div>\n    </div>\n  </nz-dropdown-menu>\n\n\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/premi-report/premi-report.html":
/*!***************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/premi-report/premi-report.html ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-card class=\"newCard\">\n  <nz-form-label>Selezionare il periodo per il calcolo dei premi</nz-form-label>\n  <div nz-row nzGutter=\"6\">\n\n    <div nz-col nzSpan=\"6\">\n      <nz-form-control>\n        <nz-range-picker [nzFormat]=\"dateFormat\" [(ngModel)]=\"rangeDate\" [nzPlaceHolder]=\"rangePlace\"></nz-range-picker>\n      </nz-form-control>\n    </div>\n\n    <div nz-col nzSpan=\"4\" class=\"no-print\">\n      <nz-form-control>\n        <button nz-button nzType=\"primary\" (click)=\"loadData()\" [disabled]=\"rangeDate.length != 2\">\n          <i nz-icon nzType=\"search\"></i>Cerca\n        </button>\n      </nz-form-control>\n    </div>\n\n\n\n    <div nz-col nzSpan=\"8\" class=\"no-print\" *ngIf=\"dataSet.length > 0\">\n      <nz-form-control>\n        <nz-select [(ngModel)]=\"destinatario\">\n          <nz-option nzValue=\"all\" nzLabel=\"Tutti i destinatari\"></nz-option>\n          <nz-option *ngFor=\"let d of destinatari\" nzValue=\"{{d.email}}\" nzLabel=\"{{d.name}} {{d.surname}} | {{d.email}}\"></nz-option>\n        </nz-select>\n      </nz-form-control>\n    </div>\n\n    <div nz-col nzSpan=\"4\" class=\"no-print\" *ngIf=\"dataSet.length > 0\">\n      <nz-form-control>\n        <button nz-button nzType=\"success\" (click)=\"sendMail()\" [disabled]=\"rangeDate.length != 2\">\n          <i nz-icon nzType=\"mail\"></i>Invia mail\n        </button>\n      </nz-form-control>\n    </div>\n  </div>\n</nz-card>\n\n<nz-table #editRowTable nzBordered [nzData]=\" displayData\" [nzPageSize]=\"20\" [nzLoading]=\"isLoading\">\n\n  <thead>\n    <tr>\n      <th nzWidth=\"5%\">Stato</th>\n      <th nzSortKey=\"code\" nzWidth=\"8%\">Codice</th>\n      <th nzSortKey=\"name\" nzWidth=\"27%\">Descrizione</th>\n      <th nzWidth=\"8%\">Stima</th>\n      <th nzWidth=\"8%\">Reale</th>\n      <th nzWidth=\"8%\">Costo Orario</th>\n      <th nzWidth=\"8%\">Costo Materiale stimato</th>\n      <th nzWidth=\"8%\">Costo Materiale reale</th>\n      <th nzWidth=\"13%\" nzAlign=\"center\">Premio</th>\n    </tr>\n    <tr class=\"ordini-select-wrapper\">\n      <p *ngIf=\"totPrize > 0\" style=\"font-size: 16px;line-height: 60px;padding-left: 10px;\">Totale premi: <b>€ {{totPrize}}</b></p>\n    </tr>\n  </thead>\n\n  <tbody>\n    <tr *ngFor=\"let data of editRowTable.data\" [ngClass]=\"{active: editCache[data.id].edit}\">\n      <td>\n        <ng-container>\n          <nz-switch [nzDisabled]=\"true\" [(ngModel)]=\"data.status\"></nz-switch>\n        </ng-container>\n      </td>\n      <td>\n        <div class=\"editable-cell\">\n          <div class=\"editable-cell-text-wrapper\">\n            <ng-container>\n              {{data.code}}\n            </ng-container>\n          </div>\n        </div>\n      </td>\n      <td>\n        <ng-container>\n          {{data.title}}\n        </ng-container>\n      </td>\n      <td>\n        <ng-container>\n          {{data.forecast}}\n        </ng-container>\n      </td>\n      <!-- STIMA REALE -->\n      <td>\n        <ng-container>\n          {{data.total}}\n        </ng-container>\n      </td>\n      <!-- COSTO ORARIO -->\n      <td>\n        <ng-container>\n          € {{data.costH}}\n        </ng-container>\n      </td>\n      <!-- COSTO ORARIO STIMATO -->\n      <td>\n        <ng-container>\n          € {{data.costM}}\n        </ng-container>\n      </td>\n      <!-- COSTO ORARIO REALE -->\n      <td>\n        <ng-container>\n          € {{data.costMReal}}\n        </ng-container>\n      </td>\n      <!-- PREMIO: VERO/FALSO -->\n      <td nzAlign=\"center\">\n        <ng-container>\n          <nz-form-label [nzNoColon]=\"true\" style=\"padding-left: 10px;\"> € {{data.prizeTotal}}</nz-form-label>\n        </ng-container>\n      </td>\n    </tr>\n  </tbody>\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/rfid-gg/rfid-gg.component.html":
/*!***************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/rfid-gg/rfid-gg.component.html ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-table #editRowTable [nzBordered]=\"true\" [nzData]=\"displayData\" [nzPageSize]=\"30\" [nzLoading]=\"isLoading\">\n  <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\n    <tr>\n      <!-- <th nzShowSort nzSortKey=\"status\" nzWidth=\"12%\">ID</th> -->\n      <th nzShowSort nzSortKey=\"code\" nzWidth=\"10%\">Codice</th>\n      <!-- <th nzShowSort nzSortKey=\"code\" nzWidth=\"20%\">Azienda</th> -->\n      <th nzShowSort nzSortKey=\"code\" nzWidth=\"40%\">Dipendente</th>\n      <th nzShowSort nzSortKey=\"time\" nzWidth=\"30%\">Data</th>\n      <th nzShowSort nzSortKey=\"time\" nzWidth=\"10%\">Ore</th>\n      <th nzShowSort nzSortKey=\"time\" nzWidth=\"10%\">Marked</th>\n      <!-- <th>Azioni </th> -->\n    </tr>\n  </thead>\n\n  <tbody>\n    <tr *ngFor=\"let data of editRowTable.data\" [ngClass]=\"{active: editCache[data.id].edit}\">\n      <td>\n        <ng-container>\n          {{ data.code }}\n        </ng-container>\n      </td>\n\n      <!-- <td>\n        <ng-container>\n          {{ data.company }}\n        </ng-container>\n      </td> -->\n\n      <td>\n        <ng-container>\n          {{ data.name }} {{ data.surname }}\n        </ng-container>\n      </td>\n\n\n      <td>\n        <ng-container>\n            {{ data.time | date }}\n        </ng-container>\n      </td>\n      \n      <td>\n        <ng-container>\n          {{ data.totH }}\n        </ng-container>\n      </td>\n\n      <td>\n        <ng-container>\n          <nz-switch [nzDisabled]=true [ngModel]=\"data.marked\"></nz-switch>\n        </ng-container>\n      </td>\n\n      <!-- <td>\n        <div class=\"editable-row-operations\">\n          <ng-container>\n             <button nz-button (click)=\"startEdit(data.id)\">\n              <i nz-icon nzType=\"edit\"></i>\n            </button>\n            &nbsp;\n\n            <button nz-button nzType=\"danger\" (click)=\"deleteRow(data.code, data.time_enter)\">\n              <i nz-icon nzType=\"delete\"></i>\n            </button>\n             \n          </ng-container>\n          <ng-container *ngIf=\"editCache[data.id].edit\">\n            <button nz-button (click)=\"saveEdit(data.id)\">\n              <i nz-icon nzType=\"save\"></i>\n            </button>\n            &nbsp;\n            <button nz-button (click)=\"cancelEdit(data.id)\">\n              <i nz-icon nzType=\"rollback\"></i>\n            </button>\n          </ng-container>\n        </div>\n      </td> -->\n    </tr>\n  </tbody>\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/rfid/rfid.component.html":
/*!*********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/rfid/rfid.component.html ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-spin [nzSpinning]=\"isSpinning\">\n  <nz-card class=\"newCard\">\n    <nz-form-label>Selezionare il filtro</nz-form-label>\n    <div nz-row nzGutter=\"6\">\n\n      <div nz-col nzSpan=\"8\">\n        <nz-form-control>\n          <nz-select [(ngModel)]=\"selectedUser\" nzPlaceHolder=\"Selezionare il dipendente\">\n            <nz-option *ngFor=\"let u of usersData\" [nzValue]=\"u\" [nzLabel]=\"u.name + ' ' + u.surname\"></nz-option>\n          </nz-select>\n        </nz-form-control>\n      </div>\n\n      <div nz-col nzSpan=\"10\">\n        <nz-form-control>\n          <nz-month-picker [(ngModel)]=\"selectedMonth\" nzPlaceHolder=\"Seleziona il mese\" [disabled]=\"!selectedUser\">\n          </nz-month-picker>\n        </nz-form-control>\n      </div>\n\n       <div nz-col nzSpan=\"2\" class=\"no-print\">\n        <nz-form-control>\n          <button nz-button (click)=\"cancelFilter()\" [disabled]=\"!selectedUser || !selectedMonth\">\n            <i nz-icon nzType=\"reload\"></i>\n          </button>\n        </nz-form-control>\n      </div>\n\n      <div nz-col nzSpan=\"4\" class=\"no-print\">\n        <nz-form-control>\n          <button nz-button nzType=\"primary\" (click)=\"loadFilter()\" [disabled]=\"!selectedUser || !selectedMonth\">\n            <i nz-icon nzType=\"filter\"></i>Filtra\n          </button>\n        </nz-form-control>\n      </div>\n    </div>\n  </nz-card>\n</nz-spin>\n\n<nz-table #editRowTable [nzBordered]=\"true\" [nzData]=\"displayData\" [nzPageSize]=\"30\" [nzLoading]=\"isLoading\">\n  <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\n    <tr>\n      <th nzShowSort nzSortKey=\"code\" nzWidth=\"10%\">Codice</th>\n      <!-- <th nzShowSort nzSortKey=\"code\" nzWidth=\"10%\">Azienda</th> -->\n      <th nzShowSort nzSortKey=\"code\" nzWidth=\"25%\">Dipendente</th>\n      <th nzShowSort nzSortKey=\"time\" nzWidth=\"25%\">Ingresso</th>\n      <th nzShowSort nzSortKey=\"time\" nzWidth=\"20%\">Uscita</th>\n      <th nzShowSort nzSortKey=\"time\" nzWidth=\"10%\">Ore</th>\n      <th nzShowSort nzSortKey=\"time\" nzWidth=\"10%\">Mark</th>\n      <th>Azioni</th>\n    </tr>\n  </thead>\n\n  <tbody>\n    <tr *ngFor=\"let data of editRowTable.data\" [ngClass]=\"{active: editCache[data.id].edit}\">\n      <td>\n        <ng-container>\n          {{ data.code }}\n        </ng-container>\n      </td>\n\n      <!-- <td>\n        <ng-container>\n          {{ data.company }}\n        </ng-container>\n      </td> -->\n\n      <td>\n        <ng-container>\n          {{ data.name }} {{ data.surname }}\n        </ng-container>\n      </td>\n\n\n      <td>\n        <ng-container>\n          <span *ngIf=\"data.time_enter > 0\">\n            {{ data.time_enter | date:'medium' }}\n          </span>\n          <br><span style=\"font-size: 10px\">{{data.time_enter}}</span>\n        </ng-container>\n      </td>\n\n      <td>\n        <ng-container>\n          <span *ngIf=\"data.time_exit > 0\">\n            {{ data.time_exit | date:'medium' }}\n          </span>\n          <br><span *ngIf=\"data.time_exit > 0\" style=\"font-size: 10px\">{{data.time_exit}}</span>\n        </ng-container>\n      </td>\n\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{ g.diffTime (data.time_enter, data.time_exit) }}\n        </ng-container>\n      </td>\n\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          <nz-switch [nzDisabled]=true [ngModel]=\"data.marked\"></nz-switch>\n        </ng-container>\n      </td>\n\n      <td>\n        <div class=\"editable-row-operations\">\n          <ng-container>\n            <!-- <button nz-button (click)=\"startEdit(data.id)\">\n              <i nz-icon nzType=\"edit\"></i>\n            </button>\n            &nbsp; -->\n            <button nz-button nzType=\"danger\" (click)=\"deleteRow(data.code, data.time_enter)\">\n              <i nz-icon nzType=\"delete\"></i>\n            </button>\n          </ng-container>\n        </div>\n      </td>\n    </tr>\n  </tbody>\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/home/tempi/tempi.component.html":
/*!***********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/home/tempi/tempi.component.html ***!
  \***********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-spin [nzSpinning]=\"isSpinning\">\n  <nz-card class=\"newCard\">\n    <nz-form-label>Selezionare il filtro</nz-form-label>\n    <div nz-row nzGutter=\"6\">\n\n      <div nz-col nzSpan=\"6\">\n        <nz-form-control>\n          <nz-select [(ngModel)]=\"selectedCompany\" nzPlaceHolder=\"Selezionare l'azienda\">\n            <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\n          </nz-select>\n        </nz-form-control>\n      </div>\n\n      <div nz-col nzSpan=\"14\">\n        <nz-form-control>\n          <nz-month-picker [(ngModel)]=\"selectedMonth\" nzPlaceHolder=\"Seleziona il mese\" [disabled]=\"!selectedCompany\">\n          </nz-month-picker>\n        </nz-form-control>\n      </div>\n\n      <div nz-col nzSpan=\"4\" class=\"no-print\">\n        <nz-form-control>\n          <button nz-button nzType=\"primary\" (click)=\"loadTimes()\" [disabled]=\"!selectedCompany || !selectedMonth\">\n            <i nz-icon nzType=\"search\"></i>Cerca\n          </button>\n        </nz-form-control>\n      </div>\n    </div>\n  </nz-card>\n</nz-spin>\n\n<nz-collapse nzBordered=\"false\">\n  <nz-collapse-panel nzHeader=\"Inserisci una riga\" [(nzActive)]=\"insertActive\">\n    <nz-card style=\"padding-top: 20px\">\n      <div nz-row nzGutter=\"6\">\n        <div nz-col nzSpan=\"4\">\n          <nz-form-control>\n            <nz-select [(ngModel)]=\"insertCompany\" nzPlaceHolder=\"Seleziona l'azienda\"\n              (ngModelChange)=\"selectUsers(); selectOrders()\">\n              <nz-option *ngFor=\"let c of companyData\" [nzValue]=\"c\" [nzLabel]=\"c\"></nz-option>\n            </nz-select>\n          </nz-form-control>\n        </div>\n\n        <div nz-col nzSpan=\"5\">\n          <nz-form-control>\n            <nz-select [(ngModel)]=\"insertUser\" nzPlaceHolder=\"Seleziona il dipendente\" [disabled]=\"!insertCompany\">\n              <nz-option *ngFor=\"let u of usersData\" [nzValue]=\"u\" [nzLabel]=\"u.name + ' ' + u.surname\"></nz-option>\n            </nz-select>\n          </nz-form-control>\n        </div>\n\n        <div nz-col nzSpan=\"4\">\n          <nz-form-control>\n            <nz-date-picker [(ngModel)]=\"insertDay\" nzPlaceHolder=\"Seleziona il giorno\" [disabled]=\"!insertUser\">\n            </nz-date-picker>\n          </nz-form-control>\n        </div>\n\n        <div nz-col nzSpan=\"2\">\n          <nz-form-control>\n            <nz-input-number [nzMin]=\"0\" [nzMax]=\"9999\" [nzPlaceHolder]=\"'Ore'\" [(ngModel)]=\"insertHr\" [disabled]=\"!insertDay\"></nz-input-number>\n          </nz-form-control>\n        </div>\n\n        <div nz-col nzSpan=\"5\">\n          <nz-form-control>\n            <nz-select [(ngModel)]=\"insertOrder\" nzPlaceHolder=\"Seleziona l'ordine\" [disabled]=\"!insertDay\">\n              <nz-option *ngFor=\"let o of selectedOrders\" [nzValue]=\"o\" [nzLabel]=\"o.code + ' - ' + o.title\">\n              </nz-option>\n            </nz-select>\n          </nz-form-control>\n        </div>\n\n        <div nz-col nzSpan=\"4\" class=\"no-print\" style=\"text-align: right;\">\n          <nz-form-control>\n            <button nz-button nzType=\"primary\" (click)=\"saveLine()\"\n              [disabled]=\"!insertCompany || !insertUser || !insertDay || !insertHr || !insertOrder\">\n              <i nz-icon nzType=\"save\"></i>Inserisci\n            </button>\n          </nz-form-control>\n        </div>\n      </div>\n    </nz-card>\n  </nz-collapse-panel>\n</nz-collapse>\n\n<nz-table #editRowTable [nzBordered]=\"true\" [nzData]=\"displayData\" [nzPageSize]=\"30\" [nzLoading]=\"isLoading\">\n  <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\n    <tr>\n      <!-- <th nzShowSort nzSortKey=\"status\" nzWidth=\"12%\">ID</th> -->\n      <th nzShowSort nzSortKey=\"status\" nzWidth=\"12%\">Data</th>\n      <th nzShowSort nzSortKey=\"code\" nzWidth=\"12%\">Dipendente</th>\n      <th nzShowSort nzSortKey=\"name\" nzWidth=\"48%\">Ordine</th>\n      <th nzShowSort nzSortKey=\"company\" nzWidth=\"15%\">Ore</th>\n      <th>Azioni</th>\n    </tr>\n  </thead>\n\n  <tbody>\n    <tr *ngFor=\"let data of editRowTable.data\" [ngClass]=\"{active: editCache[data.id].edit}\">\n      <!-- <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{ data.id }}\n        </ng-container>\n      </td> -->\n      <td>\n        <div class=\"editable-cell\">\n          <div class=\"editable-cell-text-wrapper\">\n            <ng-container *ngIf=\"!editCache[data.id].edit\">\n              {{data.date | date: 'yyyy-MM-dd' }}\n            </ng-container>\n            <ng-container *ngIf=\"editCache[data.id].edit\">\n              <nz-date-picker [(ngModel)]=\"editCache[data.id].data.date\" [nzAllowClear]=false></nz-date-picker>\n            </ng-container>\n          </div>\n        </div>\n      </td>\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{ data.name }} {{ data.surname }}\n        </ng-container>\n      </td>\n      <td>\n        <ng-container *ngIf=\"!editCache[data.id].edit\">\n          {{ getOrder(data.orderId) }}\n        </ng-container>\n      </td>\n      <td>\n        <div class=\"editable-cell\">\n          <div class=\"editable-cell-text-wrapper\">\n            <ng-container *ngIf=\"!editCache[data.id].edit\">\n              {{data.h}}\n            </ng-container>\n            <ng-container *ngIf=\"editCache[data.id].edit\">\n              <input type=\"text\" nz-input [(ngModel)]=\"editCache[data.id].data.h\">\n            </ng-container>\n          </div>\n        </div>\n      </td>\n      <td>\n        <div class=\"editable-row-operations\">\n          <ng-container *ngIf=\"!editCache[data.id].edit\">\n            <button nz-button (click)=\"startEdit(data.id)\">\n              <i nz-icon nzType=\"edit\"></i>\n            </button>\n            &nbsp;\n            <button nz-button nzType=\"danger\" (click)=\"deleteRow(data.id)\">\n              <i nz-icon nzType=\"delete\"></i>\n            </button>\n          </ng-container>\n          <ng-container *ngIf=\"editCache[data.id].edit\">\n            <button nz-button (click)=\"saveEdit(data.id)\">\n              <i nz-icon nzType=\"save\"></i>\n            </button>\n            &nbsp;\n            <button nz-button (click)=\"cancelEdit(data.id)\">\n              <i nz-icon nzType=\"rollback\"></i>\n            </button>\n          </ng-container>\n        </div>\n      </td>\n    </tr>\n  </tbody>\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/login/login.component.html":
/*!******************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/login/login.component.html ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-layout>\n  <nz-header>\n    WebCheck - Amministrazione\n  </nz-header>\n  <nz-spin [nzSpinning]=\"isSpinning\">\n    <nz-content>\n        <div nz-row nzType=\"flex\" nzJustify=\"center\">\n          <div nz-col nzSpan=\"24\" class=\"loginCol\">\n            <br>\n            <br>\n            <nz-card class=\"loginCard\" nzTitle=\"Inserire il codice di accesso:\">\n              <nz-input-group nzSize=\"large\" nzPrefixIcon=\"anticon anticon-lock\" [nzSuffix]=\"loginButton\">\n                <input type=\"password\" value=\"password\" nz-input placeholder=\"Password\" [(ngModel)]=\"txtPassword\" maxlength=\"10\" autofocus>\n              </nz-input-group>\n\n              <ng-template #loginButton>\n                <button nz-button nzType=\"primary\" nzSize=\"large\" (click)=\"login()\" [disabled]=\"txtPassword.length < 5\" nzSearch>Login</button>\n              </ng-template>\n            </nz-card>\n          </div>\n        </div>\n    </nz-content>\n  </nz-spin>\n  <nz-footer style=\"text-align: center;\">{{g.footerTitle}}</nz-footer>\n</nz-layout>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/track/check/check.component.html":
/*!************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/track/check/check.component.html ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-header class=\"fixed-header\" [innerHTML]=\"g.trackTitle\"></nz-header>\n\n<nz-table #editRowTable [nzNoResult]=\"noResultTemplate\" [nzPageSize]=\"10\" nzBordered [nzData]=\"dataSet\" [nzLoading]=\"isLoading\">\n\n  <ng-template #noResultTemplate>\n    Nessun dato disponibile\n  </ng-template>\n\n  <thead>\n    <tr>\n      <th nzWidth=\"20%\">Data</th>\n      <th nzWidth=\"20%\">Codice</th>\n      <th nzWidth=\"50%\">Ordine</th>\n      <th nzWidth=\"10%\">Ore</th>\n    </tr>\n  </thead>\n\n  <tbody>\n    <tr *ngFor=\"let data of editRowTable.data\" class=\"big\">\n      <td>\n        {{data.date | date: 'yyyy-MM-dd'}}\n      </td>\n      <td>\n        {{data.code}}\n      </td>\n      <td>\n        {{data.title}}\n\n      </td>\n      <td>\n        {{data.h}}\n      </td>\n    </tr>\n  </tbody>\n</nz-table>\n\n<button nz-button nzType=\"normal\" class=\"back\" (click)=\"goOrders()\">\n  Torna agli ordini <i nz-icon nzType=\"logout\"></i>\n</button>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/track/insert/insert.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/track/insert/insert.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-header class=\"fixed-header\">\n  <div nz-row>\n    <div nz-col nzSpan=\"8\" style=\"color: #d4e4b6\">Stimato: {{totStimato | number}}</div>\n    <div nz-col nzSpan=\"8\">{{trackTitle}} | <i nz-icon nzType=\"calendar\"></i><b>{{ dateH | date:'dd/MM/yyyy' }}</b></div>\n    <div nz-col nzSpan=\"8\" style=\"color: #bbe66d\">Lavorato: {{totLavorato | number}}</div>\n  </div>\n</nz-header>\n\n<nz-table #editRowTable [nzNoResult]=\"noResultTemplate\" [nzSimple]=\"true\" [nzPageSize]=\"6\" nzBordered [nzData]=\"dataSet\" [nzLoading]=\"isLoading\">\n\n  <ng-template #noResultTemplate>\n    Nessun dato disponibile\n  </ng-template>\n\n  <thead>\n    <tr>\n      <!-- CODICE -->\n      <th nzWidth=\"14%\"></th>\n      <th nzWidth=\"13%\">Premio</th>\n      <!-- ORE -->\n      <th nzWidth=\"45%\"> <label>Inserisci le ore:</label></th>\n      <th nzWidth=\"10%\">-</th>\n      <th nzWidth=\"8%\">Ore</th>\n      <th nzWidth=\"10%\">+</th>\n    </tr>\n  </thead>\n\n  <tbody>\n    <tr *ngFor=\"let data of editRowTable.data\" class=\"big\">\n      <!-- CODICE -->\n      <td class=\"no-break\">\n        {{data.code}}\n      </td>\n      <!-- PREMIO -->\n      <td style=\"position: relative;\">\n        <ng-container *ngIf=\"data.prize == 1\">\n          <div class=\"premio-wrapper\">\n            <div class=\"premio-left\" style=\"border-right: 1px solid #606060;\">\n              <div style=\"font-size: 12px; height: 20%;line-height: 200%;\">STIMATO</div>\n              <div style=\"height: 80%\">{{data.forecast}}</div>\n            </div>\n            <div class=\"premio-right\">\n              <div style=\"font-size: 12px; height: 20%;line-height: 240%;\">REALE</div>\n              <div style=\"height: 80%\">{{ data.total}}</div>\n            </div>\n          </div>\n        </ng-container>\n      </td>\n      <!-- TITOLO -->\n      <td class=\"no-break\">\n        {{data.title}}\n      </td>\n      <td>\n        <button [disabled]=\"data.h === 0\" nzShape=\"circle\" nz-button (click)=\"setH(data.code, '-')\">-</button>\n      </td>\n      <td>\n        {{data.h}}\n      </td>\n      <td>\n        <button [disabled]=\"sumH >= totH\" nzShape=\"circle\" nz-button (click)=\"setH(data.code, '+')\">+</button>\n      </td>\n    </tr>\n  </tbody>\n</nz-table>\n\n<div class=\"save\">\n  <div class=\"col\">\n    <div>\n      <nz-switch style=\"margin-right: 30px;\" (click)=\"filterData()\" [(ngModel)]=\"prizeFilter\" nzCheckedChildren=\"Ordini con premi\" nzUnCheckedChildren=\"Tutti gli ordini\"></nz-switch>\n    </div>\n    <div class=\"col-wrapper\" [ngClass]=\"{'col-success': totH-sumH === 0}\">\n      <div class=\"col-label\">ORE DA ASSEGNARE</div>\n      <div class=\"col-val\">{{ totH - sumH }}</div>\n    </div>\n    <!-- <button [disabled]=\"sumH !== totH\" nz-button nzType=\"primary\" (click)=\"saveInsert()\">\n      Salva <i nz-icon nzType=\"logout\"></i>\n    </button> -->\n    <button *ngIf=\"sumH === totH\" nz-button nzType=\"primary\" (click)=\"saveInsert()\">\n      Salva <i nz-icon nzType=\"logout\"></i>\n    </button>\n    <button *ngIf=\"sumH !== totH\" nz-button (click)=\"router.navigateByUrl('/track/(trackContent:utente)')\">\n      Annulla <i nz-icon nzType=\"rollback-o\"></i>\n    </button>\n  </div>\n\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/track/ordine/ordine.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/track/ordine/ordine.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-header class=\"fixed-header\" [innerHTML]=\"g.trackTitle\"></nz-header>\n\n<nz-table #editRowTable [nzNoResult]=\"noResultTemplate\" [nzPageSize]=\"5\" nzBordered [nzData]=\"dataSet\" [nzLoading]=\"isLoading\">\n\n  <ng-template #noResultTemplate>\n    Nessun dato disponibile\n  </ng-template>\n\n  <thead>\n    <tr>\n      <th nzWidth=\"20%\">\n        <label>Seleziona un ordine:</label>\n      </th>\n      <th nzWidth=\"50%\"></th>\n      <th nzWidth=\"20%\">Data</th>\n      <th nzWidth=\"10%\">Ore</th>\n    </tr>\n  </thead>\n\n  <tbody>\n    <tr *ngFor=\"let data of editRowTable.data\" class=\"big\" (click)=\"selectRow(data.id)\">\n      <td>\n        {{data.code}}\n      </td>\n      <td>\n        {{data.title}}\n      </td>\n      <td>\n        {{data.date  | date: 'yyyy-MM-dd'}}\n      </td>\n      <td>\n        {{data.h}}\n      </td>\n    </tr>\n  </tbody>\n</nz-table>\n\n<button nz-button nzType=\"normal\" class=\"check\" (click)=\"gocheck()\">\n    Ultimi inserimenti <i nz-icon nzType=\"logout\"></i>\n  </button>\n\n<button nz-button nzType=\"danger\" class=\"back\" (click)=\"goback()\">\n  Fine <i nz-icon nzType=\"logout\"></i>\n</button>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/track/tempo/tempo.component.html":
/*!************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/track/tempo/tempo.component.html ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-header class=\"fixed-header\" [innerHTML]=\"g.trackTitle\"></nz-header>\n\n<div nz-row nzType=\"flex\" nz-row nzType=\"flex\" nzJustify=\"space-around\" nzAlign=\"top\">\n  <div nz-col nzSpan=\"8\">\n    <div nz-row>\n      <div nz-col nzSpan=\"24\">\n        <input [disabled]=\"true\" type=\"text\" nz-input class=\"dateField\" [(ngModel)]=\"dateString\" placeholder=\"0\">\n      </div>\n    </div>\n    <div nz-row></div>\n    <button nz-button (click)=\"changeDate(-1)\">\n        <i nz-icon nzType=\"caret-left\"></i>\n      </button>\n      <button nz-button (click)=\"todayDate()\">\n        <i nz-icon nzType=\"calendar\"></i>\n      </button>\n      <button nz-button (click)=\"changeDate(1)\">\n          <i nz-icon nzType=\"caret-right\"></i>\n        </button>\n  </div>\n  <div nz-col nzSpan=\"10\">\n    <div nz-row>\n      <div nz-col nzSpan=\"24\">\n        <input [disabled]=\"true\" type=\"text\" nz-input class=\"text-center\" [ngClass]=\"{'input-red': numH === '0'}\" [(ngModel)]=\"numH\" placeholder=\"0\">\n      </div>\n    </div>\n    <div nz-row>\n      <div nz-col nzSpan=\"24\">\n        <button nzShape=\"circle\" (click)=\"addNumber('7')\" nz-button>7</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('8')\" nz-button>8</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('9')\" nz-button>9</button>\n      </div>\n    </div>\n    <div nz-row>\n      <div nz-col nzSpan=\"24\">\n        <button nzShape=\"circle\" (click)=\"addNumber('4')\" nz-button>4</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('5')\" nz-button>5</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('6')\" nz-button>6</button>\n      </div>\n    </div>\n    <div nz-row>\n      <div nz-col nzSpan=\"24\">\n        <button nzShape=\"circle\" (click)=\"addNumber('1')\" nz-button>1</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('2')\" nz-button>2</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('3')\" nz-button>3</button>\n      </div>\n    </div>\n    <div nz-row>\n      <div nz-col nzSpan=\"24\">\n        <button nz-button (click)=\"addNumber('0')\">0</button>\n        <button nz-button (click)=\"addNumber('.')\">.</button>\n        <button nz-button (click)=\"clearNumber()\" [disabled]=\"numH === '0'\">\n          <i nz-icon nzType=\"close\"></i>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div nz-col nzSpan=\"6\" class=\"col-right\">\n    <button nz-button nzShape=\"circle\" [disabled]=\"numH === '0'\" [hidden]=\"numH === '0'\" class=\"btnAdd\" (click)=\"addH()\">\n      <i nz-icon nzType=\"plus-square-o\"></i>\n    </button>\n    <button nz-button nzShape=\"circle\" [disabled]=\"numH != '0'\" [hidden]=\"numH != '0'\" class=\"'b'tnRemove\" (click)=\"removeH()\">\n      <i nz-icon nzType=\"minus-square-o\"></i>\n    </button>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/track/track.component.html":
/*!******************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/track/track.component.html ***!
  \******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-layout>\n  <nz-layout>\n    <nz-content class=\"content\">\n      <router-outlet name=\"trackContent\">\n      </router-outlet>\n    </nz-content>\n    <nz-footer style=\"text-align: center;\">{{g.footerTitle}}</nz-footer>\n  </nz-layout>\n</nz-layout>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/track/utente/utente.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/track/utente/utente.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-header class=\"fixed-header\" [innerHTML]=\"g.trackTitle\"></nz-header>\n\n<nz-layout>\n  <nz-content>\n    <div class=\"fix-left\">\n      <nz-input-group [nzAddOnAfterIcon]=\"'idcard'\">\n        <input nz-input placeholder=\"Rfid\" [(ngModel)]=\"rfid\" [disabled]=\"true\" />\n      </nz-input-group>\n    </div>\n\n    <div nz-row class=\"keypad-input\">\n      <div nz-col nzSpan=\"12\" nzOffset=\"6\">\n        <input [disabled]=\"true\" type=\"text\" nz-input class=\"text-center\" [(ngModel)]=\"code\" placeholder=\"- - - - -\">\n      </div>\n    </div>\n    <div nz-row>\n      <div nz-col nzSpan=\"12\" nzOffset=\"6\">\n        <button nzShape=\"circle\" (click)=\"addNumber('7')\" nz-button>7</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('8')\" nz-button>8</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('9')\" nz-button>9</button>\n      </div>\n    </div>\n    <div nz-row>\n      <div nz-col nzSpan=\"12\" nzOffset=\"6\">\n        <button nzShape=\"circle\" (click)=\"addNumber('4')\" nz-button>4</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('5')\" nz-button>5</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('6')\" nz-button>6</button>\n      </div>\n    </div>\n    <div nz-row>\n      <div nz-col nzSpan=\"12\" nzOffset=\"6\">\n        <button nzShape=\"circle\" (click)=\"addNumber('1')\" nz-button>1</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('2')\" nz-button>2</button>\n        <button nzShape=\"circle\" (click)=\"addNumber('3')\" nz-button>3</button>\n      </div>\n    </div>\n    <div nz-row>\n      <div nz-col nzSpan=\"12\" nzOffset=\"6\">\n        <button nz-button (click)=\"addNumber('0')\" class=\"double\">0</button>\n        <button nz-button (click)=\"delNumber()\" [disabled]=\"code.length < 1\">\n          <i nz-icon nzType=\"left\"></i>\n        </button>\n      </div>\n    </div>\n    <div class=\"fix-right\">\n      <button nz-button nzShape=\"circle\" [disabled]=\"code.length < 5\" (click)=\"loginUtente()\">\n        <i nz-icon nzType=\"play-circle-o\"></i>\n      </button>\n    </div>\n\n    <div class=\"message messageIngresso noselect\" [ngClass]=\"showIngresso ? 'messageIn' : 'messageOut'\">\n      <p><u>{{ this.g.userData.name }} {{ this.g.userData.surname }}</u></p>\n      <p>INGRESSO REGISTRATO</p>\n    </div>\n    <!--  -->\n    <div class=\"message messageUscita noselect\" [ngClass]=\"showUscita ? 'messageIn' : 'messageOut'\"> \n      <p><u>{{ this.g.userData.name }} {{ this.g.userData.surname }}</u></p>\n      <p>USCITA REGISTRATA</p>\n      <div class=\"button-line\">\n        <button nz-button (click)=\"continue()\"><i nz-icon nzType=\"rollback-o\"></i>SALVA</button>\n        <button nz-button (click)=\"edit()\" style=\"background-color: #e9b90e;\" (click)=\"delNumber()\"><i nz-icon nzType=\"edit-o\"></i>ASSEGNA ORE: {{totAllHrs}}</button>\n      </div>\n    </div>\n  </nz-content>\n</nz-layout>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/$$_lazy_route_resource lazy recursive":
/*!**********************************************************!*\
  !*** ./src/$$_lazy_route_resource lazy namespace object ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep {\n  text-align: center;\n}\n:host ::ng-deep .ant-layout-header,\n:host ::ng-deep .ant-layout-footer {\n  color: #fff;\n}\n:host ::ng-deep .ant-layout-header {\n  font-size: 30px;\n  line-height: 68px;\n  color: #fff;\n  font-family: Roboto;\n  height: 68px;\n}\n:host ::ng-deep .ant-layout-footer {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  padding: 5px;\n  font-size: 10px;\n}\n:host ::ng-deep .ant-layout-footer {\n  line-height: 1.5;\n}\n:host ::ng-deep .ant-layout-sider {\n  color: #fff;\n  line-height: 120px;\n}\n:host ::ng-deep .ant-layout-content {\n  color: #fff;\n  min-height: 120px;\n  line-height: 2em;\n}\n:host ::ng-deep .ant-layout {\n  margin-bottom: 48px;\n}\n:host ::ng-deep .ant-layout:last-child {\n  margin: 0;\n}\n:host ::ng-deep .ant-layout {\n  min-height: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() {
        this.title = 'app';
    }
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: appRoutes, AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appRoutes", function() { return appRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_common_locales_it__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/common/locales/it */ "./node_modules/@angular/common/locales/it.js");
/* harmony import */ var _angular_common_locales_it__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_angular_common_locales_it__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../environments/global */ "./src/environments/global.ts");
/* harmony import */ var _login_login_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../login/login.component */ "./src/login/login.component.ts");
/* harmony import */ var _home_home_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../home/home.component */ "./src/home/home.component.ts");
/* harmony import */ var _home_tempi_tempi_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../home/tempi/tempi.component */ "./src/home/tempi/tempi.component.ts");
/* harmony import */ var _home_dipendenti_dipendenti_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../home/dipendenti/dipendenti.component */ "./src/home/dipendenti/dipendenti.component.ts");
/* harmony import */ var _home_dipendenti_report_dipendenti_report__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../home/dipendenti-report/dipendenti.report */ "./src/home/dipendenti-report/dipendenti.report.ts");
/* harmony import */ var _home_ordini_ordini_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../home/ordini/ordini.component */ "./src/home/ordini/ordini.component.ts");
/* harmony import */ var _home_ordini_report_ordini_report__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../home/ordini-report/ordini.report */ "./src/home/ordini-report/ordini.report.ts");
/* harmony import */ var _home_incidenze_report_incidenze_report__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../home/incidenze-report/incidenze.report */ "./src/home/incidenze-report/incidenze.report.ts");
/* harmony import */ var _home_mese_report_mese_report__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../home/mese-report/mese-report */ "./src/home/mese-report/mese-report.ts");
/* harmony import */ var _home_premi_report_premi_report__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../home/premi-report/premi-report */ "./src/home/premi-report/premi-report.ts");
/* harmony import */ var _home_excel_report_excel_report__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../home/excel-report/excel-report */ "./src/home/excel-report/excel-report.ts");
/* harmony import */ var _home_rfid_rfid_component__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../home/rfid/rfid.component */ "./src/home/rfid/rfid.component.ts");
/* harmony import */ var _home_rfid_gg_rfid_gg_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../home/rfid-gg/rfid-gg.component */ "./src/home/rfid-gg/rfid-gg.component.ts");
/* harmony import */ var _track_track_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../track/track.component */ "./src/track/track.component.ts");
/* harmony import */ var _track_utente_utente_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../track/utente/utente.component */ "./src/track/utente/utente.component.ts");
/* harmony import */ var _track_ordine_ordine_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../track/ordine/ordine.component */ "./src/track/ordine/ordine.component.ts");
/* harmony import */ var _track_tempo_tempo_component__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../track/tempo/tempo.component */ "./src/track/tempo/tempo.component.ts");
/* harmony import */ var _track_check_check_component__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../track/check/check.component */ "./src/track/check/check.component.ts");
/* harmony import */ var _track_insert_insert_component__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../track/insert/insert.component */ "./src/track/insert/insert.component.ts");










Object(_angular_common__WEBPACK_IMPORTED_MODULE_8__["registerLocaleData"])(_angular_common_locales_it__WEBPACK_IMPORTED_MODULE_9___default.a);
// ## PITPES
// import { SqrtPipe } from './app.sqrt';
// ## PROVIDERS


// ## COMPONENTS

// ## COMPONENTS HOME












// ## COMPONENTS TRACK






const appRoutes = [
    { path: "", redirectTo: "track", pathMatch: "full" },
    { path: "admin", component: _login_login_component__WEBPACK_IMPORTED_MODULE_12__["LoginComponent"] },
    {
        path: "home",
        component: _home_home_component__WEBPACK_IMPORTED_MODULE_13__["HomeComponent"],
        children: [
            { path: "tempi", component: _home_tempi_tempi_component__WEBPACK_IMPORTED_MODULE_14__["TempiComponent"], outlet: "homeContent" },
            {
                path: "dipendenti",
                component: _home_dipendenti_dipendenti_component__WEBPACK_IMPORTED_MODULE_15__["DipendentiComponent"],
                outlet: "homeContent",
            },
            {
                path: "dipendenti.report",
                component: _home_dipendenti_report_dipendenti_report__WEBPACK_IMPORTED_MODULE_16__["DipendentiReportComponent"],
                outlet: "homeContent",
            },
            {
                path: "ordini",
                component: _home_ordini_ordini_component__WEBPACK_IMPORTED_MODULE_17__["OrdiniComponent"],
                outlet: "homeContent"
            },
            {
                path: "ordini.report",
                component: _home_ordini_report_ordini_report__WEBPACK_IMPORTED_MODULE_18__["OrdiniReportComponent"],
                outlet: "homeContent",
            },
            {
                path: "incidenze.report",
                component: _home_incidenze_report_incidenze_report__WEBPACK_IMPORTED_MODULE_19__["IncidenzeReportComponent"],
                outlet: "homeContent",
            },
            {
                path: "mese.report",
                component: _home_mese_report_mese_report__WEBPACK_IMPORTED_MODULE_20__["MeseReportComponent"],
                outlet: "homeContent",
            },
            {
                path: "premi.report",
                component: _home_premi_report_premi_report__WEBPACK_IMPORTED_MODULE_21__["PremiReportComponent"],
                outlet: "homeContent",
            },
            {
                path: "excel.report",
                component: _home_excel_report_excel_report__WEBPACK_IMPORTED_MODULE_22__["ExcelReportComponent"],
                outlet: "homeContent",
            },
            { path: "rfid", component: _home_rfid_rfid_component__WEBPACK_IMPORTED_MODULE_23__["RfidComponent"], outlet: "homeContent" },
            { path: "rfid-gg", component: _home_rfid_gg_rfid_gg_component__WEBPACK_IMPORTED_MODULE_24__["RfidGgComponent"], outlet: "homeContent" },
        ],
    },
    {
        path: "track",
        component: _track_track_component__WEBPACK_IMPORTED_MODULE_25__["TrackComponent"],
        children: [
            { path: "utente", component: _track_utente_utente_component__WEBPACK_IMPORTED_MODULE_26__["UtenteComponent"], outlet: "trackContent" },
            { path: "ordine", component: _track_ordine_ordine_component__WEBPACK_IMPORTED_MODULE_27__["OrdineComponent"], outlet: "trackContent" },
            { path: "tempo", component: _track_tempo_tempo_component__WEBPACK_IMPORTED_MODULE_28__["TempoComponent"], outlet: "trackContent" },
            { path: "check", component: _track_check_check_component__WEBPACK_IMPORTED_MODULE_29__["CheckComponent"], outlet: "trackContent" },
            { path: "insert", component: _track_insert_insert_component__WEBPACK_IMPORTED_MODULE_30__["InsertComponent"], outlet: "trackContent" },
        ],
    },
];
let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_10__["AppComponent"],
            _login_login_component__WEBPACK_IMPORTED_MODULE_12__["LoginComponent"],
            // HOME
            _home_home_component__WEBPACK_IMPORTED_MODULE_13__["HomeComponent"],
            _home_dipendenti_dipendenti_component__WEBPACK_IMPORTED_MODULE_15__["DipendentiComponent"],
            _home_ordini_ordini_component__WEBPACK_IMPORTED_MODULE_17__["OrdiniComponent"],
            _home_tempi_tempi_component__WEBPACK_IMPORTED_MODULE_14__["TempiComponent"],
            _home_dipendenti_report_dipendenti_report__WEBPACK_IMPORTED_MODULE_16__["DipendentiReportComponent"],
            _home_ordini_report_ordini_report__WEBPACK_IMPORTED_MODULE_18__["OrdiniReportComponent"],
            _home_incidenze_report_incidenze_report__WEBPACK_IMPORTED_MODULE_19__["IncidenzeReportComponent"],
            _home_mese_report_mese_report__WEBPACK_IMPORTED_MODULE_20__["MeseReportComponent"],
            _home_excel_report_excel_report__WEBPACK_IMPORTED_MODULE_22__["ExcelReportComponent"],
            _home_premi_report_premi_report__WEBPACK_IMPORTED_MODULE_21__["PremiReportComponent"],
            _home_rfid_rfid_component__WEBPACK_IMPORTED_MODULE_23__["RfidComponent"],
            _home_rfid_gg_rfid_gg_component__WEBPACK_IMPORTED_MODULE_24__["RfidGgComponent"],
            // TRACK
            _track_track_component__WEBPACK_IMPORTED_MODULE_25__["TrackComponent"],
            _track_utente_utente_component__WEBPACK_IMPORTED_MODULE_26__["UtenteComponent"],
            _track_ordine_ordine_component__WEBPACK_IMPORTED_MODULE_27__["OrdineComponent"],
            _track_tempo_tempo_component__WEBPACK_IMPORTED_MODULE_28__["TempoComponent"],
            _track_check_check_component__WEBPACK_IMPORTED_MODULE_29__["CheckComponent"],
            _track_insert_insert_component__WEBPACK_IMPORTED_MODULE_30__["InsertComponent"],
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_4__["BrowserAnimationsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClientModule"],
            ng_zorro_antd__WEBPACK_IMPORTED_MODULE_7__["NgZorroAntdModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_3__["RouterModule"].forRoot(appRoutes, { enableTracing: false } // <-- debugging purposes only
            ),
        ],
        providers: [
            _environments_global__WEBPACK_IMPORTED_MODULE_11__["GlobalComponent"],
            { provide: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_7__["NZ_I18N"], useValue: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_7__["it_IT"] },
            { provide: _angular_core__WEBPACK_IMPORTED_MODULE_2__["LOCALE_ID"], useValue: "it" },
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_10__["AppComponent"]],
    })
], AppModule);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/environments/global.ts":
/*!************************************!*\
  !*** ./src/environments/global.ts ***!
  \************************************/
/*! exports provided: Aziende, GlobalComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Aziende", function() { return Aziende; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalComponent", function() { return GlobalComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");



const Aziende = ["Meneghetti"];
// ##############################################
// CLASS
let GlobalComponent = class GlobalComponent {
    constructor(http) {
        this.http = http;
        this.userData = {};
        this.nodeServer = "https://nodecheck.emsoft.it/";
        this.trackTitle = "WebCheck";
        this.footerTitle = "WebCheck v26.02.04 - ©2026 Meneghetti Mobili S.r.l.";
        this.menuState = 0;
        this.normalTime = 10000;
        this.fastTime = 3000;
    }
    // ################################################
    // ASK TOKEN
    login() {
        return this.http.post(this.nodeServer + "login", this.userLogin);
    }
    // ################################################
    // ASK ID
    loginUtente(code, rfid) {
        console.log("LOGIN UTENTE");
        return this.http.post(this.nodeServer + "loginUtente", {
            code: code,
            rfid: rfid,
        });
    }
    // ################################################
    // SEND PREMI
    sendPremi(destinatari, premi, dal, al, totale) {
        return this.http.post(this.nodeServer + "sendPremi", {
            destinatari: destinatari,
            premi: premi,
            dal: dal,
            al: al,
            totale: totale,
        });
    }
    // ################################################
    // CHECK LOGIN
    checkLogin() {
        if (typeof this.userLogin === "undefined") {
            this.getLogin();
        }
        if (this.userLogin.logged === true) {
            return true;
        }
        else {
            return false;
        }
    }
    getLogin() {
        const value = sessionStorage.getItem("webcheck");
        if (value) {
            this.userLogin = JSON.parse(value);
        }
        else {
            this.userLogin = { logged: false };
        }
    }
    // ################################################
    // CHECK UTENTE
    checkUserData() {
        if (typeof this.userData === "undefined") {
            return false;
        }
        else {
            return true;
        }
    }
    // ################################################
    // MY SQL
    mysql(query) {
        const obj = {
            query: query,
        };
        return this.http.post(this.nodeServer + "mysql", obj);
    }
    // ################################################
    // NUMBER LIMIT
    numberLimit(e, n) {
        const t = e.target;
        if (e.key !== "Backspace" && e.key !== "Tab") {
            if (Number.isNaN(Number(e.key)) || t.value.length === n) {
                e.preventDefault();
            }
            else if (t.value.length > n) {
                t.value = t.value.substring(0, n);
            }
        }
    }
    // ################################################
    // KEY LIMIT
    keyLimit(e, n) {
        const t = e.target;
        if (e.key !== "Backspace" && e.key !== "Tab") {
            if (t.value.length === n) {
                e.preventDefault();
            }
            else if (t.value.length > n) {
                t.value = t.value.substring(0, n);
            }
        }
    }
    // ################################################
    // DIFF TIME
    /*diffTime(timeEnter: number, timeExit: number) {
          const backEnter = timeEnter;
          const backExit = timeExit;
          if (timeExit === 0) {
              return 0;
          }
  
          // ENTER ROUND < 3 = 0 | < 33 = 30 | >= 33 = +1h
          let dateTime = new Date(timeEnter);
          let m = dateTime.getMinutes();
          if (m < 3) {
              dateTime.setMinutes(0, 0, 0);
          } else if (m < 33) {
              dateTime.setMinutes(30, 0, 0);
          } else {
              dateTime.setMinutes(0, 0, 0);
              dateTime.setHours(dateTime.getHours() + 1);
          }
          timeEnter = dateTime.getTime();
  
          // EXIT ROUND >= 55 = +1h | >= 25 = 30 | < 25 = 0
          dateTime = new Date(timeExit);
          m = dateTime.getMinutes();
          if (m >= 55) {
              dateTime.setMinutes(0, 0, 0);
              dateTime.setHours(dateTime.getHours() + 1);
          } else if (m >= 25) {
              dateTime.setMinutes(30, 0, 0);
          } else {
              dateTime.setMinutes(0, 0, 0);
          }
          timeExit = dateTime.getTime();
  
          if (backEnter === 1587621369743) {
              console.log("CHECK IN: " + m, backEnter, timeEnter, new Date(timeEnter));
              console.log("CHECK OUT: " + m, backExit, timeExit, new Date(timeExit));
          }
          return Math.round((Math.abs(timeExit - timeEnter) / 36e5) * 100) / 100;
      }*/
    diffTime(timeEnter, timeExit) {
        if (!timeExit || timeExit <= 0 || !timeEnter)
            return 0;
        // differenza pura in ore
        const diffHours = Math.max(0, (timeExit - timeEnter) / 36e5);
        // arrotonda verso il basso a step di mezz'ora (0.5h)
        const floored = Math.floor(diffHours * 2) / 2;
        return Math.round(floored * 100) / 100;
    }
    diffTimeRaw(timeEnter, timeExit) {
        if (!timeExit || timeExit <= 0 || !timeEnter)
            return 0;
        return Math.max(0, (timeExit - timeEnter) / 36e5);
    }
    roundToHalfDown(hours) {
        if (!hours || hours <= 0)
            return 0;
        const floored = Math.floor(hours * 2) / 2;
        return Math.round(floored * 100) / 100;
    }
};
GlobalComponent.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
GlobalComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], GlobalComponent);



/***/ }),

/***/ "./src/home/dipendenti-report/dipendenti.report.scss":
/*!***********************************************************!*\
  !*** ./src/home/dipendenti-report/dipendenti.report.scss ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-select, :host ::ng-deep .ant-btn, :host ::ng-deep .ant-calendar-picker {\n  width: 100%;\n}\n:host ::ng-deep .ant-table-row, :host ::ng-deep .ant-table-row:hover {\n  background-color: #fff;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ob21lL2RpcGVuZGVudGktcmVwb3J0L0M6XFxVc2Vyc1xcU291cmNlc1xcV2ViQ2hlY2tcXHdlYmNoZWNrLmVtc29mdC5pdC9zcmNcXGhvbWVcXGRpcGVuZGVudGktcmVwb3J0XFxkaXBlbmRlbnRpLnJlcG9ydC5zY3NzIiwic3JjL2hvbWUvZGlwZW5kZW50aS1yZXBvcnQvZGlwZW5kZW50aS5yZXBvcnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDRTtFQUNFLFdBQUE7QUNBSjtBREVFO0VBQ0Usc0JBQUE7QUNBSiIsImZpbGUiOiJzcmMvaG9tZS9kaXBlbmRlbnRpLXJlcG9ydC9kaXBlbmRlbnRpLnJlcG9ydC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3QgOjpuZy1kZWVwIHtcbiAgLmFudC1zZWxlY3QsIC5hbnQtYnRuLCAuYW50LWNhbGVuZGFyLXBpY2tlciB7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbiAgLmFudC10YWJsZS1yb3csIC5hbnQtdGFibGUtcm93OmhvdmVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmO1xuICB9XG59XG4iLCI6aG9zdCA6Om5nLWRlZXAgLmFudC1zZWxlY3QsIDpob3N0IDo6bmctZGVlcCAuYW50LWJ0biwgOmhvc3QgOjpuZy1kZWVwIC5hbnQtY2FsZW5kYXItcGlja2VyIHtcbiAgd2lkdGg6IDEwMCU7XG59XG46aG9zdCA6Om5nLWRlZXAgLmFudC10YWJsZS1yb3csIDpob3N0IDo6bmctZGVlcCAuYW50LXRhYmxlLXJvdzpob3ZlciB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG59Il19 */");

/***/ }),

/***/ "./src/home/dipendenti-report/dipendenti.report.ts":
/*!*********************************************************!*\
  !*** ./src/home/dipendenti-report/dipendenti.report.ts ***!
  \*********************************************************/
/*! exports provided: DipendentiReportComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DipendentiReportComponent", function() { return DipendentiReportComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let DipendentiReportComponent = class DipendentiReportComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(g, datepipe, notification) {
        this.g = g;
        this.datepipe = datepipe;
        this.notification = notification;
        // TABLE VARS
        this.timesData = [];
        this.displayData = [...this.timesData];
        this.usersData = [];
        this.ordersData = [];
        this.editCache = {};
        this.sortName = null;
        this.sortValue = null;
        // COMPONNET VARS
        this.companyData = _environments_global__WEBPACK_IMPORTED_MODULE_4__["Aziende"];
        this.isSpinning = false;
        this.isLoading = false;
        this.selectedUsers = [];
        this.rangePlace = ["Da data", "A Data"];
        this.dateFormat = "dd/MM/yyyy";
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
        this.loadData();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 8;
        this.g.homeTitle = "Report Dipendenti";
    }
    loadData() {
        this.isSpinning = true;
        const query = "SELECT * from chk_users";
        this.g.mysql(query).subscribe((res) => {
            this.usersData = res.data;
            const currDate = new Date();
            const prevDate = new Date(currDate.getFullYear(), currDate.getMonth(), 1);
            // prevDate.setMonth(currDate.getMonth() - 1);
            this.rangeDate = new Array(prevDate, currDate);
            this.isSpinning = false;
        }, (error) => {
            this.isSpinning = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: 0 });
        });
    }
    selectUsers() {
        this.selectedUsers = this.usersData.filter((u) => u.company === this.selectedCompany);
        this.selectedUser = null;
    }
    loadTimes() {
        this.isLoading = true;
        // tslint:disable-next-line:max-line-length
        const query = "SELECT chk_times.id, chk_times.date, chk_times.userId, chk_times.orderId, chk_times.h, chk_orders.id, chk_orders.code, chk_orders.title, chk_orders.forecast, chk_orders.company, chk_orders.status, chk_orders.total, chk_orders.prize, chk_orders.costH, chk_orders.costM, chk_orders.costMReal, chk_orders.date as data FROM chk_times left JOIN chk_orders ON chk_orders.id = chk_times.orderId" +
            " WHERE `userId`=" +
            this.selectedUser.id +
            ' AND chk_times.date >= "' +
            this.datepipe.transform(this.rangeDate[0], "yyyy-MM-dd") +
            '"' +
            ' AND chk_times.date <= "' +
            this.datepipe.transform(this.rangeDate[1], "yyyy-MM-dd") +
            '"' +
            " ORDER BY chk_times.date";
        console.log(query);
        return this.g.mysql(query).subscribe((res) => {
            console.log(res);
            this.isLoading = false;
            this.timesData = res.data;
            this.displayData = [...this.timesData];
            let n = 0;
            res.data.forEach((t) => {
                n += t.h;
            });
            this.currentTotale = n > 0 ? "Totale ore: " + n : "";
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: this.g.normalTime });
        });
    }
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        if (this.sortName) {
            this.displayData = [
                ...this.timesData.sort((a, b) => this.sortValue === "ascend"
                    ? a[this.sortName] > b[this.sortName]
                        ? 1
                        : -1
                    : b[this.sortName] > a[this.sortName]
                        ? 1
                        : -1),
            ];
        }
        else {
            this.displayData = [...this.timesData];
        }
    }
    getUser(userId) {
        const res = this.usersData.find((u) => u.id === userId);
        if (res) {
            return res.name;
        }
        else {
            return "(non trovato)";
        }
    }
};
DipendentiReportComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzNotificationService"] }
];
DipendentiReportComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-dipendenti-report",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dipendenti.report.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/dipendenti-report/dipendenti.report.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dipendenti.report.scss */ "./src/home/dipendenti-report/dipendenti.report.scss")).default]
    })
], DipendentiReportComponent);



/***/ }),

/***/ "./src/home/dipendenti/dipendenti.component.scss":
/*!*******************************************************!*\
  !*** ./src/home/dipendenti/dipendenti.component.scss ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-table {\n  padding-top: 60px;\n}\n:host ::ng-deep .ant-pagination {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n}\n:host ::ng-deep .ant-input-number,\n:host ::ng-deep .ant-select {\n  width: 100% !important;\n}\n:host ::ng-deep .ant-card-body {\n  padding-top: 10px;\n}\n:host ::ng-deep .newCard button {\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ob21lL2RpcGVuZGVudGkvQzpcXFVzZXJzXFxTb3VyY2VzXFxXZWJDaGVja1xcd2ViY2hlY2suZW1zb2Z0Lml0L3NyY1xcaG9tZVxcZGlwZW5kZW50aVxcZGlwZW5kZW50aS5jb21wb25lbnQuc2NzcyIsInNyYy9ob21lL2RpcGVuZGVudGkvZGlwZW5kZW50aS5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFRTtFQUNFLGlCQUFBO0FDREo7QURHRTtFQUNFLGtCQUFBO0VBQ0EsUUFBQTtFQUNBLFVBQUE7QUNESjtBREdFOztFQUVFLHNCQUFBO0FDREo7QURHRTtFQUNFLGlCQUFBO0FDREo7QURHRTtFQUNFLFdBQUE7QUNESiIsImZpbGUiOiJzcmMvaG9tZS9kaXBlbmRlbnRpL2RpcGVuZGVudGkuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBjb21wb25lbnQgY3NzIGdvZXMgaGVyZVxuOmhvc3QgOjpuZy1kZWVwIHtcbiAgLmFudC10YWJsZSB7XG4gICAgcGFkZGluZy10b3A6IDYwcHg7XG4gIH1cbiAgLmFudC1wYWdpbmF0aW9uIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiAwcHg7XG4gICAgcmlnaHQ6IDBweDtcbiAgfVxuICAuYW50LWlucHV0LW51bWJlcixcbiAgLmFudC1zZWxlY3Qge1xuICAgIHdpZHRoOiAxMDAlICFpbXBvcnRhbnQ7XG4gIH1cbiAgLmFudC1jYXJkLWJvZHkge1xuICAgIHBhZGRpbmctdG9wOiAxMHB4O1xuICB9XG4gIC5uZXdDYXJkIGJ1dHRvbiB7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbn1cbiIsIjpob3N0IDo6bmctZGVlcCAuYW50LXRhYmxlIHtcbiAgcGFkZGluZy10b3A6IDYwcHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLmFudC1wYWdpbmF0aW9uIHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDBweDtcbiAgcmlnaHQ6IDBweDtcbn1cbjpob3N0IDo6bmctZGVlcCAuYW50LWlucHV0LW51bWJlcixcbjpob3N0IDo6bmctZGVlcCAuYW50LXNlbGVjdCB7XG4gIHdpZHRoOiAxMDAlICFpbXBvcnRhbnQ7XG59XG46aG9zdCA6Om5nLWRlZXAgLmFudC1jYXJkLWJvZHkge1xuICBwYWRkaW5nLXRvcDogMTBweDtcbn1cbjpob3N0IDo6bmctZGVlcCAubmV3Q2FyZCBidXR0b24ge1xuICB3aWR0aDogMTAwJTtcbn0iXX0= */");

/***/ }),

/***/ "./src/home/dipendenti/dipendenti.component.ts":
/*!*****************************************************!*\
  !*** ./src/home/dipendenti/dipendenti.component.ts ***!
  \*****************************************************/
/*! exports provided: DipendentiComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DipendentiComponent", function() { return DipendentiComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");




let DipendentiComponent = class DipendentiComponent {
    constructor(g, notification, message) {
        this.g = g;
        this.notification = notification;
        this.message = message;
        // TABLE VARS
        this.dataSet = [];
        this.displayData = [...this.dataSet];
        this.editCache = {};
        this.sortName = null;
        this.sortValue = null;
        // COMPONENT VARS
        this.newDipendente = {
            code: "",
            name: "",
            surname: "",
            company: null,
            email: "",
            rfid: "",
        };
        this.newCodeError = "validating";
        this.isLoading = true;
        this.companyData = _environments_global__WEBPACK_IMPORTED_MODULE_3__["Aziende"];
        // SETUP INTERFACE
        this.g.menuState = 1;
        this.g.homeTitle = "Tabella Dipendenti";
        // LOAD DATA
        this.loadData();
    }
    loadData() {
        this.isLoading = true;
        const query = "SELECT * from chk_users";
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            this.dataSet = res.data;
            this.updateEditCache();
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: 0 });
        });
    }
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        if (this.sortName) {
            this.displayData = [
                ...this.dataSet.sort((a, b) => this.sortValue === "ascend"
                    ? a[this.sortName] > b[this.sortName]
                        ? 1
                        : -1
                    : b[this.sortName] > a[this.sortName]
                        ? 1
                        : -1),
            ];
        }
        else {
            this.displayData = [...this.dataSet];
        }
    }
    startEdit(id) {
        this.editCache[id].edit = true;
    }
    cancelEdit(id) {
        this.editCache[id].edit = false;
    }
    saveNew() {
        const check = this.dataSet.findIndex((item) => item.code === this.newDipendente.code);
        if (check !== -1) {
            this.notification.error("Codice già esistente", "Attenzione: il codice inserito è già stato utilizzato.", { nzDuration: this.g.fastTime });
            this.newCodeError = "error";
            return;
        }
        const query = 'INSERT INTO chk_users (`code`, `name`, `surname`, `company`, `email`, `rfid`) VALUES ("' +
            this.newDipendente.code +
            '","' +
            this.newDipendente.name +
            '","' +
            this.newDipendente.surname +
            '","' +
            this.newDipendente.company +
            '","' +
            this.newDipendente.email +
            '","' +
            this.newDipendente.rfid +
            '")';
        this.isLoading = true;
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.newDipendente.id = res.data.insertId;
                this.dataSet.push(this.newDipendente);
                this.newDipendente = {
                    id: "",
                    code: "",
                    name: "",
                    surname: "",
                    company: "",
                    email: "",
                    rfid: "",
                };
                this.newCodeError = "validating";
                this.message.success("Nuovo inserimento creato con successo!");
                this.updateEditCache();
            }
            else {
                this.notification.error("Si è verificato un problema, si prega di riprovare tra qualche minuto.", res.message, { nzDuration: this.g.normalTime });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto.", error.statusText, { nzDuration: 0 });
        });
    }
    saveEdit(id) {
        const data = this.editCache[id].data;
        const index = this.dataSet.findIndex((item) => item.id === id);
        const check = this.dataSet.findIndex((item) => item.code === data.code);
        if (check !== -1 && check !== index) {
            this.notification.error("Codice già esistente", "Attenzione: il codice inserito è già stato utilizzato.", { nzDuration: this.g.fastTime });
            return;
        }
        this.dataSet[index] = this.editCache[id].data;
        this.editCache[id].edit = false;
        const query = 'UPDATE chk_users SET `code`="' +
            data.code +
            '", `name`="' +
            data.name +
            '", `surname`="' +
            data.surname +
            '", `company`="' +
            data.company +
            '", `email`="' +
            data.email +
            '", `rfid`="' +
            data.rfid +
            '" where `id`=' +
            data.id;
        this.isLoading = true;
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.message.success("Modifica completata con successo!");
                this.updateEditCache();
            }
            else {
                this.notification.error("Si è verificato un problema, si prega di riprovare tra qualche minuto.", res.message, { nzDuration: this.g.normalTime });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto.", error.statusText, { nzDuration: 0 });
        });
    }
    deleteRow(id) {
        const index = this.dataSet.findIndex((item) => item.id === id);
        const query = 'DELETE FROM chk_users WHERE `code`= "' + this.dataSet[index].code + '"';
        this.isLoading = true;
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.dataSet.splice(index, 1);
                this.message.success("Cancellazione completata con successo!");
                this.updateEditCache();
            }
            else {
                this.notification.error("Si è verificato un problema, si prega di riprovare tra qualche minuto.", res.message, { nzDuration: this.g.normalTime });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto.", error.statusText, { nzDuration: 0 });
        });
    }
    updateEditCache() {
        if (this.dataSet != null) {
            this.dataSet.forEach((item) => {
                if (!this.editCache[item.id]) {
                    this.editCache[item.id] = {
                        edit: false,
                        data: item,
                    };
                }
            });
        }
        this.displayData = [...this.dataSet];
    }
};
DipendentiComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_3__["GlobalComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__["NzNotificationService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__["NzMessageService"] }
];
DipendentiComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-dipendenti",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dipendenti.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/dipendenti/dipendenti.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dipendenti.component.scss */ "./src/home/dipendenti/dipendenti.component.scss")).default]
    })
], DipendentiComponent);



/***/ }),

/***/ "./src/home/excel-report/excel-report.scss":
/*!*************************************************!*\
  !*** ./src/home/excel-report/excel-report.scss ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep nz-card .ant-select, :host ::ng-deep nz-card .ant-btn, :host ::ng-deep nz-card .ant-calendar-picker, :host ::ng-deep nz-card nz-month-picker {\n  width: 100%;\n}\n:host ::ng-deep nz-card .ant-table-row, :host ::ng-deep nz-card .ant-table-row:hover {\n  background-color: #fff;\n}\n:host ::ng-deep nz-card .alertRow {\n  background-color: #fdf2f2;\n}\n.export {\n  font-family: \"Courier New\", Courier, monospace;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ob21lL2V4Y2VsLXJlcG9ydC9DOlxcVXNlcnNcXFNvdXJjZXNcXFdlYkNoZWNrXFx3ZWJjaGVjay5lbXNvZnQuaXQvc3JjXFxob21lXFxleGNlbC1yZXBvcnRcXGV4Y2VsLXJlcG9ydC5zY3NzIiwic3JjL2hvbWUvZXhjZWwtcmVwb3J0L2V4Y2VsLXJlcG9ydC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNJO0VBQ0UsV0FBQTtBQ0FOO0FERUk7RUFDRSxzQkFBQTtBQ0FOO0FER0k7RUFDRSx5QkFBQTtBQ0ROO0FESUU7RUFDRSw4Q0FBQTtBQ0RKIiwiZmlsZSI6InNyYy9ob21lL2V4Y2VsLXJlcG9ydC9leGNlbC1yZXBvcnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IDo6bmctZGVlcCBuei1jYXJkIHtcbiAgICAuYW50LXNlbGVjdCwgLmFudC1idG4sIC5hbnQtY2FsZW5kYXItcGlja2VyLCBuei1tb250aC1waWNrZXIge1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgfVxuICAgIC5hbnQtdGFibGUtcm93LCAuYW50LXRhYmxlLXJvdzpob3ZlciB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmO1xuICAgIH1cblxuICAgIC5hbGVydFJvdyB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmRmMmYyO1xuICAgIH1cbiAgfVxuICAuZXhwb3J0IHtcbiAgICBmb250LWZhbWlseTogJ0NvdXJpZXIgTmV3JywgQ291cmllciwgbW9ub3NwYWNlO1xuICB9IiwiOmhvc3QgOjpuZy1kZWVwIG56LWNhcmQgLmFudC1zZWxlY3QsIDpob3N0IDo6bmctZGVlcCBuei1jYXJkIC5hbnQtYnRuLCA6aG9zdCA6Om5nLWRlZXAgbnotY2FyZCAuYW50LWNhbGVuZGFyLXBpY2tlciwgOmhvc3QgOjpuZy1kZWVwIG56LWNhcmQgbnotbW9udGgtcGlja2VyIHtcbiAgd2lkdGg6IDEwMCU7XG59XG46aG9zdCA6Om5nLWRlZXAgbnotY2FyZCAuYW50LXRhYmxlLXJvdywgOmhvc3QgOjpuZy1kZWVwIG56LWNhcmQgLmFudC10YWJsZS1yb3c6aG92ZXIge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmO1xufVxuOmhvc3QgOjpuZy1kZWVwIG56LWNhcmQgLmFsZXJ0Um93IHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZkZjJmMjtcbn1cblxuLmV4cG9ydCB7XG4gIGZvbnQtZmFtaWx5OiBcIkNvdXJpZXIgTmV3XCIsIENvdXJpZXIsIG1vbm9zcGFjZTtcbn0iXX0= */");

/***/ }),

/***/ "./src/home/excel-report/excel-report.ts":
/*!***********************************************!*\
  !*** ./src/home/excel-report/excel-report.ts ***!
  \***********************************************/
/*! exports provided: ExcelReportComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExcelReportComponent", function() { return ExcelReportComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let ExcelReportComponent = class ExcelReportComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(g, datepipe, notification) {
        this.g = g;
        this.datepipe = datepipe;
        this.notification = notification;
        // TABLE VARS
        this.daysData = [];
        this.timesData = [];
        this.usersData = [];
        this.editCache = {};
        this.sortName = null;
        this.sortValue = null;
        // COMPONNET VARS
        this.companyData = _environments_global__WEBPACK_IMPORTED_MODULE_4__["Aziende"];
        this.isSpinning = false;
        this.isLoading = false;
        // selectedCompany: string;
        // selectedMonth: Date;
        // public selectedMonthName: string;
        // ########################################## DEBUG
        this.selectedCompany = "Meneghetti";
        this.lastMonth = new Date();
        this.selectedMonth = new Date(this.lastMonth.getFullYear(), this.lastMonth.getMonth() - 1, 1);
        this.selectedMonthName = "";
        this.dateFormat = "dd/MM/yyyy";
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
        // ########################################## DEBUG
        this.selectUsers();
        // this.loadTimes();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 11;
        this.g.homeTitle = "Report Excel";
    }
    selectUsers() {
        this.isSpinning = true;
        const query = "SELECT * from chk_users";
        this.g.mysql(query).subscribe((res) => {
            this.usersData = res.data;
            this.isSpinning = false;
        }, (error) => {
            this.isSpinning = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: 0 });
        });
    }
    loadTimes() {
        this.isLoading = true;
        let startDate;
        let endDate;
        // tslint:disable-next-line:max-line-length
        let query = "SELECT chk_times.userId, chk_times.date, Round(Sum(chk_times.h),2) AS Sum_h, chk_users.name, chk_users.surname FROM chk_times INNER JOIN chk_users ON chk_users.id = chk_times.userId";
        if (this.selectedMonth != null) {
            startDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth(), 1);
            endDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 0);
            query +=
                ' WHERE chk_times.date >= "' +
                    this.datepipe.transform(startDate, "yyyy-MM-dd") +
                    '"' +
                    ' AND  chk_times.date <= "' +
                    this.datepipe.transform(endDate, "yyyy-MM-dd") +
                    '"';
            this.selectedMonthName = this.selectedMonth.toLocaleString("it-IT", {
                month: "long",
            });
        }
        query +=
            " GROUP BY chk_times.userId, chk_times.date, chk_users.name, chk_users.surname ORDER BY chk_times.date, chk_times.userId";
        // console.log( query );
        return this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            this.timesData = res.data;
            const endtDay = endDate.getUTCDate();
            this.daysData = [];
            for (let nday = 1; nday <= endtDay + 1; nday++) {
                this.daysData.push({
                    day: nday,
                    users: this.deepCopy(this.usersData),
                    expand: true,
                });
            }
            // console.log(this.daysData);
            // console.log(this.usersData);
            this.txtExport =
                "DITTA:;" +
                    this.selectedCompany.toUpperCase() +
                    ";MESE:;" +
                    this.selectedMonthName.toUpperCase() +
                    "\n\n\n";
            this.timesData.forEach((t) => {
                const data = new Date(t.date);
                const day = data.getDate();
                const item = this.daysData[day - 1].users.find((u) => u.id === t.userId);
                item.Sum_h = t.Sum_h;
                // nTot += t.Sum_h;
            });
            const rows = new Array();
            let rowIndex = 0;
            let dipIndex = 0;
            this.daysData[0].users.forEach((u) => {
                this.rowsAppend(rows, 0, "DIP.;" + (u.name + " " + u.surname).toUpperCase() + ";;;");
                this.rowsAppend(rows, 1, "GG;OL;OG;GIUSTIFICATIVO;");
                rowIndex = 2;
                this.daysData.forEach((d) => {
                    // tslint:disable-next-line:max-line-length
                    this.rowsAppend(rows, rowIndex, d.day +
                        ";" +
                        (typeof d.users[dipIndex].Sum_h !== "undefined"
                            ? d.users[dipIndex].Sum_h.toString().replace(".", ",")
                            : 0) +
                        ";;;");
                    rowIndex++;
                });
                dipIndex++;
            });
            rows.forEach((r) => {
                this.txtExport += r + "\n";
            });
            this.copyToClipboard();
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: this.g.normalTime });
        });
    }
    rowsAppend(arr, index, s) {
        if (!arr[index]) {
            arr[index] = s;
        }
        else {
            arr[index] += s;
        }
    }
    deepCopy(obj) {
        let copy;
        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" !== typeof obj) {
            return obj;
        }
        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }
        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.deepCopy(obj[i]);
            }
            return copy;
        }
        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) {
                    copy[attr] = this.deepCopy(obj[attr]);
                }
            }
            return copy;
        }
        throw new Error("Unable to copy obj! Its type isn't supported.");
    }
    // sort(sort: { key: string, value: string }): void {
    //     this.sortName = sort.key;
    //     this.sortValue = sort.value;
    //     if (this.sortName) {
    //         this.displayData = [... this.timesData.sort((a, b) => (this.sortValue === 'ascend') ?
    //             (a[this.sortName] > b[this.sortName] ? 1 : -1) : (b[this.sortName] > a[this.sortName] ? 1 : -1))];
    //     } else {
    //         this.displayData = [...this.timesData];
    //     }
    // }
    copyToClipboard() {
        this.textArea.nativeElement.select();
        document.execCommand("copy");
        this.notification.success("Operazione completata", "Dati copiati con successo");
    }
};
ExcelReportComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzNotificationService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("textArea", { static: true })
], ExcelReportComponent.prototype, "textArea", void 0);
ExcelReportComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-excel-report",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./excel-report.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/excel-report/excel-report.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./excel-report.scss */ "./src/home/excel-report/excel-report.scss")).default]
    })
], ExcelReportComponent);



/***/ }),

/***/ "./src/home/home.component.scss":
/*!**************************************!*\
  !*** ./src/home/home.component.scss ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep {\n  text-align: left;\n}\n:host ::ng-deep .logo {\n  text-align: center;\n  line-height: 0;\n  padding: 10px 0;\n}\n:host ::ng-deep .logoImg {\n  max-height: 113px;\n}\n:host ::ng-deep .logoSmall {\n  max-height: 44px;\n}\n:host ::ng-deep .ant-layout-header {\n  padding-left: 0;\n}\n:host ::ng-deep .title-icon {\n  font-size: 15px;\n  line-height: 68px;\n  font-size: 24px;\n  line-height: 64px;\n  padding: 0 12px;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n:host ::ng-deep .title-icon:hover {\n  color: #1890ff;\n}\n:host ::ng-deep .fixed-header {\n  position: fixed;\n  top: 0;\n  width: 100%;\n}\n:host ::ng-deep .content {\n  margin-top: 68px;\n  margin-bottom: 25px;\n  padding: 20px;\n  overflow: auto;\n  height: calc(100vh - 68px - 25px);\n}\n:host ::ng-deep .active,\n:host ::ng-deep .ant-table-thead > tr.active.ant-table-row-hover > td,\n:host ::ng-deep .ant-table-tbody > tr.active.ant-table-row-hover > td,\n:host ::ng-deep .ant-table-thead > tr:hover > td,\n:host ::ng-deep .ant-table-tbody > tr.active:hover > td {\n  background-color: #fffde6;\n}\n:host ::ng-deep .ant-layout-footer {\n  background: #001529;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/home/home.component.ts":
/*!************************************!*\
  !*** ./src/home/home.component.ts ***!
  \************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../environments/global */ "./src/environments/global.ts");




let HomeComponent = class HomeComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(router, g) {
        this.router = router;
        this.g = g;
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        if (!this.g.checkLogin()) {
            this.router.navigateByUrl("/admin");
            return;
        }
        this.isRestricted = this.g.userLogin.restricted || this.g.userLogin.onlyorders;
        if (!this.isRestricted) {
            this.g.homeTitle = "WebCheck Amministrazione";
        }
        else {
            this.g.homeTitle = "WebCheck Gestione";
            this.router.navigateByUrl("/home/(homeContent:ordini)");
        }
    }
    // ################################################
    // LOGOUT
    logOut() {
        this.g.userLogin = {};
        this.g.menuState = 0;
        sessionStorage.setItem("webcheck", JSON.stringify(this.g.userLogin));
        this.router.navigateByUrl("/admin");
    }
};
HomeComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_3__["GlobalComponent"] }
];
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-home",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.scss */ "./src/home/home.component.scss")).default]
    })
], HomeComponent);



/***/ }),

/***/ "./src/home/incidenze-report/incidenze.report.scss":
/*!*********************************************************!*\
  !*** ./src/home/incidenze-report/incidenze.report.scss ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-select, :host ::ng-deep .ant-btn, :host ::ng-deep .ant-calendar-picker, :host ::ng-deep nz-month-picker {\n  width: 100%;\n}\n:host ::ng-deep .ant-table-row, :host ::ng-deep .ant-table-row:hover {\n  background-color: #fff;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ob21lL2luY2lkZW56ZS1yZXBvcnQvQzpcXFVzZXJzXFxTb3VyY2VzXFxXZWJDaGVja1xcd2ViY2hlY2suZW1zb2Z0Lml0L3NyY1xcaG9tZVxcaW5jaWRlbnplLXJlcG9ydFxcaW5jaWRlbnplLnJlcG9ydC5zY3NzIiwic3JjL2hvbWUvaW5jaWRlbnplLXJlcG9ydC9pbmNpZGVuemUucmVwb3J0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0k7RUFDRSxXQUFBO0FDQU47QURFSTtFQUNFLHNCQUFBO0FDQU4iLCJmaWxlIjoic3JjL2hvbWUvaW5jaWRlbnplLXJlcG9ydC9pbmNpZGVuemUucmVwb3J0LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCA6Om5nLWRlZXAge1xuICAgIC5hbnQtc2VsZWN0LCAuYW50LWJ0biwgLmFudC1jYWxlbmRhci1waWNrZXIsIG56LW1vbnRoLXBpY2tlciB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG4gICAgLmFudC10YWJsZS1yb3csIC5hbnQtdGFibGUtcm93OmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG4gICAgfVxuICAgIFxuICB9XG4gICIsIjpob3N0IDo6bmctZGVlcCAuYW50LXNlbGVjdCwgOmhvc3QgOjpuZy1kZWVwIC5hbnQtYnRuLCA6aG9zdCA6Om5nLWRlZXAgLmFudC1jYWxlbmRhci1waWNrZXIsIDpob3N0IDo6bmctZGVlcCBuei1tb250aC1waWNrZXIge1xuICB3aWR0aDogMTAwJTtcbn1cbjpob3N0IDo6bmctZGVlcCAuYW50LXRhYmxlLXJvdywgOmhvc3QgOjpuZy1kZWVwIC5hbnQtdGFibGUtcm93OmhvdmVyIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZjtcbn0iXX0= */");

/***/ }),

/***/ "./src/home/incidenze-report/incidenze.report.ts":
/*!*******************************************************!*\
  !*** ./src/home/incidenze-report/incidenze.report.ts ***!
  \*******************************************************/
/*! exports provided: IncidenzeReportComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IncidenzeReportComponent", function() { return IncidenzeReportComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let IncidenzeReportComponent = class IncidenzeReportComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(g, datepipe, notification) {
        this.g = g;
        this.datepipe = datepipe;
        this.notification = notification;
        // TABLE VARS
        this.timesData = [];
        this.displayData = [...this.timesData];
        this.ordersData = [];
        this.editCache = {};
        this.sortName = null;
        this.sortValue = null;
        // COMPONNET VARS
        this.companyData = _environments_global__WEBPACK_IMPORTED_MODULE_4__["Aziende"];
        this.isSpinning = false;
        this.isLoading = false;
        this.selectedOrders = [];
        this.statusFilter = true;
        this.totalSwitch = false;
        this.currentTotale = "Totale ore: 0";
        this.dateFormat = "dd/MM/yyyy";
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
        this.loadData();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 7;
        this.g.homeTitle = "Report Incidenze";
    }
    loadData(reSelect = false) {
        this.isSpinning = true;
        const query = "SELECT * from chk_orders WHERE `status`=" + (this.statusFilter ? "1" : "0");
        this.g.mysql(query).subscribe((res) => {
            this.ordersData = res.data;
            this.isSpinning = false;
            if (reSelect) {
                this.selectedOrder = null;
                this.selectOrders();
            }
        }, (error) => {
            this.isSpinning = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: 0 });
        });
    }
    selectOrders() {
        if (this.selectedCompany) {
            this.selectedOrders = this.ordersData.filter((o) => o.company === this.selectedCompany);
            this.selectedOrder = null;
        }
    }
    loadTimes() {
        this.isLoading = true;
        // tslint:disable-next-line:max-line-length
        let query = "SELECT chk_times.id, chk_times.userId, Sum(chk_times.h) As Sum_h, chk_users.name, chk_users.surname FROM chk_times INNER JOIN chk_users ON chk_users.id = chk_times.userId INNER JOIN chk_orders ON chk_orders.id = chk_times.orderId" +
            " WHERE `orderId`=" +
            this.selectedOrder.id +
            " GROUP BY chk_times.userId,	chk_times.orderId, chk_users.name, chk_users.surname";
        query += " ORDER BY chk_users.name";
        console.log(query);
        return this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            let totaleOre = 0;
            res.data.forEach((t) => {
                totaleOre += t.Sum_h;
            });
            this.currentTotale = totaleOre > 0 ? "Totale ore: " + totaleOre : "";
            if (totaleOre > 0) {
                res.data.forEach((t) => {
                    const incidenza = ((t.Sum_h * 100) / totaleOre);
                    t.incidenza = (incidenza > 1) ? incidenza.toFixed(0) + "%" : "<1%";
                });
            }
            this.timesData = res.data;
            this.displayData = [...this.timesData];
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, {
                nzDuration: this.g.normalTime,
            });
        });
    }
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        if (this.sortName) {
            this.displayData = [
                ...this.timesData.sort((a, b) => this.sortValue === "ascend"
                    ? a[this.sortName] > b[this.sortName]
                        ? 1
                        : -1
                    : b[this.sortName] > a[this.sortName]
                        ? 1
                        : -1),
            ];
        }
        else {
            this.displayData = [...this.timesData];
        }
    }
};
IncidenzeReportComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzNotificationService"] }
];
IncidenzeReportComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-incidenze-report",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./incidenze.report.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/incidenze-report/incidenze.report.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./incidenze.report.scss */ "./src/home/incidenze-report/incidenze.report.scss")).default]
    })
], IncidenzeReportComponent);



/***/ }),

/***/ "./src/home/mese-report/mese-report.scss":
/*!***********************************************!*\
  !*** ./src/home/mese-report/mese-report.scss ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep nz-card .ant-select, :host ::ng-deep nz-card .ant-btn, :host ::ng-deep nz-card .ant-calendar-picker, :host ::ng-deep nz-card nz-month-picker {\n  width: 100%;\n}\n:host ::ng-deep nz-card .ant-table-row, :host ::ng-deep nz-card .ant-table-row:hover {\n  background-color: #fff;\n}\n:host ::ng-deep nz-card .alertRow {\n  background-color: #fdf2f2;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ob21lL21lc2UtcmVwb3J0L0M6XFxVc2Vyc1xcU291cmNlc1xcV2ViQ2hlY2tcXHdlYmNoZWNrLmVtc29mdC5pdC9zcmNcXGhvbWVcXG1lc2UtcmVwb3J0XFxtZXNlLXJlcG9ydC5zY3NzIiwic3JjL2hvbWUvbWVzZS1yZXBvcnQvbWVzZS1yZXBvcnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDSTtFQUNFLFdBQUE7QUNBTjtBREVJO0VBQ0Usc0JBQUE7QUNBTjtBREdJO0VBQ0UseUJBQUE7QUNETiIsImZpbGUiOiJzcmMvaG9tZS9tZXNlLXJlcG9ydC9tZXNlLXJlcG9ydC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3QgOjpuZy1kZWVwIG56LWNhcmQge1xuICAgIC5hbnQtc2VsZWN0LCAuYW50LWJ0biwgLmFudC1jYWxlbmRhci1waWNrZXIsIG56LW1vbnRoLXBpY2tlciB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG4gICAgLmFudC10YWJsZS1yb3csIC5hbnQtdGFibGUtcm93OmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG4gICAgfVxuXG4gICAgLmFsZXJ0Um93IHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICNmZGYyZjI7XG4gICAgfVxuICB9XG4gICIsIjpob3N0IDo6bmctZGVlcCBuei1jYXJkIC5hbnQtc2VsZWN0LCA6aG9zdCA6Om5nLWRlZXAgbnotY2FyZCAuYW50LWJ0biwgOmhvc3QgOjpuZy1kZWVwIG56LWNhcmQgLmFudC1jYWxlbmRhci1waWNrZXIsIDpob3N0IDo6bmctZGVlcCBuei1jYXJkIG56LW1vbnRoLXBpY2tlciB7XG4gIHdpZHRoOiAxMDAlO1xufVxuOmhvc3QgOjpuZy1kZWVwIG56LWNhcmQgLmFudC10YWJsZS1yb3csIDpob3N0IDo6bmctZGVlcCBuei1jYXJkIC5hbnQtdGFibGUtcm93OmhvdmVyIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZjtcbn1cbjpob3N0IDo6bmctZGVlcCBuei1jYXJkIC5hbGVydFJvdyB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmZGYyZjI7XG59Il19 */");

/***/ }),

/***/ "./src/home/mese-report/mese-report.ts":
/*!*********************************************!*\
  !*** ./src/home/mese-report/mese-report.ts ***!
  \*********************************************/
/*! exports provided: MeseReportComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MeseReportComponent", function() { return MeseReportComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let MeseReportComponent = class MeseReportComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(g, datepipe, notification) {
        this.g = g;
        this.datepipe = datepipe;
        this.notification = notification;
        // TABLE VARS
        this.daysData = [];
        this.timesData = [];
        this.usersData = [];
        this.editCache = {};
        this.sortName = null;
        this.sortValue = null;
        // COMPONNET VARS
        this.companyData = _environments_global__WEBPACK_IMPORTED_MODULE_4__["Aziende"];
        this.isSpinning = false;
        this.isLoading = false;
        this.dateFormat = 'dd/MM/yyyy';
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 9;
        this.g.homeTitle = 'Report Mese';
    }
    selectUsers() {
        this.isSpinning = true;
        const query = 'SELECT * from chk_users';
        this.g.mysql(query)
            .subscribe((res) => {
            this.usersData = res.data;
            this.isSpinning = false;
        }, (error) => {
            this.isSpinning = false;
            this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: 0 });
        });
    }
    loadTimes() {
        this.isLoading = true;
        let startDate;
        let endDate;
        // tslint:disable-next-line:max-line-length
        let query = 'SELECT chk_times.userId, chk_times.date, Round(Sum(chk_times.h),2) AS Sum_h, chk_users.name, chk_users.surname FROM chk_times INNER JOIN chk_users ON chk_users.id = chk_times.userId';
        if (this.selectedMonth != null) {
            startDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth(), 1);
            endDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 0);
            query += ' WHERE chk_times.date >= "' + this.datepipe.transform(startDate, 'yyyy-MM-dd') + '"' +
                ' AND chk_times.date <= "' + this.datepipe.transform(endDate, 'yyyy-MM-dd') + '"';
            this.selectedMonthName = this.selectedMonth.toLocaleString('it-IT', { month: 'long' });
        }
        query += ' GROUP BY chk_times.userId, chk_times.date, chk_users.name, chk_users.surname ORDER BY chk_times.date, chk_times.userId';
        console.log(query);
        return this.g.mysql(query)
            .subscribe((res) => {
            this.isLoading = false;
            this.timesData = res.data;
            const endtDay = endDate.getUTCDate();
            this.daysData = [];
            for (let nday = 1; nday <= endtDay + 1; nday++) {
                this.daysData.push({ day: nday, users: this.deepCopy(this.usersData), expand: true });
            }
            console.log(this.daysData);
            // console.log(this.timesData);
            let nTot = 0;
            this.timesData.forEach(t => {
                const data = new Date(t.date);
                const day = data.getDate();
                const item = this.daysData[day - 1].users.find(u => u.id === t.userId);
                item.Sum_h = t.Sum_h;
                nTot += t.Sum_h;
            });
            this.currentTotale = (nTot > 0) ? 'Totale ore: ' + nTot : '';
        }, (error) => {
            this.isLoading = false;
            this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: this.g.normalTime });
        });
    }
    deepCopy(obj) {
        let copy;
        // Handle the 3 simple types, and null or undefined
        if (null == obj || 'object' !== typeof obj) {
            return obj;
        }
        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }
        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (let i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.deepCopy(obj[i]);
            }
            return copy;
        }
        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) {
                    copy[attr] = this.deepCopy(obj[attr]);
                }
            }
            return copy;
        }
        throw new Error('Unable to copy obj! Its type isn\'t supported.');
    }
    // sort(sort: { key: string, value: string }): void {
    //     this.sortName = sort.key;
    //     this.sortValue = sort.value;
    //     if (this.sortName) {
    //         this.displayData = [... this.timesData.sort((a, b) => (this.sortValue === 'ascend') ?
    //             (a[this.sortName] > b[this.sortName] ? 1 : -1) : (b[this.sortName] > a[this.sortName] ? 1 : -1))];
    //     } else {
    //         this.displayData = [...this.timesData];
    //     }
    // }
    copyToClipboard() {
        let xls = '';
        this.daysData.forEach(d => {
            d.users.forEach(u => {
                xls += d.day.toString() + '/' + this.selectedMonth.getMonth() + '/' + this.selectedMonth.getFullYear() + '\t';
                xls += u.code + '\t';
                xls += u.name + '\t';
                xls += u.surname + '\t';
                xls += (u.Sum_h || 0) + '\r\n';
            });
        });
        const dummy = document.createElement('textarea');
        document.body.appendChild(dummy);
        // dummy.setAttribute('value', xls);
        dummy.value = xls;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);
    }
};
MeseReportComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzNotificationService"] }
];
MeseReportComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-mese-report',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./mese-report.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/mese-report/mese-report.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./mese-report.scss */ "./src/home/mese-report/mese-report.scss")).default]
    })
], MeseReportComponent);



/***/ }),

/***/ "./src/home/ordini-report/ordini.report.scss":
/*!***************************************************!*\
  !*** ./src/home/ordini-report/ordini.report.scss ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-select, :host ::ng-deep .ant-btn, :host ::ng-deep .ant-calendar-picker, :host ::ng-deep nz-month-picker {\n  width: 100%;\n}\n:host ::ng-deep .ant-table-row, :host ::ng-deep .ant-table-row:hover {\n  background-color: #fff;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ob21lL29yZGluaS1yZXBvcnQvQzpcXFVzZXJzXFxTb3VyY2VzXFxXZWJDaGVja1xcd2ViY2hlY2suZW1zb2Z0Lml0L3NyY1xcaG9tZVxcb3JkaW5pLXJlcG9ydFxcb3JkaW5pLnJlcG9ydC5zY3NzIiwic3JjL2hvbWUvb3JkaW5pLXJlcG9ydC9vcmRpbmkucmVwb3J0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0k7RUFDRSxXQUFBO0FDQU47QURFSTtFQUNFLHNCQUFBO0FDQU4iLCJmaWxlIjoic3JjL2hvbWUvb3JkaW5pLXJlcG9ydC9vcmRpbmkucmVwb3J0LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCA6Om5nLWRlZXAge1xuICAgIC5hbnQtc2VsZWN0LCAuYW50LWJ0biwgLmFudC1jYWxlbmRhci1waWNrZXIsIG56LW1vbnRoLXBpY2tlciB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG4gICAgLmFudC10YWJsZS1yb3csIC5hbnQtdGFibGUtcm93OmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG4gICAgfVxuICAgIFxuICB9XG4gICIsIjpob3N0IDo6bmctZGVlcCAuYW50LXNlbGVjdCwgOmhvc3QgOjpuZy1kZWVwIC5hbnQtYnRuLCA6aG9zdCA6Om5nLWRlZXAgLmFudC1jYWxlbmRhci1waWNrZXIsIDpob3N0IDo6bmctZGVlcCBuei1tb250aC1waWNrZXIge1xuICB3aWR0aDogMTAwJTtcbn1cbjpob3N0IDo6bmctZGVlcCAuYW50LXRhYmxlLXJvdywgOmhvc3QgOjpuZy1kZWVwIC5hbnQtdGFibGUtcm93OmhvdmVyIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZjtcbn0iXX0= */");

/***/ }),

/***/ "./src/home/ordini-report/ordini.report.ts":
/*!*************************************************!*\
  !*** ./src/home/ordini-report/ordini.report.ts ***!
  \*************************************************/
/*! exports provided: OrdiniReportComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrdiniReportComponent", function() { return OrdiniReportComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let OrdiniReportComponent = class OrdiniReportComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(g, datepipe, notification) {
        this.g = g;
        this.datepipe = datepipe;
        this.notification = notification;
        // TABLE VARS
        this.timesData = [];
        this.displayData = [...this.timesData];
        this.ordersData = [];
        this.editCache = {};
        this.sortName = null;
        this.sortValue = null;
        // COMPONNET VARS
        this.companyData = _environments_global__WEBPACK_IMPORTED_MODULE_4__["Aziende"];
        this.isSpinning = false;
        this.isLoading = false;
        this.selectedOrders = [];
        this.statusFilter = true;
        this.totalSwitch = false;
        this.currentTotale = "Totale ore: 0";
        this.dateFormat = "dd/MM/yyyy";
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
        this.loadData();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 6;
        this.g.homeTitle = "Report Ordini";
    }
    loadData(reSelect = false) {
        this.isSpinning = true;
        const query = "SELECT * from chk_orders WHERE `status`=" + (this.statusFilter ? "1" : "0");
        this.g.mysql(query).subscribe((res) => {
            this.ordersData = res.data;
            this.isSpinning = false;
            if (reSelect) {
                this.selectedOrder = null;
                this.selectOrders();
            }
        }, (error) => {
            this.isSpinning = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: 0 });
        });
    }
    selectOrders() {
        if (this.selectedCompany) {
            this.selectedOrders = this.ordersData.filter((o) => o.company === this.selectedCompany);
            this.selectedOrder = null;
        }
    }
    loadTimes() {
        this.isLoading = true;
        // tslint:disable-next-line:max-line-length
        let query = "SELECT chk_times.id, chk_times.userId, chk_times.date, chk_times.orderId, chk_times.h, chk_users.name, chk_users.surname, chk_orders.status FROM chk_times INNER JOIN chk_users ON chk_users.id = chk_times.userId INNER JOIN chk_orders ON chk_orders.id = chk_times.orderId" +
            " WHERE `orderId`=" +
            this.selectedOrder.id;
        if (this.selectedMonth != null) {
            const startDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth(), 1);
            const endDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 0);
            query +=
                ' AND  chk_times.date >= "' +
                    this.datepipe.transform(startDate, "yyyy-MM-dd") +
                    '"' +
                    ' AND  chk_times.date <= "' +
                    this.datepipe.transform(endDate, "yyyy-MM-dd") +
                    '"';
        }
        query += " ORDER BY chk_times.date";
        return this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            this.timesData = res.data;
            this.processData();
            let n = 0;
            res.data.forEach((t) => {
                n += t.h;
            });
            this.currentTotale = n > 0 ? "Totale ore: " + n : "";
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, {
                nzDuration: this.g.normalTime,
            });
        });
    }
    processData() {
        if (this.totalSwitch) {
            const sum = this.timesData.reduce((acc, cur) => {
                const found = acc.find((val) => val.name === cur.name && val.surname === cur.surname);
                if (found) {
                    found.h += cur.h;
                    found.date = null;
                }
                else {
                    acc.push(Object.assign({}, cur, { h: cur.h }));
                }
                return acc;
            }, []);
            this.displayData = [...sum];
        }
        else {
            this.displayData = [...this.timesData];
        }
    }
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        if (this.sortName) {
            this.displayData = [
                ...this.timesData.sort((a, b) => this.sortValue === "ascend"
                    ? a[this.sortName] > b[this.sortName]
                        ? 1
                        : -1
                    : b[this.sortName] > a[this.sortName]
                        ? 1
                        : -1),
            ];
        }
        else {
            this.displayData = [...this.timesData];
        }
    }
};
OrdiniReportComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzNotificationService"] }
];
OrdiniReportComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-ordini-report",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./ordini.report.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/ordini-report/ordini.report.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./ordini.report.scss */ "./src/home/ordini-report/ordini.report.scss")).default]
    })
], OrdiniReportComponent);



/***/ }),

/***/ "./src/home/ordini/ordini.component.scss":
/*!***********************************************!*\
  !*** ./src/home/ordini/ordini.component.scss ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-table {\n  padding-top: 60px;\n}\n:host ::ng-deep .ant-pagination {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n}\n:host ::ng-deep .ant-input-number,\n:host ::ng-deep .ant-select {\n  width: 100% !important;\n}\n:host ::ng-deep .ant-card-body {\n  padding-top: 10px;\n}\n:host ::ng-deep .newCard button {\n  width: 100%;\n}\n:host ::ng-deep .ordini-select-wrapper {\n  position: absolute;\n  top: 0;\n}\n:host ::ng-deep .filter-control {\n  display: inline-flex;\n  top: -23px;\n  margin-left: 8px;\n}\n:host ::ng-deep .ordini-select {\n  padding: 16px 8px;\n  z-index: 99;\n}\n:host ::ng-deep .ordini-select button {\n  height: 30px;\n}\n:host ::ng-deep .ordini-select button span > span {\n  padding: 10px;\n  color: #000;\n}\n:host ::ng-deep .ordini-select .ant-switch-checked {\n  background-color: #a5f8ac;\n}\n:host ::ng-deep .ordini-select .ant-switch-checked::after {\n  top: 5px;\n}\n:host ::ng-deep .ordini-select .ant-switch::after {\n  top: 5px;\n}\n:host ::ng-deep .prize-select button span > span {\n  color: #000;\n}\n:host ::ng-deep .prize-select .ant-switch-checked {\n  background-color: #a5f8ac;\n}\n:host ::ng-deep .ext,\n:host ::ng-deep .tot {\n  margin: 10px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ob21lL29yZGluaS9DOlxcVXNlcnNcXFNvdXJjZXNcXFdlYkNoZWNrXFx3ZWJjaGVjay5lbXNvZnQuaXQvc3JjXFxob21lXFxvcmRpbmlcXG9yZGluaS5jb21wb25lbnQuc2NzcyIsInNyYy9ob21lL29yZGluaS9vcmRpbmkuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0U7RUFDRSxpQkFBQTtBQ0FKO0FERUU7RUFDRSxrQkFBQTtFQUNBLFFBQUE7RUFDQSxVQUFBO0FDQUo7QURFRTs7RUFFRSxzQkFBQTtBQ0FKO0FERUU7RUFDRSxpQkFBQTtBQ0FKO0FERUU7RUFDRSxXQUFBO0FDQUo7QURFRTtFQUNFLGtCQUFBO0VBQ0EsTUFBQTtBQ0FKO0FERUU7RUFDRSxvQkFBQTtFQUNBLFVBQUE7RUFDQSxnQkFBQTtBQ0FKO0FERUU7RUFDRSxpQkFBQTtFQUNBLFdBQUE7QUNBSjtBRENJO0VBQ0UsWUFBQTtBQ0NOO0FEQU07RUFDRSxhQUFBO0VBQ0EsV0FBQTtBQ0VSO0FEQ0k7RUFDRSx5QkFBQTtBQ0NOO0FEQ0k7RUFDRSxRQUFBO0FDQ047QURDSTtFQUNFLFFBQUE7QUNDTjtBRElNO0VBQ0UsV0FBQTtBQ0ZSO0FES0k7RUFDRSx5QkFBQTtBQ0hOO0FETUU7O0VBRUUsWUFBQTtBQ0pKIiwiZmlsZSI6InNyYy9ob21lL29yZGluaS9vcmRpbmkuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCA6Om5nLWRlZXAge1xuICAuYW50LXRhYmxlIHtcbiAgICBwYWRkaW5nLXRvcDogNjBweDtcbiAgfVxuICAuYW50LXBhZ2luYXRpb24ge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDBweDtcbiAgICByaWdodDogMHB4O1xuICB9XG4gIC5hbnQtaW5wdXQtbnVtYmVyLFxuICAuYW50LXNlbGVjdCB7XG4gICAgd2lkdGg6IDEwMCUgIWltcG9ydGFudDtcbiAgfVxuICAuYW50LWNhcmQtYm9keSB7XG4gICAgcGFkZGluZy10b3A6IDEwcHg7XG4gIH1cbiAgLm5ld0NhcmQgYnV0dG9uIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuICAub3JkaW5pLXNlbGVjdC13cmFwcGVyIHtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdG9wOiAwO1xuICB9XG4gIC5maWx0ZXItY29udHJvbCB7XG4gICAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gICAgdG9wOiAtMjNweDtcbiAgICBtYXJnaW4tbGVmdDogOHB4O1xuICB9XG4gIC5vcmRpbmktc2VsZWN0IHtcbiAgICBwYWRkaW5nOiAxNnB4IDhweDtcbiAgICB6LWluZGV4OiA5OTtcbiAgICBidXR0b24ge1xuICAgICAgaGVpZ2h0OiAzMHB4O1xuICAgICAgc3BhbiA+IHNwYW4ge1xuICAgICAgICBwYWRkaW5nOiAxMHB4O1xuICAgICAgICBjb2xvcjogIzAwMDtcbiAgICAgIH1cbiAgICB9XG4gICAgLmFudC1zd2l0Y2gtY2hlY2tlZCB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjYTVmOGFjO1xuICAgIH1cbiAgICAuYW50LXN3aXRjaC1jaGVja2VkOjphZnRlciB7XG4gICAgICB0b3A6IDVweDtcbiAgICB9XG4gICAgLmFudC1zd2l0Y2g6OmFmdGVyIHtcbiAgICAgIHRvcDogNXB4O1xuICAgIH1cbiAgfVxuICAucHJpemUtc2VsZWN0IHtcbiAgICBidXR0b24ge1xuICAgICAgc3BhbiA+IHNwYW4ge1xuICAgICAgICBjb2xvcjogIzAwMDtcbiAgICAgIH1cbiAgICB9XG4gICAgLmFudC1zd2l0Y2gtY2hlY2tlZCB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjYTVmOGFjO1xuICAgIH1cbiAgfVxuICAuZXh0LFxuICAudG90IHtcbiAgICBtYXJnaW46IDEwcHg7XG4gIH1cbn1cbiIsIjpob3N0IDo6bmctZGVlcCAuYW50LXRhYmxlIHtcbiAgcGFkZGluZy10b3A6IDYwcHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLmFudC1wYWdpbmF0aW9uIHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDBweDtcbiAgcmlnaHQ6IDBweDtcbn1cbjpob3N0IDo6bmctZGVlcCAuYW50LWlucHV0LW51bWJlcixcbjpob3N0IDo6bmctZGVlcCAuYW50LXNlbGVjdCB7XG4gIHdpZHRoOiAxMDAlICFpbXBvcnRhbnQ7XG59XG46aG9zdCA6Om5nLWRlZXAgLmFudC1jYXJkLWJvZHkge1xuICBwYWRkaW5nLXRvcDogMTBweDtcbn1cbjpob3N0IDo6bmctZGVlcCAubmV3Q2FyZCBidXR0b24ge1xuICB3aWR0aDogMTAwJTtcbn1cbjpob3N0IDo6bmctZGVlcCAub3JkaW5pLXNlbGVjdC13cmFwcGVyIHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDA7XG59XG46aG9zdCA6Om5nLWRlZXAgLmZpbHRlci1jb250cm9sIHtcbiAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gIHRvcDogLTIzcHg7XG4gIG1hcmdpbi1sZWZ0OiA4cHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLm9yZGluaS1zZWxlY3Qge1xuICBwYWRkaW5nOiAxNnB4IDhweDtcbiAgei1pbmRleDogOTk7XG59XG46aG9zdCA6Om5nLWRlZXAgLm9yZGluaS1zZWxlY3QgYnV0dG9uIHtcbiAgaGVpZ2h0OiAzMHB4O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5vcmRpbmktc2VsZWN0IGJ1dHRvbiBzcGFuID4gc3BhbiB7XG4gIHBhZGRpbmc6IDEwcHg7XG4gIGNvbG9yOiAjMDAwO1xufVxuOmhvc3QgOjpuZy1kZWVwIC5vcmRpbmktc2VsZWN0IC5hbnQtc3dpdGNoLWNoZWNrZWQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjYTVmOGFjO1xufVxuOmhvc3QgOjpuZy1kZWVwIC5vcmRpbmktc2VsZWN0IC5hbnQtc3dpdGNoLWNoZWNrZWQ6OmFmdGVyIHtcbiAgdG9wOiA1cHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLm9yZGluaS1zZWxlY3QgLmFudC1zd2l0Y2g6OmFmdGVyIHtcbiAgdG9wOiA1cHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLnByaXplLXNlbGVjdCBidXR0b24gc3BhbiA+IHNwYW4ge1xuICBjb2xvcjogIzAwMDtcbn1cbjpob3N0IDo6bmctZGVlcCAucHJpemUtc2VsZWN0IC5hbnQtc3dpdGNoLWNoZWNrZWQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjYTVmOGFjO1xufVxuOmhvc3QgOjpuZy1kZWVwIC5leHQsXG46aG9zdCA6Om5nLWRlZXAgLnRvdCB7XG4gIG1hcmdpbjogMTBweDtcbn0iXX0= */");

/***/ }),

/***/ "./src/home/ordini/ordini.component.ts":
/*!*********************************************!*\
  !*** ./src/home/ordini/ordini.component.ts ***!
  \*********************************************/
/*! exports provided: OrdiniComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrdiniComponent", function() { return OrdiniComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");
/* harmony import */ var _home_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../home.component */ "./src/home/home.component.ts");





let OrdiniComponent = class OrdiniComponent {
    constructor(g, home, notification, message) {
        this.g = g;
        this.home = home;
        this.notification = notification;
        this.message = message;
        // TABLE VARS
        this.formatterEuro = (value) => `€ ${value}`;
        this.parserEuro = (value) => value.replace("€ ", "");
        this.dataSet = [];
        this.displayData = [...this.dataSet];
        this.editCache = {};
        this.sortName = null;
        this.sortValue = null;
        // COMPONENT VARS
        this.newOrdine = {
            id: "",
            code: "",
            title: "",
            forecast: null,
            company: "Meneghetti",
            status: true,
            costM: 0,
            costH: 0,
            prize: false,
        };
        this.newCodeError = "validating";
        this.activeFilter = true;
        this.prizeFilter = false;
        this.orderFilter = "";
        this.totStimato = 0;
        this.totLavorato = 0;
        this.isLoading = true;
        this.companyData = _environments_global__WEBPACK_IMPORTED_MODULE_3__["Aziende"];
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
        this.loadData();
        this.isRestricted = this.g.userLogin.restricted;
    }
    // ################################################
    // SETUP
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 2;
        this.g.homeTitle = "Tabella Ordini";
    }
    // ################################################
    // LOAD DATA
    loadData() {
        this.isLoading = true;
        const query = "SELECT * from chk_orders WHERE `status`=" +
            (this.activeFilter ? "1" : "0") +
            (this.prizeFilter ? " and `prize`= 1" : "") +
            " ORDER BY `id` DESC";
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            this.dataSet = res.data;
            //if (this.prizeFilter) {
            // this.dataSet.forEach((e: Ordine) => {
            // this.calcH(e.id);
            // });
            //} else {
            // this.dataSet.forEach((e: Ordine) => {
            //  if (e.prize) {
            // this.calcH(e.id);
            //  }
            // });
            //}
            this.totStimato = 0;
            this.totLavorato = 0;
            this.dataSet.forEach((e) => {
                if (e.prize) {
                    this.totStimato += e.forecast;
                    this.totLavorato += e.total;
                }
            });
            if (this.orderFilter.length > 0) {
                console.log("FILTRO", this.orderFilter);
            }
            this.updateEditCache();
            // console.log(this.dataSet);
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: 0 });
        });
    }
    // ################################################
    // FILTER DATA
    filterChange(e) {
        if (this.orderFilter.length > 0) {
            var filter = this.dataSet.filter((e) => {
                return (e.title.toUpperCase().indexOf(this.orderFilter.toUpperCase()) >= 0);
            });
            this.displayData = [...filter];
        }
        else {
            this.displayData = [...this.dataSet];
        }
    }
    // ################################################
    // SEARCH
    search() { }
    // ################################################
    // RESET
    reset() { }
    // ################################################
    // SORT
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        if (this.sortName) {
            this.displayData = [
                ...this.dataSet.sort((a, b) => this.sortValue === "ascend"
                    ? a[this.sortName] > b[this.sortName]
                        ? 1
                        : -1
                    : b[this.sortName] > a[this.sortName]
                        ? 1
                        : -1),
            ];
        }
        else {
            this.displayData = [...this.dataSet];
        }
    }
    startEdit(id) {
        this.editCache[id].edit = true;
    }
    cancelEdit(id) {
        this.editCache[id].edit = false;
    }
    saveNew() {
        const check = this.dataSet.findIndex((item) => item.code === this.newOrdine.code);
        if (check !== -1) {
            this.notification.error("Codice già esistente", "Attenzione: il codice inserito è già stato utilizzato.", { nzDuration: this.g.fastTime });
            this.newCodeError = "error";
            return;
        }
        const query = 'INSERT INTO chk_orders (`code`, `title`, `forecast`, `company`, `status`, `costM`, `costH`, `prize`) VALUES ("' +
            this.newOrdine.code +
            '","' +
            this.newOrdine.title +
            '","' +
            this.newOrdine.forecast +
            '","' +
            this.newOrdine.company +
            '",' +
            +this.newOrdine.status +
            "," +
            +this.newOrdine.costM +
            "," +
            +this.newOrdine.costH +
            "," +
            +this.newOrdine.prize +
            ")";
        console.log(query);
        this.isLoading = true;
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.newOrdine.id = res.data.insertId;
                this.dataSet.push(this.newOrdine);
                this.newOrdine = {
                    id: "",
                    code: "",
                    title: "",
                    forecast: null,
                    company: "",
                    status: true,
                };
                this.newCodeError = "validating";
                this.message.success("Nuovo inserimento creato con successo!");
                this.updateEditCache();
            }
            else {
                this.notification.error("Si è verificato un problema, si prega di riprovare tra qualche minuto.", res.message, { nzDuration: this.g.normalTime });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto.", error.statusText, { nzDuration: 0 });
        });
    }
    saveEdit(id) {
        const data = this.editCache[id].data;
        const index = this.dataSet.findIndex((item) => item.id === id);
        const check = this.dataSet.findIndex((item) => item.code === data.code);
        if (check !== -1 && check !== index) {
            this.notification.error("Codice già esistente", "Attenzione: il codice inserito è già stato utilizzato.", { nzDuration: this.g.fastTime });
            return;
        }
        this.dataSet[index] = this.editCache[id].data;
        this.editCache[id].edit = false;
        const query = 'UPDATE chk_orders SET `code`="' +
            data.code +
            '", `title`="' +
            data.title +
            '", `forecast`="' +
            data.forecast +
            '", `company`="' +
            data.company +
            '", `costM`="' +
            data.costM +
            '", `costH`="' +
            data.costH +
            '", `costMReal`="' +
            data.costMReal +
            '" WHERE `id`=' +
            data.id;
        this.isLoading = true;
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.message.success("Modifica completata con successo!");
                this.updateEditCache();
            }
            else {
                this.notification.error("Si è verificato un problema, si prega di riprovare tra qualche minuto.", res.message, { nzDuration: 0 });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto.", error.statusText, { nzDuration: 0 });
        });
    }
    saveCheck(id) {
        const data = this.dataSet.find((item) => item.id === id);
        let query = "SELECT SUM(chk_times.h) AS h FROM chk_times WHERE `orderId`=" + id;
        this.g.mysql(query).subscribe((res) => {
            if (data.status === false) {
                data.total = res.data[0].h ? res.data[0].h : 0;
            }
            else {
                data.total = null;
            }
            query =
                "UPDATE chk_orders SET `status`=" +
                    (data.status === false ? 0 : 1) +
                    (data.status === false
                        ? ",`date`= '" + new Date().toISOString().substring(0, 10) + "'"
                        : ",`date`=''") +
                    ",`total`=" +
                    data.total +
                    " WHERE `id`=" +
                    data.id;
            console.log(query);
            this.isLoading = true;
            this.g.mysql(query).subscribe((resUpdate) => {
                this.isLoading = false;
                if (resUpdate.error === false) {
                    this.message.success("Modifica completata con successo!");
                    this.loadData();
                }
                else {
                    this.notification.error("Si è verificato un problema, si prega di riprovare tra qualche minuto.", resUpdate.message, { nzDuration: 0 });
                    console.log(resUpdate);
                }
            }, (error) => {
                this.isLoading = false;
                this.notification.error("Si è vericato un errore non previsto.", error.statusText, { nzDuration: 0 });
            });
        });
    }
    savePrize(id) {
        const data = this.dataSet.find((item) => item.id === id);
        const prize = data.prize === true ? 1 : 0;
        let query = "UPDATE chk_orders SET `prize`=" + prize + " WHERE `id`=" + data.id;
        // console.log(query);
        this.isLoading = true;
        this.g.mysql(query).subscribe((resUpdate) => {
            this.isLoading = false;
            if (resUpdate.error === false) {
                this.message.success("Modifica completata con successo!");
                this.loadData();
            }
            else {
                this.notification.error("Si è verificato un problema, si prega di riprovare tra qualche minuto.", resUpdate.message, { nzDuration: 0 });
                // console.log(resUpdate);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto.", error.statusText, { nzDuration: 0 });
        });
    }
    deleteRow(id) {
        const index = this.dataSet.findIndex((item) => item.id === id);
        const query = 'DELETE FROM chk_orders WHERE `code`= "' + this.dataSet[index].code + '"';
        this.isLoading = true;
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.dataSet.splice(index, 1);
                this.message.success("Cancellazione completata con successo!");
                this.updateEditCache();
            }
            else {
                this.notification.error("Si è verificato un problema, si prega di riprovare tra qualche minuto.", res.message, { nzDuration: 0 });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto.", error.statusText, { nzDuration: 0 });
        });
    }
    updateEditCache() {
        if (this.dataSet != null) {
            this.dataSet.forEach((item) => {
                if (!this.editCache[item.id]) {
                    this.editCache[item.id] = {
                        edit: false,
                        data: item,
                    };
                }
            });
        }
        if (this.orderFilter.length > 0) {
            this.filterChange(null);
        }
        else {
            this.displayData = [...this.dataSet];
        }
    }
    calcH(orderId) {
        const query = "SELECT SUM(chk_times.h) AS h FROM chk_times" +
            " WHERE `orderId`=" +
            orderId;
        this.g.mysql(query).subscribe((res) => {
            const index = this.dataSet.findIndex((item) => item.id === orderId);
            this.dataSet[index].total = res.data[0].h ? res.data[0].h : 0;
        });
    }
    isNull(val) {
        return typeof val === "number";
    }
    calcPrize(o) {
        var deltaH;
        if (o.forecast != 0)
            deltaH = o.forecast - o.total;
        else
            deltaH = o.total;
        //if (deltaH <= 0) return 0;
        const costH = deltaH * o.costH;
        const costM = o.costM - o.costMReal;
        const prizeValue = Math.round((costH + costM) / 2);
        return prizeValue;
    }
};
OrdiniComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_3__["GlobalComponent"] },
    { type: _home_component__WEBPACK_IMPORTED_MODULE_4__["HomeComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__["NzNotificationService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__["NzMessageService"] }
];
OrdiniComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-ordini",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./ordini.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/ordini/ordini.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./ordini.component.scss */ "./src/home/ordini/ordini.component.scss")).default]
    })
], OrdiniComponent);



/***/ }),

/***/ "./src/home/premi-report/premi-report.scss":
/*!*************************************************!*\
  !*** ./src/home/premi-report/premi-report.scss ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-table {\n  padding-top: 60px;\n}\n:host ::ng-deep .ant-pagination {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n}\n:host ::ng-deep .ant-input-number,\n:host ::ng-deep .ant-select {\n  width: 100% !important;\n}\n:host ::ng-deep .ant-card-body {\n  padding-top: 10px;\n}\n:host ::ng-deep .newCard button {\n  width: 100%;\n}\n:host ::ng-deep .ordini-select-wrapper {\n  position: absolute;\n  top: 0;\n}\n:host ::ng-deep .ordini-select {\n  padding: 16px;\n  z-index: 99;\n}\n:host ::ng-deep .ordini-select button {\n  height: 30px;\n}\n:host ::ng-deep .ordini-select button span > span {\n  padding: 10px;\n  color: #000;\n}\n:host ::ng-deep .ordini-select .ant-switch-checked {\n  background-color: #a5f8ac;\n}\n:host ::ng-deep .ordini-select .ant-switch-checked::after {\n  top: 5px;\n}\n:host ::ng-deep .ordini-select .ant-switch::after {\n  top: 5px;\n}\n:host ::ng-deep .prize-select button span > span {\n  color: #000;\n}\n:host ::ng-deep .prize-select .ant-switch-checked {\n  background-color: #a5f8ac;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/home/premi-report/premi-report.ts":
/*!***********************************************!*\
  !*** ./src/home/premi-report/premi-report.ts ***!
  \***********************************************/
/*! exports provided: PremiReportComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PremiReportComponent", function() { return PremiReportComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _home_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../home.component */ "./src/home/home.component.ts");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");






let PremiReportComponent = class PremiReportComponent {
    constructor(g, datepipe, home, notification, message) {
        this.g = g;
        this.datepipe = datepipe;
        this.home = home;
        this.notification = notification;
        this.message = message;
        // TABLE VARS
        this.formatterEuro = (value) => `€ ${value}`;
        this.parserEuro = (value) => value.replace("€ ", "");
        this.rangeDate = [];
        this.rangePlace = ["Da data", "A Data"];
        this.dateFormat = "dd/MM/yyyy";
        this.dataSet = [];
        this.displayData = [...this.dataSet];
        this.editCache = {};
        // COMPONENT VARS
        this.isLoading = false;
        this.destinatario = "all";
        this.destinatari = [];
        this.totPrize = 0;
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 10;
        this.g.homeTitle = "Report Premi";
    }
    loadData() {
        this.isLoading = true;
        let query = "SELECT * from chk_orders WHERE `status`= 0" +
            " AND `prize`= 1" +
            " AND  `date`>= '" +
            this.datepipe.transform(this.rangeDate[0], "yyyy-MM-dd") +
            "' AND `date`<= '" +
            this.datepipe.transform(this.rangeDate[1], "yyyy-MM-dd") +
            "' ORDER BY `id` DESC";
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            this.dataSet = res.data;
            this.dataSet.forEach((e) => {
                if (e.prize) {
                    this.calcH(e.id);
                    e["prizeTotal"] = this.calcPrize(e);
                    this.totPrize += e["prizeTotal"];
                }
            });
            this.updateEditCache();
            // console.log(this.dataSet);
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: 0 });
        });
        query = "SELECT name, surname, email FROM chk_users WHERE `email` > ''";
        this.g.mysql(query).subscribe((res) => {
            this.destinatari = res.data;
        });
    }
    updateEditCache() {
        if (this.dataSet != null) {
            this.dataSet.forEach((item) => {
                if (!this.editCache[item.id]) {
                    this.editCache[item.id] = {
                        edit: false,
                        data: item,
                    };
                }
            });
        }
        this.displayData = [...this.dataSet];
    }
    calcH(orderId) {
        const query = "SELECT SUM(chk_times.h) AS h FROM chk_times" +
            " WHERE `orderId`=" +
            orderId;
        this.g.mysql(query).subscribe((res) => {
            const index = this.dataSet.findIndex((item) => item.id === orderId);
            this.dataSet[index].total = res.data[0].h ? res.data[0].h : 0;
        });
    }
    isNull(val) {
        return typeof val === "number";
    }
    calcPrize(o) {
        var deltaH;
        if (o.forecast != 0)
            deltaH = o.forecast - o.total;
        else
            deltaH = o.total;
        // if (deltaH <= 0) return 0;
        const costH = deltaH * o.costH;
        const costM = o.costM - o.costMReal;
        // console.log(
        //   "id",
        //   o.id,
        //   "o.forecast",
        //   o.forecast,
        //   "o.total",
        //   o.total,
        //   "deltaH",
        //   deltaH
        // );
        const prizeValue = Math.round((costH + costM) / 2);
        return prizeValue;
    }
    sendMail() {
        let destinatari = "";
        if (this.destinatario == "all") {
            this.destinatari.forEach((d) => {
                destinatari += d["email"] + ",";
            });
        }
        else {
            destinatari = this.destinatario;
        }
        this.isLoading = true;
        const da = this.datepipe.transform(this.rangeDate[0], "dd-MM-yyyy");
        const a = this.datepipe.transform(this.rangeDate[1], "dd-MM-yyyy");
        this.g.sendPremi(destinatari, this.dataSet, da, a, this.totPrize).subscribe((res) => {
            this.isLoading = false;
            this.notification.success("Email inviata", "Operazione completata con successo", { nzDuration: this.g.fastTime });
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: 0 });
        });
    }
};
PremiReportComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_5__["GlobalComponent"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"] },
    { type: _home_component__WEBPACK_IMPORTED_MODULE_4__["HomeComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzNotificationService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] }
];
PremiReportComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-premi-report",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./premi-report.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/premi-report/premi-report.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./premi-report.scss */ "./src/home/premi-report/premi-report.scss")).default]
    })
], PremiReportComponent);



/***/ }),

/***/ "./src/home/rfid-gg/rfid-gg.component.scss":
/*!*************************************************!*\
  !*** ./src/home/rfid-gg/rfid-gg.component.scss ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-table {\n  padding-top: 60px;\n}\n:host ::ng-deep .ant-pagination {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n}\n:host ::ng-deep .ant-input-number,\n:host ::ng-deep .ant-select {\n  width: 100% !important;\n}\n:host ::ng-deep .ant-card-body {\n  padding-top: 10px;\n}\n:host ::ng-deep .newCard button {\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ob21lL3JmaWQtZ2cvQzpcXFVzZXJzXFxTb3VyY2VzXFxXZWJDaGVja1xcd2ViY2hlY2suZW1zb2Z0Lml0L3NyY1xcaG9tZVxccmZpZC1nZ1xccmZpZC1nZy5jb21wb25lbnQuc2NzcyIsInNyYy9ob21lL3JmaWQtZ2cvcmZpZC1nZy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFSTtFQUNFLGlCQUFBO0FDRE47QURHSTtFQUNFLGtCQUFBO0VBQ0EsUUFBQTtFQUNBLFVBQUE7QUNETjtBREdJOztFQUVFLHNCQUFBO0FDRE47QURHSTtFQUNFLGlCQUFBO0FDRE47QURHSTtFQUNFLFdBQUE7QUNETiIsImZpbGUiOiJzcmMvaG9tZS9yZmlkLWdnL3JmaWQtZ2cuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBjb21wb25lbnQgY3NzIGdvZXMgaGVyZVxuOmhvc3QgOjpuZy1kZWVwIHtcbiAgICAuYW50LXRhYmxlIHtcbiAgICAgIHBhZGRpbmctdG9wOiA2MHB4O1xuICAgIH1cbiAgICAuYW50LXBhZ2luYXRpb24ge1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgdG9wOiAwcHg7XG4gICAgICByaWdodDogMHB4O1xuICAgIH1cbiAgICAuYW50LWlucHV0LW51bWJlcixcbiAgICAuYW50LXNlbGVjdCB7XG4gICAgICB3aWR0aDogMTAwJSAhaW1wb3J0YW50O1xuICAgIH1cbiAgICAuYW50LWNhcmQtYm9keSB7XG4gICAgICBwYWRkaW5nLXRvcDogMTBweDtcbiAgICB9XG4gICAgLm5ld0NhcmQgYnV0dG9uIHtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgIH1cbiAgfVxuICAiLCI6aG9zdCA6Om5nLWRlZXAgLmFudC10YWJsZSB7XG4gIHBhZGRpbmctdG9wOiA2MHB4O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5hbnQtcGFnaW5hdGlvbiB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwcHg7XG4gIHJpZ2h0OiAwcHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLmFudC1pbnB1dC1udW1iZXIsXG46aG9zdCA6Om5nLWRlZXAgLmFudC1zZWxlY3Qge1xuICB3aWR0aDogMTAwJSAhaW1wb3J0YW50O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5hbnQtY2FyZC1ib2R5IHtcbiAgcGFkZGluZy10b3A6IDEwcHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLm5ld0NhcmQgYnV0dG9uIHtcbiAgd2lkdGg6IDEwMCU7XG59Il19 */");

/***/ }),

/***/ "./src/home/rfid-gg/rfid-gg.component.ts":
/*!***********************************************!*\
  !*** ./src/home/rfid-gg/rfid-gg.component.ts ***!
  \***********************************************/
/*! exports provided: RfidGgComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RfidGgComponent", function() { return RfidGgComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let RfidGgComponent = class RfidGgComponent {
    constructor(g, notification, datepipe, message) {
        this.g = g;
        this.notification = notification;
        this.datepipe = datepipe;
        this.message = message;
        // TABLE VARS
        this.dataSet = [];
        this.displayData = [...this.dataSet];
        this.editCache = {};
        this.sortName = null;
        this.sortValue = null;
        // COMPONENT VARS
        this.newTempo = { id: new Date(), date: new Date(), userId: '', orderId: '', h: 0 };
        this.newCodeError = 'validating';
        this.isLoading = true;
        this.isSpinning = false;
        this.companyData = _environments_global__WEBPACK_IMPORTED_MODULE_4__["Aziende"];
        this.orderData = [];
        this.userData = [];
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
        this.loadData();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 5;
        this.g.homeTitle = 'Tabella Ingressi giornaliera';
    }
    loadData() {
        this.isSpinning = true;
        const query = 'Select ' +
            'chk_rfid.code, ' +
            'chk_users.name, ' +
            'chk_users.surname, ' +
            'chk_users.company, ' +
            'chk_rfid.time_enter, ' +
            'chk_rfid.time_exit, ' +
            'chk_rfid.marked ' +
            'FROM ' +
            'chk_rfid Left Join ' +
            'chk_users On chk_users.code = chk_rfid.code ' +
            'ORDER BY chk_rfid.code, chk_rfid.time_enter';
        console.log(query);
        return this.g.mysql(query)
            .subscribe((res) => {
            this.isLoading = false;
            this.isSpinning = false;
            // ################ PACK DATA
            let newTime;
            let lastTime = 0;
            let lastCode = -1;
            let lastCompany = '';
            let lastName = '';
            let lastSurname = '';
            let totHrs = 0;
            let lastMark = 0;
            let dtDiff = 0;
            res.data.forEach(d => {
                if (d.code !== lastCode) {
                    // INSERT PREV
                    if (totHrs !== 0) {
                        // console.log('ADD NEW DIP', lastCode);
                        this.addRow(lastCode, lastCompany, lastName, lastSurname, lastTime, totHrs, lastMark);
                    }
                    lastCode = d.code;
                    lastName = d.name;
                    lastSurname = d.surname;
                    lastCompany = d.company;
                    lastTime = 0;
                    totHrs = 0;
                    lastMark = 1;
                }
                lastMark = lastMark * d.marked;
                if (d.time_exit !== 0) {
                    dtDiff = this.g.diffTime(d.time_enter, d.time_exit); // Math.round(Math.abs(d.time_exit - d.time_enter) / 36e5 * 100) / 100;
                }
                else {
                    dtDiff = 0;
                }
                newTime = new Date(d.time_enter).setHours(0, 0, 0, 0);
                if (lastTime !== newTime) {
                    if (totHrs !== 0) {
                        // console.log('ADD NEW DAY', lastCode, lastTime);
                        this.addRow(lastCode, lastCompany, lastName, lastSurname, lastTime, totHrs, lastMark);
                    }
                    lastTime = newTime;
                    totHrs = dtDiff;
                }
                else {
                    totHrs += dtDiff;
                }
                // console.log('DIFF', d.time_enter, d.time_exit, dtDiff);
            });
            if (totHrs !== 0) {
                this.addRow(lastCode, lastCompany, lastName, lastSurname, lastTime, totHrs, lastMark);
            }
            // this.sort({ key: 'time', value: 'ascending' });
            this.dataSet.sort(function (a, b) {
                return b['time'] - a['time'] || a['anem'] - b['name'];
            });
            this.updateEditCache();
        }, (error) => {
            this.isLoading = false;
            this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: this.g.normalTime });
        });
    }
    addRow(code, compamy, name, surname, time, totH, marked) {
        this.dataSet.push({
            code: code,
            company: compamy, name: name, surname: surname,
            time: time,
            totH: totH,
            marked: marked
        });
    }
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        if (this.sortName) {
            this.displayData = [...this.dataSet.sort((a, b) => (this.sortValue === 'ascend') ?
                    (a[this.sortName] > b[this.sortName] ? 1 : -1) : (b[this.sortName] > a[this.sortName] ? 1 : -1))];
        }
        else {
            this.displayData = [...this.dataSet];
        }
    }
    deleteRow(code, enter) {
        const index = this.dataSet.findIndex(item => item.code === code);
        const query = 'DELETE FROM chk_rfid WHERE '
            + '`code`= ' + code + ' AND '
            + '`time_enter`= ' + enter.toString();
        this.isLoading = true;
        this.g.mysql(query)
            .subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.dataSet.splice(index, 1);
                this.message.success('Cancellazione completata con successo!');
                this.updateEditCache();
            }
            else {
                this.notification.error('Si è verificato un problema, si prega di riprovare tra qualche minuto.', res.message, { nzDuration: this.g.normalTime });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error('Si è vericato un errore non previsto.', error.statusText, { nzDuration: 0 });
        });
    }
    updateEditCache() {
        if (this.dataSet != null) {
            this.dataSet.forEach(item => {
                if (!this.editCache[item.id]) {
                    this.editCache[item.id] = {
                        edit: false,
                        data: item
                    };
                }
            });
        }
        this.displayData = [...this.dataSet];
    }
};
RfidGgComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzNotificationService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] }
];
RfidGgComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-rfid',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./rfid-gg.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/rfid-gg/rfid-gg.component.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./rfid-gg.component.scss */ "./src/home/rfid-gg/rfid-gg.component.scss")).default]
    })
], RfidGgComponent);



/***/ }),

/***/ "./src/home/rfid/rfid.component.scss":
/*!*******************************************!*\
  !*** ./src/home/rfid/rfid.component.scss ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-table {\n  padding-top: 60px;\n}\n:host ::ng-deep .ant-pagination {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n}\n:host ::ng-deep .ant-input-number,\n:host ::ng-deep .ant-select {\n  width: 100% !important;\n}\n:host ::ng-deep .ant-card-body {\n  padding-top: 10px;\n}\n:host ::ng-deep .newCard button {\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ob21lL3JmaWQvQzpcXFVzZXJzXFxTb3VyY2VzXFxXZWJDaGVja1xcd2ViY2hlY2suZW1zb2Z0Lml0L3NyY1xcaG9tZVxccmZpZFxccmZpZC5jb21wb25lbnQuc2NzcyIsInNyYy9ob21lL3JmaWQvcmZpZC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFSTtFQUNFLGlCQUFBO0FDRE47QURHSTtFQUNFLGtCQUFBO0VBQ0EsUUFBQTtFQUNBLFVBQUE7QUNETjtBREdJOztFQUVFLHNCQUFBO0FDRE47QURHSTtFQUNFLGlCQUFBO0FDRE47QURHSTtFQUNFLFdBQUE7QUNETiIsImZpbGUiOiJzcmMvaG9tZS9yZmlkL3JmaWQuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBjb21wb25lbnQgY3NzIGdvZXMgaGVyZVxuOmhvc3QgOjpuZy1kZWVwIHtcbiAgICAuYW50LXRhYmxlIHtcbiAgICAgIHBhZGRpbmctdG9wOiA2MHB4O1xuICAgIH1cbiAgICAuYW50LXBhZ2luYXRpb24ge1xuICAgICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgICAgdG9wOiAwcHg7XG4gICAgICByaWdodDogMHB4O1xuICAgIH1cbiAgICAuYW50LWlucHV0LW51bWJlcixcbiAgICAuYW50LXNlbGVjdCB7XG4gICAgICB3aWR0aDogMTAwJSAhaW1wb3J0YW50O1xuICAgIH1cbiAgICAuYW50LWNhcmQtYm9keSB7XG4gICAgICBwYWRkaW5nLXRvcDogMTBweDtcbiAgICB9XG4gICAgLm5ld0NhcmQgYnV0dG9uIHtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgIH1cbiAgfVxuICAiLCI6aG9zdCA6Om5nLWRlZXAgLmFudC10YWJsZSB7XG4gIHBhZGRpbmctdG9wOiA2MHB4O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5hbnQtcGFnaW5hdGlvbiB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwcHg7XG4gIHJpZ2h0OiAwcHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLmFudC1pbnB1dC1udW1iZXIsXG46aG9zdCA6Om5nLWRlZXAgLmFudC1zZWxlY3Qge1xuICB3aWR0aDogMTAwJSAhaW1wb3J0YW50O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5hbnQtY2FyZC1ib2R5IHtcbiAgcGFkZGluZy10b3A6IDEwcHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLm5ld0NhcmQgYnV0dG9uIHtcbiAgd2lkdGg6IDEwMCU7XG59Il19 */");

/***/ }),

/***/ "./src/home/rfid/rfid.component.ts":
/*!*****************************************!*\
  !*** ./src/home/rfid/rfid.component.ts ***!
  \*****************************************/
/*! exports provided: RfidComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RfidComponent", function() { return RfidComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let RfidComponent = class RfidComponent {
    constructor(g, notification, datepipe, message) {
        this.g = g;
        this.notification = notification;
        this.datepipe = datepipe;
        this.message = message;
        // TABLE VARS
        this.dataSet = [];
        this.displayData = [...this.dataSet];
        this.editCache = {};
        this.sortName = null;
        this.sortValue = null;
        // COMPONENT VARS
        this.newTempo = {
            id: new Date(),
            date: new Date(),
            userId: "",
            orderId: "",
            h: 0,
        };
        this.newCodeError = "validating";
        this.isLoading = true;
        this.isSpinning = false;
        this.companyData = _environments_global__WEBPACK_IMPORTED_MODULE_4__["Aziende"];
        this.orderData = [];
        this.usersData = [];
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
        this.loadData();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 4;
        this.g.homeTitle = "Tabella Ingressi";
    }
    loadData() {
        this.isSpinning = true;
        const query = "Select " +
            "chk_rfid.code, " +
            "chk_users.name, " +
            "chk_users.surname, " +
            "chk_users.company, " +
            "chk_rfid.time_enter, " +
            "chk_rfid.time_exit, " +
            "chk_rfid.marked " +
            "FROM " +
            "chk_rfid Left Join " +
            "chk_users On chk_users.code = chk_rfid.code " +
            "ORDER BY chk_rfid.time_enter DESC";
        this.g.mysql(query).subscribe((res) => {
            this.dataSet = res.data;
            const query = "SELECT * from chk_users";
            this.g.mysql(query).subscribe((resUser) => {
                this.usersData = resUser.data;
                this.isLoading = false;
                this.isSpinning = false;
                this.updateEditCache();
            });
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: this.g.normalTime });
        });
    }
    loadFilter() {
        if (!this.selectedUser || !this.selectedMonth) {
            this.displayData = [...this.dataSet];
            return;
        }
        // Estrai mese e anno selezionati
        const selectedMonth = this.selectedMonth.getMonth(); // 0-11
        const selectedYear = this.selectedMonth.getFullYear();
        this.displayData = [...this.dataSet.filter((item) => {
                const sameName = item.name === this.selectedUser.name;
                const sameSurname = item.surname === this.selectedUser.surname;
                const itemDate = new Date(item.time_enter);
                const sameMonth = itemDate.getMonth() === selectedMonth;
                const sameYear = itemDate.getFullYear() === selectedYear;
                return sameName && sameSurname && sameMonth && sameYear;
            })];
    }
    cancelFilter() {
        this.selectedUser = null;
        this.selectedMonth = null;
        this.displayData = [...this.dataSet];
    }
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        if (this.sortName) {
            this.displayData = [
                ...this.dataSet.sort((a, b) => this.sortValue === "ascend"
                    ? a[this.sortName] > b[this.sortName]
                        ? 1
                        : -1
                    : b[this.sortName] > a[this.sortName]
                        ? 1
                        : -1),
            ];
        }
        else {
            this.displayData = [...this.dataSet];
        }
    }
    deleteRow(code, enter) {
        const index = this.dataSet.findIndex((item) => item.code === code);
        const query = "DELETE FROM chk_rfid WHERE " +
            "`code`= " +
            code +
            " AND " +
            "`time_enter`= " +
            enter.toString();
        this.isLoading = true;
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.dataSet.splice(index, 1);
                this.message.success("Cancellazione completata con successo!");
                this.updateEditCache();
            }
            else {
                this.notification.error("Si è verificato un problema, si prega di riprovare tra qualche minuto.", res.message, { nzDuration: this.g.normalTime });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error("Si è vericato un errore non previsto.", error.statusText, { nzDuration: 0 });
        });
    }
    updateEditCache() {
        if (this.dataSet != null) {
            this.dataSet.forEach((item) => {
                if (!this.editCache[item.id]) {
                    this.editCache[item.id] = {
                        edit: false,
                        data: item,
                    };
                }
            });
        }
        this.displayData = [...this.dataSet];
    }
};
RfidComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzNotificationService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] }
];
RfidComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-rfid",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./rfid.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/rfid/rfid.component.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./rfid.component.scss */ "./src/home/rfid/rfid.component.scss")).default]
    })
], RfidComponent);



/***/ }),

/***/ "./src/home/tempi/tempi.component.scss":
/*!*********************************************!*\
  !*** ./src/home/tempi/tempi.component.scss ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-table {\n  padding-top: 60px;\n}\n:host ::ng-deep .ant-pagination {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n}\n:host ::ng-deep .ant-input-number,\n:host ::ng-deep .ant-select {\n  width: 100% !important;\n}\n:host ::ng-deep .ant-card-body {\n  padding-top: 10px;\n}\n:host ::ng-deep .newCard button {\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9ob21lL3RlbXBpL0M6XFxVc2Vyc1xcU291cmNlc1xcV2ViQ2hlY2tcXHdlYmNoZWNrLmVtc29mdC5pdC9zcmNcXGhvbWVcXHRlbXBpXFx0ZW1waS5jb21wb25lbnQuc2NzcyIsInNyYy9ob21lL3RlbXBpL3RlbXBpLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVJO0VBQ0UsaUJBQUE7QUNETjtBREdJO0VBQ0Usa0JBQUE7RUFDQSxRQUFBO0VBQ0EsVUFBQTtBQ0ROO0FER0k7O0VBRUUsc0JBQUE7QUNETjtBREdJO0VBQ0UsaUJBQUE7QUNETjtBREdJO0VBQ0UsV0FBQTtBQ0ROIiwiZmlsZSI6InNyYy9ob21lL3RlbXBpL3RlbXBpLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gY29tcG9uZW50IGNzcyBnb2VzIGhlcmVcbjpob3N0IDo6bmctZGVlcCB7XG4gICAgLmFudC10YWJsZSB7XG4gICAgICBwYWRkaW5nLXRvcDogNjBweDtcbiAgICB9XG4gICAgLmFudC1wYWdpbmF0aW9uIHtcbiAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgIHRvcDogMHB4O1xuICAgICAgcmlnaHQ6IDBweDtcbiAgICB9XG4gICAgLmFudC1pbnB1dC1udW1iZXIsXG4gICAgLmFudC1zZWxlY3Qge1xuICAgICAgd2lkdGg6IDEwMCUgIWltcG9ydGFudDtcbiAgICB9XG4gICAgLmFudC1jYXJkLWJvZHkge1xuICAgICAgcGFkZGluZy10b3A6IDEwcHg7XG4gICAgfVxuICAgIC5uZXdDYXJkIGJ1dHRvbiB7XG4gICAgICB3aWR0aDogMTAwJTtcbiAgICB9XG4gIH1cbiAgIiwiOmhvc3QgOjpuZy1kZWVwIC5hbnQtdGFibGUge1xuICBwYWRkaW5nLXRvcDogNjBweDtcbn1cbjpob3N0IDo6bmctZGVlcCAuYW50LXBhZ2luYXRpb24ge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMHB4O1xuICByaWdodDogMHB4O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5hbnQtaW5wdXQtbnVtYmVyLFxuOmhvc3QgOjpuZy1kZWVwIC5hbnQtc2VsZWN0IHtcbiAgd2lkdGg6IDEwMCUgIWltcG9ydGFudDtcbn1cbjpob3N0IDo6bmctZGVlcCAuYW50LWNhcmQtYm9keSB7XG4gIHBhZGRpbmctdG9wOiAxMHB4O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5uZXdDYXJkIGJ1dHRvbiB7XG4gIHdpZHRoOiAxMDAlO1xufSJdfQ== */");

/***/ }),

/***/ "./src/home/tempi/tempi.component.ts":
/*!*******************************************!*\
  !*** ./src/home/tempi/tempi.component.ts ***!
  \*******************************************/
/*! exports provided: TempiComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TempiComponent", function() { return TempiComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let TempiComponent = class TempiComponent {
    constructor(g, notification, datepipe, message) {
        this.g = g;
        this.notification = notification;
        this.datepipe = datepipe;
        this.message = message;
        // TABLE VARS
        this.dataSet = [];
        this.displayData = [...this.dataSet];
        this.editCache = {};
        this.sortName = null;
        this.sortValue = null;
        // COMPONENT VARS
        this.newTempo = { id: new Date(), date: new Date(), userId: '', orderId: '', h: 0 };
        this.newCodeError = 'validating';
        this.isLoading = true;
        this.isSpinning = false;
        this.companyData = _environments_global__WEBPACK_IMPORTED_MODULE_4__["Aziende"];
        this.orderData = [];
        this.usersData = [];
        this.ordersData = [];
        this.selectedUsers = [];
        this.selectedOrders = [];
        // ##########
        this.insertActive = false;
        this.setup();
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.setup();
        this.loadOrders();
        this.loadInserts();
    }
    setup() {
        // SETUP INTERFACE
        this.g.menuState = 3;
        this.g.homeTitle = 'Tabella Tempi';
    }
    loadInserts() {
        let query = 'SELECT * from chk_users';
        this.g.mysql(query)
            .subscribe((res) => {
            this.usersData = res.data;
        }, (error) => {
            this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: 0 });
        });
        query = 'SELECT * from chk_orders WHERE `status`= 1';
        this.g.mysql(query)
            .subscribe((res) => {
            this.ordersData = res.data;
        }, (error) => {
            this.isSpinning = false;
            this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: 0 });
        });
    }
    selectOrders() {
        if (this.insertCompany) {
            this.selectedOrders = this.ordersData.filter(o => o.company === this.insertCompany);
            this.insertOrder = null;
        }
    }
    selectUsers() {
        this.selectedUsers = this.usersData.filter(u => u.company === this.selectedCompany);
        this.insertUser = null;
    }
    saveLine() {
        let query = 'INSERT INTO chk_times (id, date, userId, orderId, h) VALUES';
        const key = this.datepipe.transform(new Date(), 'yyyyMMddHHmmss');
        query += '(' + key + ',' +
            '"' + this.datepipe.transform(this.insertDay, 'yyyy-MM-dd') + '",' +
            this.insertUser.id + ',' +
            this.insertOrder.id + ',' +
            this.insertHr + ')';
        this.g.mysql(query)
            .subscribe((res) => {
            this.notification.success('Modifica completata', 'Operazione completata con successo.', { nzDuration: this.g.fastTime });
            this.updateEditCache();
            this.insertUser = null;
            this.insertOrder = null;
            this.insertDay = null;
            this.insertHr = null;
            this.insertCompany = null;
            this.insertActive = false;
        }, (error) => {
            this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: 0 });
        });
    }
    loadOrders() {
        this.isSpinning = true;
        const query = 'SELECT * from chk_orders';
        return this.g.mysql(query)
            .subscribe((res) => {
            this.isLoading = false;
            this.orderData = res.data;
            this.isSpinning = false;
        }, (error) => {
            this.isLoading = false;
            this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: this.g.normalTime });
        });
    }
    loadTimes() {
        const startDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth(), 1);
        const endDate = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 0);
        // const query: string = 'SELECT * from chk_times INNER JOIN chk_users ON chk_users.id = chk_times.userId' +
        //                     ' WHERE `company` = "' + this.selectedCompany + '"' +
        //                     ' AND `date`>= "' + this.datepipe.transform(startDate, 'yyyy-MM-dd') + '"' +
        //                     ' AND `date`<= "' + this.datepipe.transform(endDate, 'yyyy-MM-dd') + '" ORDER BY `date` DESC';
        const query = 'SELECT * from chk_users INNER JOIN chk_times ON chk_users.id = chk_times.userId' +
            ' WHERE `company` = "' + this.selectedCompany + '"' +
            ' AND `date`>= "' + this.datepipe.transform(startDate, 'yyyy-MM-dd') + '"' +
            ' AND `date`<= "' + this.datepipe.transform(endDate, 'yyyy-MM-dd') + '" ORDER BY `date` DESC';
        return this.g.mysql(query)
            .subscribe((res) => {
            this.isLoading = false;
            this.dataSet = res.data;
            //  console.log(res.data[0]); // ##########################################
            this.updateEditCache();
        }, (error) => {
            this.isLoading = false;
            this.notification.error('Si è vericato un errore non previsto', error.statusText, { nzDuration: this.g.normalTime });
        });
    }
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        if (this.sortName) {
            this.displayData = [...this.dataSet.sort((a, b) => (this.sortValue === 'ascend') ?
                    (a[this.sortName] > b[this.sortName] ? 1 : -1) : (b[this.sortName] > a[this.sortName] ? 1 : -1))];
        }
        else {
            this.displayData = [...this.dataSet];
        }
    }
    startEdit(id) {
        this.editCache[id].edit = true;
    }
    cancelEdit(id) {
        this.editCache[id].edit = false;
    }
    getOrder(orderId) {
        const res = this.orderData.find(o => o.id === orderId);
        if (res) {
            return res.code + ' - ' + res.title;
        }
        else {
            return '(non trovato)';
        }
    }
    saveEdit(id) {
        const data = this.editCache[id].data;
        const index = this.dataSet.findIndex(item => item.id === id);
        this.dataSet[index] = this.editCache[id].data;
        this.editCache[id].edit = false;
        const query = 'UPDATE chk_times SET `h`="' + data.h +
            '", `date`="' + this.datepipe.transform(data.date, 'yyyy-MM-dd') +
            '" where `id`="' + data.id + '"';
        this.isLoading = true;
        this.g.mysql(query)
            .subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.notification.success('Modifica completata', 'Operazione completata con successo.', { nzDuration: this.g.fastTime });
                this.updateEditCache();
            }
            else {
                this.notification.error('Si è verificato un problema, si prega di riprovare tra qualche minuto.', res.message, { nzDuration: 0 });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error('Si è vericato un errore non previsto.', error.statusText, { nzDuration: 0 });
        });
    }
    deleteRow(id) {
        const index = this.dataSet.findIndex(item => item.id === id);
        const query = 'DELETE FROM chk_times WHERE `id`= ' + id;
        this.isLoading = true;
        this.g.mysql(query)
            .subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.dataSet.splice(index, 1);
                this.message.success('Cancellazione completata con successo!');
                this.updateEditCache();
            }
            else {
                this.notification.error('Si è verificato un problema, si prega di riprovare tra qualche minuto.', res.message, { nzDuration: this.g.normalTime });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error('Si è vericato un errore non previsto.', error.statusText, { nzDuration: 0 });
        });
    }
    updateEditCache() {
        if (this.dataSet != null) {
            this.dataSet.forEach(item => {
                if (!this.editCache[item.id]) {
                    this.editCache[item.id] = {
                        edit: false,
                        data: item
                    };
                }
            });
        }
        this.displayData = [...this.dataSet];
    }
};
TempiComponent.ctorParameters = () => [
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzNotificationService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] }
];
TempiComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-tempi',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./tempi.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/home/tempi/tempi.component.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./tempi.component.scss */ "./src/home/tempi/tempi.component.scss")).default]
    })
], TempiComponent);



/***/ }),

/***/ "./src/login/login.component.scss":
/*!****************************************!*\
  !*** ./src/login/login.component.scss ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .loginCol {\n  max-width: 800px;\n  text-align: left;\n}\n:host ::ng-deep .ant-input {\n  padding: 30px;\n  font-size: 18px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9sb2dpbi9DOlxcVXNlcnNcXFNvdXJjZXNcXFdlYkNoZWNrXFx3ZWJjaGVjay5lbXNvZnQuaXQvc3JjXFxsb2dpblxcbG9naW4uY29tcG9uZW50LnNjc3MiLCJzcmMvbG9naW4vbG9naW4uY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0U7RUFDRSxnQkFBQTtFQUNBLGdCQUFBO0FDQUo7QURFRTtFQUNFLGFBQUE7RUFDQSxlQUFBO0FDQUoiLCJmaWxlIjoic3JjL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3QgOjpuZy1kZWVwIHtcbiAgLmxvZ2luQ29sIHtcbiAgICBtYXgtd2lkdGg6IDgwMHB4O1xuICAgIHRleHQtYWxpZ246IGxlZnQ7XG4gIH1cbiAgLmFudC1pbnB1dCB7XG4gICAgcGFkZGluZzogMzBweDtcbiAgICBmb250LXNpemU6IDE4cHg7XG4gIH1cbn1cbiIsIjpob3N0IDo6bmctZGVlcCAubG9naW5Db2wge1xuICBtYXgtd2lkdGg6IDgwMHB4O1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5hbnQtaW5wdXQge1xuICBwYWRkaW5nOiAzMHB4O1xuICBmb250LXNpemU6IDE4cHg7XG59Il19 */");

/***/ }),

/***/ "./src/login/login.component.ts":
/*!**************************************!*\
  !*** ./src/login/login.component.ts ***!
  \**************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../environments/global */ "./src/environments/global.ts");





let LoginComponent = class LoginComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(router, g, message) {
        this.router = router;
        this.g = g;
        this.message = message;
        this.txtPassword = "";
        this.isSpinning = false;
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() { }
    // ################################################
    // LOGIN
    login() {
        this.g.userLogin = {
            password: this.txtPassword,
            logged: false,
            restricted: false,
            onlyorders: false
        };
        this.isSpinning = true;
        this.g.login().subscribe((res) => {
            this.isSpinning = false;
            if (res.error === false) {
                this.message.success("Codice accettato");
                this.g.userLogin = res.data;
                sessionStorage.setItem("webcheck", JSON.stringify(this.g.userLogin));
                this.router.navigateByUrl("/home");
            }
            else {
                this.message.warning(res.message);
            }
        }, (error) => {
            this.isSpinning = false;
            this.message.warning('Si è vericato un errore non previsto:<br>"' + error.statusText + '"');
        });
    }
};
LoginComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__["NzMessageService"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-login",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.scss */ "./src/login/login.component.scss")).default]
    })
], LoginComponent);



/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.log(err));


/***/ }),

/***/ "./src/track/check/check.component.scss":
/*!**********************************************!*\
  !*** ./src/track/check/check.component.scss ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-table {\n  padding-bottom: 130px;\n}\n:host ::ng-deep .ant-table-pagination {\n  position: fixed;\n  bottom: 20px;\n  right: 10px;\n  font-size: 30px;\n}\n:host ::ng-deep .ant-pagination-item,\n:host ::ng-deep .ant-pagination-disabled,\n:host ::ng-deep .ant-pagination-item-link,\n:host ::ng-deep .ant-pagination-prev,\n:host ::ng-deep .ant-pagination-next {\n  width: 100px;\n  height: 100px;\n  line-height: 100px;\n}\n:host ::ng-deep .ant-pagination-item-link::after {\n  font-size: 48px;\n}\n:host ::ng-deep .big {\n  font-size: 18px;\n  line-height: 29.4px;\n}\n:host ::ng-deep .ant-table-thead > tr > th,\n:host ::ng-deep .ant-table-tbody > tr > td {\n  padding: 8px 16px;\n}\n:host ::ng-deep .ant-table-row:nth-child(odd) {\n  background-color: #fafafa;\n}\n:host ::ng-deep .back {\n  position: fixed;\n  bottom: 35px;\n  left: 10px;\n  width: 320px;\n  height: 100px;\n  font-size: 30px;\n}\n:host ::ng-deep .fixed-header {\n  background: #52c41a;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/track/check/check.component.ts":
/*!********************************************!*\
  !*** ./src/track/check/check.component.ts ***!
  \********************************************/
/*! exports provided: CheckComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckComponent", function() { return CheckComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let CheckComponent = class CheckComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(router, g, message) {
        this.router = router;
        this.g = g;
        this.message = message;
        // TABLE VARS
        this.dataSet = [];
        // COMPONENT VARS
        this.isLoading = true;
    }
    ngOnInit() {
        this.loadData();
    }
    loadData() {
        this.isLoading = true;
        const query = 'SELECT * from chk_times INNER JOIN chk_orders' +
            ' ON chk_times.orderId = chk_orders.id' +
            ' WHERE `userId`=' + this.g.userData.id + ' ORDER BY DATE DESC LIMIT 20';
        this.g.mysql(query)
            .subscribe((res) => {
            this.isLoading = false;
            console.log(res.data);
            this.dataSet = res.data;
        }, (error) => {
            this.isLoading = false;
            this.message.error('Si è vericato un errore non previsto:<br>' + error.statusText, { nzDuration: 5000 });
        });
    }
    goOrders() {
        this.router.navigateByUrl('/track/(trackContent:ordine)');
    }
};
CheckComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] }
];
CheckComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-check',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./check.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/track/check/check.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./check.component.scss */ "./src/track/check/check.component.scss")).default]
    })
], CheckComponent);



/***/ }),

/***/ "./src/track/insert/insert.component.scss":
/*!************************************************!*\
  !*** ./src/track/insert/insert.component.scss ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-table {\n  padding-bottom: 130px;\n}\n:host ::ng-deep .ant-table-pagination {\n  position: fixed;\n  bottom: 20px;\n  left: 10px;\n  font-size: 30px;\n}\n:host ::ng-deep .ant-pagination-item,\n:host ::ng-deep .ant-pagination-disabled,\n:host ::ng-deep .ant-pagination-item-link,\n:host ::ng-deep .ant-pagination-prev,\n:host ::ng-deep .ant-pagination-next {\n  width: 100px;\n  height: 100px;\n  line-height: 100px;\n}\n:host ::ng-deep .ant-pagination-item-link {\n  height: 100px !important;\n}\n:host ::ng-deep .ant-pagination-simple-pager {\n  height: 100px;\n  margin-right: 30px;\n}\n:host ::ng-deep .ant-pagination-simple-pager input {\n  pointer-events: none;\n  background: transparent;\n}\n:host ::ng-deep .ant-pagination-item-link::after {\n  font-size: 48px;\n}\n:host ::ng-deep .no-break {\n  white-space: nowrap;\n}\n:host ::ng-deep .big {\n  font-size: 32px;\n  line-height: 75px;\n}\n:host ::ng-deep .ant-table-thead > tr > th,\n:host ::ng-deep .ant-table-tbody > tr > td {\n  padding: 8px 16px;\n}\n:host ::ng-deep .ant-table-row:nth-child(odd) {\n  background-color: #fafafa;\n}\n:host ::ng-deep .premio-wrapper {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  text-align: center;\n  line-height: 240%;\n}\n:host ::ng-deep .premio-left {\n  width: 50%;\n  background-color: #d4e4b6;\n}\n:host ::ng-deep .premio-right {\n  width: 50%;\n  background-color: #bbe66d;\n}\n:host ::ng-deep .save {\n  position: fixed;\n  bottom: 35px;\n  right: 10px;\n}\n:host ::ng-deep .save .col {\n  display: inline-flex;\n}\n:host ::ng-deep .save .col-wrapper {\n  font-size: 3em;\n  padding: 15px 30px;\n  text-align: left;\n  background-color: #e9b90e;\n  color: white;\n  border-radius: 30px;\n  margin-right: 30px;\n  text-align: center;\n}\n:host ::ng-deep .save .col-wrapper .col-label {\n  font-size: 18px;\n}\n:host ::ng-deep .save .col-success {\n  background-color: #bbe66d;\n}\n:host ::ng-deep .save button {\n  width: 200px;\n  height: 100px;\n  font-size: 30px;\n}\n:host ::ng-deep .check {\n  position: fixed;\n  top: 10px;\n  right: 10px;\n  width: 250px;\n  height: 45px;\n  font-size: 20px;\n}\n:host ::ng-deep button {\n  font-size: 50px;\n  line-height: 50px;\n  min-height: 100px;\n  min-width: 100px;\n  border-radius: 10px;\n  padding-bottom: 8px;\n}\n:host ::ng-deep .ant-switch-loading-icon,\n:host ::ng-deep .ant-switch::after {\n  height: 99%;\n  box-shadow: none;\n}\n:host ::ng-deep .ant-switch-inner {\n  font-size: 20px;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/track/insert/insert.component.ts":
/*!**********************************************!*\
  !*** ./src/track/insert/insert.component.ts ***!
  \**********************************************/
/*! exports provided: InsertComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InsertComponent", function() { return InsertComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");






let InsertComponent = class InsertComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(router, route, g, datepipe, message) {
        this.router = router;
        this.route = route;
        this.g = g;
        this.datepipe = datepipe;
        this.message = message;
        // TABLE VARS
        this.dataSet = [];
        this.backupSet = [];
        this.sumH = 0;
        // COMPONENT VARS
        this.isLoading = true;
        this.trackTitle = "";
        this.prizeFilter = false;
        this.totStimato = 0;
        this.totLavorato = 0;
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        if (!this.g.checkUserData()) {
            this.router.navigateByUrl("/track/(trackContent:utente)");
        }
        // SETUP TITLE
        this.trackTitle = this.g.userData.name + " " + this.g.userData.surname;
        this.init();
    }
    // ################################################
    // FUNCTION: INIT
    init() {
        if (this.g.userData.times.length <= 0) {
            this.router.navigateByUrl("/track/(trackContent:utente)");
            return;
        }
        // LOAD DATA
        this.loadData();
        this.dateH = new Date(this.g.userData.times[0].time);
        this.totH = this.g.roundToHalfDown(this.g.userData.times[0].totH);
        // console.log("USERDATA", this.g.userData);
    }
    // ################################################
    // FUNCTION: LOAD DATA
    loadData() {
        this.isLoading = true;
        const query = 'SELECT * from chk_orders WHERE `company`="' +
            this.g.userData.company +
            '" and `status` = true';
        this.g.mysql(query).subscribe((res) => {
            this.isLoading = false;
            this.dataSet = res.data;
            this.dataSet.forEach((d) => {
                d["h"] = 0.0;
                if (d.prize) {
                    this.calcH(d.id);
                }
                if (d.prize) {
                    this.totStimato += d.forecast;
                    this.totLavorato += d.total;
                }
            });
            this.backupSet = this.dataSet;
            this.sumH = this.dataSet.reduce(function (prev, cur) {
                return prev + cur.h;
            }, 0);
            console.log("SUMH", this.sumH, this.totH);
        }, (error) => {
            this.isLoading = false;
            this.message.error("Si è vericato un errore non previsto:<br>" + error.statusText, { nzDuration: 5000 });
        });
    }
    filterData() {
        if (this.prizeFilter) {
            this.dataSet = this.backupSet.filter(this.isPrice);
        }
        else {
            this.dataSet = this.backupSet;
        }
    }
    isPrice(e, index, array) {
        return e.prize == true;
    }
    calcH(orderId) {
        const query = "SELECT SUM(chk_times.h) AS h FROM chk_times" +
            " WHERE `orderId`=" +
            orderId;
        this.g.mysql(query).subscribe((res) => {
            const index = this.dataSet.findIndex((item) => item.id === orderId);
            this.dataSet[index].total = res.data[0].h ? res.data[0].h : 0;
        });
    }
    selectRow(id) {
        this.router.navigateByUrl("/track/(trackContent:tempo)?orderid=" + id);
    }
    goback() {
        this.g.userData = {};
        this.router.navigateByUrl("/track/(trackContent:utente)");
    }
    gocheck() {
        this.router.navigateByUrl("/track/(trackContent:check)");
    }
    saveInsert() {
        if (this.sumH > 0) {
            let query = "INSERT INTO chk_times (id, date, userId, orderId, h) VALUES";
            let key = this.datepipe.transform(new Date(), "yyyyMMddHHmmss");
            this.dataSet.forEach((d) => {
                if (d["h"] > 0) {
                    query +=
                        "(" +
                            key +
                            "," +
                            '"' +
                            this.datepipe.transform(this.dateH, "yyyy-MM-dd") +
                            '",' +
                            this.g.userData.id +
                            "," +
                            d.id +
                            "," +
                            d.h +
                            "),";
                    let nKey = parseInt(key, 0);
                    nKey++;
                    key = nKey.toString();
                }
            });
            query = query.substring(0, query.length - 1);
            this.isLoading = true;
            this.g.mysql(query).subscribe((resQuery) => {
                if (!resQuery.error) {
                    query =
                        "UPDATE chk_rfid set `marked` = 1 WHERE `code` = " +
                            '"' +
                            this.g.userData.code +
                            '" AND `marked` = 0 ' +
                            "AND `time_enter` in (" +
                            this.g.userData.times[0].enters.join(",") +
                            ")";
                    this.isLoading = true;
                    this.g.mysql(query).subscribe((rfidQuery) => {
                        if (!rfidQuery.error) {
                            this.g.userData.times.shift();
                            this.init();
                            this.message.success("Aggiornamento completato con successo", {
                                nzDuration: 3000,
                            });
                        }
                        else {
                            this.goback();
                            this.message.error("Si è verificato un errore, riprovare", {
                                nzDuration: 3000,
                            });
                        }
                    });
                }
                else {
                    this.message.error("Si è verificato un errore, riprovare", {
                        nzDuration: 3000,
                    });
                }
            });
        }
        else {
            this.goback();
        }
    }
    setH(code, type) {
        const obj = this.dataSet.find((d) => d.code === code);
        if (type === "+") {
            obj.h += 0.5;
        }
        else {
            obj.h -= 0.5;
        }
        this.sumH = this.dataSet.reduce(function (prev, cur) {
            return prev + cur.h;
        }, 0);
        // console.log('TOTH', this.totH, 'SUMH', this.sumH);
    }
};
InsertComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_5__["GlobalComponent"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_3__["DatePipe"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_4__["NzMessageService"] }
];
InsertComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-data",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./insert.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/track/insert/insert.component.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_3__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./insert.component.scss */ "./src/track/insert/insert.component.scss")).default]
    })
], InsertComponent);



/***/ }),

/***/ "./src/track/ordine/ordine.component.scss":
/*!************************************************!*\
  !*** ./src/track/ordine/ordine.component.scss ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep .ant-table {\n  padding-bottom: 130px;\n}\n:host ::ng-deep .ant-table-pagination {\n  position: fixed;\n  bottom: 20px;\n  right: 10px;\n  font-size: 30px;\n}\n:host ::ng-deep .ant-pagination-item, :host ::ng-deep .ant-pagination-disabled, :host ::ng-deep .ant-pagination-item-link, :host ::ng-deep .ant-pagination-prev, :host ::ng-deep .ant-pagination-next {\n  width: 100px;\n  height: 100px;\n  line-height: 100px;\n}\n:host ::ng-deep .ant-pagination-item-link::after {\n  font-size: 48px;\n}\n:host ::ng-deep .big {\n  font-size: 32px;\n  line-height: 75px;\n}\n:host ::ng-deep .ant-table-thead > tr > th, :host ::ng-deep .ant-table-tbody > tr > td {\n  padding: 8px 16px;\n}\n:host ::ng-deep .ant-table-row:nth-child(odd) {\n  background-color: #fafafa;\n}\n:host ::ng-deep .back {\n  position: fixed;\n  bottom: 35px;\n  left: 10px;\n  width: 160px;\n  height: 100px;\n  font-size: 30px;\n}\n:host ::ng-deep .check {\n  position: fixed;\n  top: 10px;\n  right: 10px;\n  width: 250px;\n  height: 45px;\n  font-size: 20px;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/track/ordine/ordine.component.ts":
/*!**********************************************!*\
  !*** ./src/track/ordine/ordine.component.ts ***!
  \**********************************************/
/*! exports provided: OrdineComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrdineComponent", function() { return OrdineComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let OrdineComponent = class OrdineComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(router, g, message) {
        this.router = router;
        this.g = g;
        this.message = message;
        // TABLE VARS
        this.dataSet = [];
        // COMPONENT VARS
        this.isLoading = true;
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        if (!this.g.checkUserData()) {
            this.router.navigateByUrl('/track/(trackContent:utente)');
        }
        // SETUP TITLE
        this.g.trackTitle = '<i nz-icon nzType="user"></i> ' + this.g.userData.name + ' ' + this.g.userData.surname;
        // LOAD DATA
        this.loadData();
    }
    loadData() {
        this.isLoading = true;
        const query = 'SELECT * from chk_orders WHERE `company`="' + this.g.userData.company + '" and `status` = true';
        this.g.mysql(query)
            .subscribe((res) => {
            this.isLoading = false;
            this.dataSet = res.data;
        }, (error) => {
            this.isLoading = false;
            this.message.error('Si è vericato un errore non previsto:<br>' + error.statusText, { nzDuration: 5000 });
        });
    }
    selectRow(id) {
        this.router.navigateByUrl('/track/(trackContent:tempo)?orderid=' + id);
    }
    goback() {
        this.g.userData = {};
        this.router.navigateByUrl('/track/(trackContent:utente)');
    }
    gocheck() {
        this.router.navigateByUrl('/track/(trackContent:check)');
    }
};
OrdineComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] }
];
OrdineComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-data',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./ordine.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/track/ordine/ordine.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./ordine.component.scss */ "./src/track/ordine/ordine.component.scss")).default]
    })
], OrdineComponent);



/***/ }),

/***/ "./src/track/tempo/tempo.component.scss":
/*!**********************************************!*\
  !*** ./src/track/tempo/tempo.component.scss ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep {\n  text-align: center;\n}\n:host ::ng-deep .ant-layout {\n  height: 100%;\n}\n:host ::ng-deep .title {\n  font-size: 2em;\n  color: #303030;\n  font-family: Roboto;\n  font-weight: bold;\n}\n:host ::ng-deep button {\n  font-size: 50px;\n  line-height: 50px;\n  min-height: 100px;\n  min-width: 100px;\n  margin: 10px 20px;\n  border-radius: 10px;\n}\n:host ::ng-deep .double {\n  min-width: 240px;\n}\n:host ::ng-deep input {\n  margin: 20px;\n  font-size: 60px;\n  line-height: 60px;\n  width: 370px;\n  height: 100px;\n  text-align: center;\n  border-radius: 10px;\n  letter-spacing: 5px;\n}\n:host ::ng-deep .ant-input-disabled {\n  background-color: #d6ffd8;\n  color: #303030;\n}\n:host ::ng-deep .input-red {\n  background-color: #ffdbd6;\n}\n:host ::ng-deep .col-right {\n  align-self: center;\n}\n:host ::ng-deep .btnAdd {\n  color: #52c41a;\n}\n:host ::ng-deep .btnRemove {\n  color: #c4581a;\n}\n:host ::ng-deep .col-right button {\n  width: 150px;\n  height: 150px;\n  font-size: 100px;\n  background-color: #fff;\n  border-color: #d9d9d9;\n}\n:host ::ng-deep .col-right button[disabled] {\n  color: #e7e8e9;\n  background-color: transparent;\n  border: none;\n  font-size: 150px;\n}\n:host ::ng-deep .col-right button:active {\n  background-color: #d6ffd8;\n}\n:host ::ng-deep .dateField {\n  text-align: center;\n  font-size: 50px;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/track/tempo/tempo.component.ts":
/*!********************************************!*\
  !*** ./src/track/tempo/tempo.component.ts ***!
  \********************************************/
/*! exports provided: TempoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TempoComponent", function() { return TempoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");






let TempoComponent = class TempoComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(router, g, notification, datepipe, message) {
        this.router = router;
        this.g = g;
        this.notification = notification;
        this.datepipe = datepipe;
        this.message = message;
        this.dateH = new Date();
        this.dateString = this.dateH.toISOString().substring(0, 10);
        this.numH = '0';
        this.isLoading = false;
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        const snapshot = this.router.routerState.snapshot;
        const params = snapshot.root.queryParams;
        if (typeof params.orderid === 'undefined') {
            this.router.navigateByUrl('/track/(trackContent:ordine)');
            return;
        }
        const orderId = +params.orderid;
        Object.keys(this.g.userData.ordini).forEach(key => {
            if (this.g.userData.ordini[key].id === orderId) {
                this.ordine = this.g.userData.ordini[key];
                return true;
            }
        });
        if (typeof this.ordine.id === 'undefined') {
            this.router.navigateByUrl('/track/(trackContent:ordine)');
            return;
        }
        this.g.trackTitle = '<i nz-icon nzType="file-text"></i> ' + this.ordine.title;
        if (this.ordine.date) {
            this.dateH = new Date(this.ordine.date);
            this.dateString = this.dateH.toISOString().substring(0, 10);
        }
        if (this.ordine.h) {
            this.numH = this.ordine.h.toString();
        }
    }
    addNumber(strNum) {
        if (strNum === '.') {
            if (this.numH.indexOf('.') < 0) {
                this.numH += '.';
            }
        }
        else if (Number(this.numH) < 99) {
            const dec = this.numH.indexOf('.');
            if (dec > 0) {
                if (this.numH.length - 1 === dec) {
                    this.numH += strNum;
                }
            }
            else if (this.numH !== '0') {
                this.numH += strNum;
            }
            else if (strNum !== '0') {
                this.numH = strNum;
            }
        }
    }
    clearNumber() {
        this.numH = '0';
    }
    changeDate(n) {
        this.dateH.setDate(this.dateH.getDate() + n);
        this.dateString = this.dateH.toISOString().substring(0, 10);
    }
    todayDate() {
        this.dateH = new Date();
        this.dateString = this.dateH.toISOString().substring(0, 10);
    }
    addH() {
        let query;
        let msg;
        if (this.ordine.h) {
            this.numH = this.numH.replace(',', '.');
            query = 'UPDATE chk_times SET `h`="' + this.numH + '",' +
                '`date`="' + this.datepipe.transform(this.dateH, 'yyyy-MM-dd') + '" WHERE ' +
                '`userId`=' + this.g.userData.id + ' AND ' +
                '`orderId`=' + this.ordine.id + ' AND ' +
                '`date`="' + this.datepipe.transform(this.ordine.date, 'yyyy-MM-dd') + '"';
            msg = 'Modifica effettuata con successo!';
        }
        else {
            query = 'INSERT INTO chk_times (`id`, `date`, `userid`, `orderid`, `h`) VALUES ("' +
                this.datepipe.transform(this.dateH, 'yyyyMMddHHmmss') + '",' +
                '"' + this.datepipe.transform(this.dateH, 'yyyy-MM-dd') + '",' +
                '"' + this.g.userData.id + '",' +
                '"' + this.ordine.id + '",' +
                +this.numH + ')';
            msg = 'Nuovo inserimento creato con successo!';
        }
        this.isLoading = true;
        this.g.mysql(query)
            .subscribe((res) => {
            this.isLoading = false;
            if (res.error === false) {
                this.ordine.date = this.dateH;
                this.ordine.h = Number(this.numH);
                this.message.success(msg);
                this.router.navigateByUrl('/track/(trackContent:ordine)');
            }
            else {
                this.notification.error('Si è verificato un problema, si prega di riprovare tra qualche minuto.', res.message, { nzDuration: this.g.normalTime });
                console.log(res);
            }
        }, (error) => {
            this.isLoading = false;
            this.notification.error('Si è vericato un errore non previsto.', error.statusText, { nzDuration: 0 });
        });
    }
    removeH() {
        if (this.ordine.h) {
            const query = 'DELETE FROM chk_times WHERE ' +
                '`userId`=' + this.g.userData.id + ' AND ' +
                '`orderId`=' + this.ordine.id + ' AND ' +
                '`date`="' + this.datepipe.transform(this.ordine.date, 'yyyy-MM-dd') + '"';
            this.isLoading = true;
            this.g.mysql(query)
                .subscribe((res) => {
                this.isLoading = false;
                if (res.error === false) {
                    this.ordine.date = null;
                    this.ordine.h = null;
                    this.message.success('Cancellazione effettua con successo!');
                    this.router.navigateByUrl('/track/(trackContent:ordine)');
                }
                else {
                    this.notification.error('Si è verificato un problema, si prega di riprovare tra qualche minuto.', res.message, { nzDuration: this.g.normalTime });
                    console.log(res);
                }
            }, (error) => {
                this.isLoading = false;
                this.notification.error('Si è vericato un errore non previsto.', error.statusText, { nzDuration: 0 });
            });
        }
        else {
            this.router.navigateByUrl('/track/(trackContent:ordine)');
        }
    }
};
TempoComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_5__["GlobalComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_4__["NzNotificationService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_3__["DatePipe"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_4__["NzMessageService"] }
];
TempoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-data',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./tempo.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/track/tempo/tempo.component.html")).default,
        providers: [_angular_common__WEBPACK_IMPORTED_MODULE_3__["DatePipe"]],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./tempo.component.scss */ "./src/track/tempo/tempo.component.scss")).default]
    })
], TempoComponent);



/***/ }),

/***/ "./src/track/track.component.scss":
/*!****************************************!*\
  !*** ./src/track/track.component.scss ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep {\n  text-align: center;\n}\n:host ::ng-deep .active, :host ::ng-deep .ant-table-thead > tr.active.ant-table-row-hover > td, :host ::ng-deep .ant-table-tbody > tr.active.ant-table-row-hover > td, :host ::ng-deep .ant-table-thead > tr:hover > td, :host ::ng-deep .ant-table-tbody > tr.active:hover > td {\n  background-color: #fffde6;\n}\n:host ::ng-deep .title {\n  font-size: 50px;\n  color: #fff;\n  font-family: Roboto;\n}\n:host ::ng-deep nz-footer {\n  background-color: #e9b90e;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy90cmFjay9DOlxcVXNlcnNcXFNvdXJjZXNcXFdlYkNoZWNrXFx3ZWJjaGVjay5lbXNvZnQuaXQvc3JjXFx0cmFja1xcdHJhY2suY29tcG9uZW50LnNjc3MiLCJzcmMvdHJhY2svdHJhY2suY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxrQkFBQTtBQ0NGO0FERUU7RUFDRSx5QkFBQTtBQ0FKO0FER0U7RUFDRSxlQUFBO0VBQ0EsV0FBQTtFQUNBLG1CQUFBO0FDREo7QURHRTtFQUNFLHlCQUFBO0FDREoiLCJmaWxlIjoic3JjL3RyYWNrL3RyYWNrLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3QgOjpuZy1kZWVwIHtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuXG4gIC8vIEFDVElWRSBST1cgQkFDS0dSVU5EIGFuZCBIT1ZFUiBDT0xPUlxuICAuYWN0aXZlLCAuYW50LXRhYmxlLXRoZWFkID4gdHIuYWN0aXZlLmFudC10YWJsZS1yb3ctaG92ZXIgPiB0ZCwgLmFudC10YWJsZS10Ym9keSA+IHRyLmFjdGl2ZS5hbnQtdGFibGUtcm93LWhvdmVyID4gdGQsIC5hbnQtdGFibGUtdGhlYWQgPiB0cjpob3ZlciA+IHRkLCAuYW50LXRhYmxlLXRib2R5ID4gdHIuYWN0aXZlOmhvdmVyID4gdGQge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNmZmZkZTY7XG4gIH1cblxuICAudGl0bGUge1xuICAgIGZvbnQtc2l6ZTogNTBweDtcbiAgICBjb2xvcjogI2ZmZjtcbiAgICBmb250LWZhbWlseTogUm9ib3RvO1xuICB9XG4gIG56LWZvb3RlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2U5YjkwZTtcbiAgfVxufSIsIjpob3N0IDo6bmctZGVlcCB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cbjpob3N0IDo6bmctZGVlcCAuYWN0aXZlLCA6aG9zdCA6Om5nLWRlZXAgLmFudC10YWJsZS10aGVhZCA+IHRyLmFjdGl2ZS5hbnQtdGFibGUtcm93LWhvdmVyID4gdGQsIDpob3N0IDo6bmctZGVlcCAuYW50LXRhYmxlLXRib2R5ID4gdHIuYWN0aXZlLmFudC10YWJsZS1yb3ctaG92ZXIgPiB0ZCwgOmhvc3QgOjpuZy1kZWVwIC5hbnQtdGFibGUtdGhlYWQgPiB0cjpob3ZlciA+IHRkLCA6aG9zdCA6Om5nLWRlZXAgLmFudC10YWJsZS10Ym9keSA+IHRyLmFjdGl2ZTpob3ZlciA+IHRkIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZmRlNjtcbn1cbjpob3N0IDo6bmctZGVlcCAudGl0bGUge1xuICBmb250LXNpemU6IDUwcHg7XG4gIGNvbG9yOiAjZmZmO1xuICBmb250LWZhbWlseTogUm9ib3RvO1xufVxuOmhvc3QgOjpuZy1kZWVwIG56LWZvb3RlciB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNlOWI5MGU7XG59Il19 */");

/***/ }),

/***/ "./src/track/track.component.ts":
/*!**************************************!*\
  !*** ./src/track/track.component.ts ***!
  \**************************************/
/*! exports provided: TrackComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrackComponent", function() { return TrackComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../environments/global */ "./src/environments/global.ts");




let TrackComponent = class TrackComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(router, route, g) {
        this.router = router;
        this.route = route;
        this.g = g;
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.router.navigateByUrl('/track/(trackContent:utente)');
        // #################################################################################################### DEBUG
        // this.g.userData.ordini = JSON.parse(localStorage.getItem('webcheck'));
        // this.router.navigateByUrl('/track/(trackContent:insert)');
    }
};
TrackComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_3__["GlobalComponent"] }
];
TrackComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./track.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/track/track.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./track.component.scss */ "./src/track/track.component.scss")).default]
    })
], TrackComponent);



/***/ }),

/***/ "./src/track/utente/utente.component.scss":
/*!************************************************!*\
  !*** ./src/track/utente/utente.component.scss ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host ::ng-deep {\n  text-align: center;\n}\n:host ::ng-deep .ant-layout {\n  height: 100%;\n}\n:host ::ng-deep .ant-layout-header {\n  background-color: #e9b90e;\n}\n:host ::ng-deep .title {\n  font-size: 2em;\n  color: #303030;\n  font-family: Roboto;\n  font-weight: bold;\n}\n:host ::ng-deep button {\n  font-size: 50px;\n  line-height: 50px;\n  min-height: 100px;\n  min-width: 100px;\n  margin: 10px 20px;\n  border-radius: 10px;\n}\n:host ::ng-deep .double {\n  min-width: 240px;\n}\n:host ::ng-deep .keypad-input input {\n  margin: 20px;\n  font-size: 60px;\n  line-height: 60px;\n  width: 370px;\n  height: 100px;\n  text-align: center;\n  border-radius: 10px;\n  letter-spacing: 5px;\n}\n:host ::ng-deep .keypad-input .ant-input-disabled {\n  background-color: #fff6d6;\n  color: #303030;\n}\n:host ::ng-deep .fix-right {\n  position: absolute;\n  height: 100%;\n  right: 50px;\n  display: flex;\n  align-items: center;\n  top: 0;\n}\n:host ::ng-deep .fix-left {\n  position: absolute;\n  height: 100%;\n  left: 50px;\n  display: flex;\n  align-items: center;\n  top: 0;\n  width: 25%;\n}\n:host ::ng-deep .fix-left span {\n  height: 64px;\n}\n:host ::ng-deep .fix-left span input {\n  font-size: 30px;\n  height: 64px;\n}\n:host ::ng-deep .fix-left span i {\n  font-size: 30px;\n}\n:host ::ng-deep .fix-right button {\n  width: 150px;\n  height: 150px;\n  font-size: 100px;\n  background-color: #fff;\n  color: #52c41a;\n}\n:host ::ng-deep .fix-right button[disabled] {\n  color: #e7e8e9;\n  background-color: transparent;\n  border: none;\n  font-size: 150px;\n}\n:host ::ng-deep .fix-right button:active {\n  color: #fff;\n  background-color: #52c41a;\n}\n:host ::ng-deep .message {\n  position: absolute;\n  top: 68px;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 92px);\n  font-size: 4em;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  transition: opacity 1s;\n  -webkit-transition: opacity 1s;\n}\n:host ::ng-deep .messageIn {\n  opacity: 1;\n  pointer-events: unset;\n}\n:host ::ng-deep .messageOut {\n  opacity: 0;\n  pointer-events: none;\n}\n:host ::ng-deep .messageIngresso {\n  background-color: mediumseagreen;\n}\n:host ::ng-deep .messageUscita {\n  background-color: #aa3c3c;\n}\n.ant-message {\n  font-size: 3em !important;\n}\n.ant-message i {\n  font-size: 3em;\n}\n.button-line {\n  display: inline-block;\n}\n.button-line .ant-btn {\n  height: 200px;\n  min-width: 600px;\n}\n.button-line .ant-btn:hover {\n  color: #303030;\n  background-color: mediumseagreen;\n}\n.noselect {\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Old versions of Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n     supported by Chrome, Opera and Firefox */\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy90cmFjay91dGVudGUvQzpcXFVzZXJzXFxTb3VyY2VzXFxXZWJDaGVja1xcd2ViY2hlY2suZW1zb2Z0Lml0L3NyY1xcdHJhY2tcXHV0ZW50ZVxcdXRlbnRlLmNvbXBvbmVudC5zY3NzIiwic3JjL3RyYWNrL3V0ZW50ZS91dGVudGUuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxrQkFBQTtBQ0NGO0FEQUU7RUFDRSxZQUFBO0FDRUo7QURBRTtFQUNFLHlCQUFBO0FDRUo7QURBRTtFQUNFLGNBQUE7RUFDQSxjQUFBO0VBQ0EsbUJBQUE7RUFDQSxpQkFBQTtBQ0VKO0FEQUU7RUFDRSxlQUFBO0VBQ0EsaUJBQUE7RUFDQSxpQkFBQTtFQUNBLGdCQUFBO0VBQ0EsaUJBQUE7RUFDQSxtQkFBQTtBQ0VKO0FEQUU7RUFDRSxnQkFBQTtBQ0VKO0FEQ0k7RUFDRSxZQUFBO0VBQ0EsZUFBQTtFQUNBLGlCQUFBO0VBQ0EsWUFBQTtFQUNBLGFBQUE7RUFDQSxrQkFBQTtFQUNBLG1CQUFBO0VBQ0EsbUJBQUE7QUNDTjtBRENJO0VBQ0UseUJBQUE7RUFDQSxjQUFBO0FDQ047QURFRTtFQUNFLGtCQUFBO0VBQ0EsWUFBQTtFQUNBLFdBQUE7RUFDQSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxNQUFBO0FDQUo7QURFRTtFQUNFLGtCQUFBO0VBQ0EsWUFBQTtFQUNBLFVBQUE7RUFDQSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxNQUFBO0VBQ0EsVUFBQTtBQ0FKO0FEQ0k7RUFDRSxZQUFBO0FDQ047QURBTTtFQUNFLGVBQUE7RUFDQSxZQUFBO0FDRVI7QURBTTtFQUNFLGVBQUE7QUNFUjtBREVFO0VBQ0UsWUFBQTtFQUNBLGFBQUE7RUFDQSxnQkFBQTtFQUNBLHNCQUFBO0VBQ0EsY0FBQTtBQ0FKO0FERUU7RUFDRSxjQUFBO0VBQ0EsNkJBQUE7RUFDQSxZQUFBO0VBQ0EsZ0JBQUE7QUNBSjtBREVFO0VBQ0UsV0FBQTtFQUNBLHlCQUFBO0FDQUo7QURHRTtFQUNFLGtCQUFBO0VBQ0EsU0FBQTtFQUNBLE9BQUE7RUFDQSxXQUFBO0VBQ0EseUJBQUE7RUFDQSxjQUFBO0VBQ0Esa0JBQUE7RUFDQSxhQUFBO0VBQ0Esc0JBQUE7RUFDQSx1QkFBQTtFQUNBLG1CQUFBO0VBQ0Esc0JBQUE7RUFDQSw4QkFBQTtBQ0RKO0FER0U7RUFDRSxVQUFBO0VBQ0EscUJBQUE7QUNESjtBREdFO0VBQ0UsVUFBQTtFQUNBLG9CQUFBO0FDREo7QURHRTtFQUNFLGdDQUFBO0FDREo7QURHRTtFQUNFLHlCQUFBO0FDREo7QURLQTtFQUNFLHlCQUFBO0FDRkY7QURHRTtFQUNFLGNBQUE7QUNESjtBREtBO0VBQ0UscUJBQUE7QUNGRjtBREdFO0VBQ0UsYUFBQTtFQUNBLGdCQUFBO0FDREo7QURHRTtFQUNFLGNBQUE7RUFDQSxnQ0FBQTtBQ0RKO0FES0E7RUFDRSwyQkFBQTtFQUE2QixlQUFBO0VBQzNCLHlCQUFBO0VBQTJCLFdBQUE7RUFDQSxtQkFBQTtFQUN4QixzQkFBQTtFQUF3Qiw0QkFBQTtFQUN2QixxQkFBQTtFQUF1QiwyQkFBQTtFQUNuQixpQkFBQTtFQUFtQjs2Q0FBQTtBQ0svQiIsImZpbGUiOiJzcmMvdHJhY2svdXRlbnRlL3V0ZW50ZS5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IDo6bmctZGVlcCB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgLmFudC1sYXlvdXQge1xuICAgIGhlaWdodDogMTAwJTtcbiAgfVxuICAuYW50LWxheW91dC1oZWFkZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6IHJnYigyMzMsIDE4NSwgMTQpO1xuICB9XG4gIC50aXRsZSB7XG4gICAgZm9udC1zaXplOiAyZW07XG4gICAgY29sb3I6ICMzMDMwMzA7XG4gICAgZm9udC1mYW1pbHk6IFJvYm90bztcbiAgICBmb250LXdlaWdodDogYm9sZDtcbiAgfVxuICBidXR0b24ge1xuICAgIGZvbnQtc2l6ZTogNTBweDtcbiAgICBsaW5lLWhlaWdodDogNTBweDtcbiAgICBtaW4taGVpZ2h0OiAxMDBweDtcbiAgICBtaW4td2lkdGg6IDEwMHB4O1xuICAgIG1hcmdpbjogMTBweCAyMHB4O1xuICAgIGJvcmRlci1yYWRpdXM6IDEwcHg7XG4gIH1cbiAgLmRvdWJsZSB7XG4gICAgbWluLXdpZHRoOiAyNDBweDtcbiAgfVxuICAua2V5cGFkLWlucHV0IHtcbiAgICBpbnB1dCB7XG4gICAgICBtYXJnaW46IDIwcHg7XG4gICAgICBmb250LXNpemU6IDYwcHg7XG4gICAgICBsaW5lLWhlaWdodDogNjBweDtcbiAgICAgIHdpZHRoOiAzNzBweDtcbiAgICAgIGhlaWdodDogMTAwcHg7XG4gICAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgICBib3JkZXItcmFkaXVzOiAxMHB4O1xuICAgICAgbGV0dGVyLXNwYWNpbmc6IDVweDtcbiAgICB9XG4gICAgLmFudC1pbnB1dC1kaXNhYmxlZCB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2IoMjU1LCAyNDYsIDIxNCk7XG4gICAgICBjb2xvcjogIzMwMzAzMDtcbiAgICB9XG4gIH1cbiAgLmZpeC1yaWdodCB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgICByaWdodDogNTBweDtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgdG9wOiAwO1xuICB9XG4gIC5maXgtbGVmdCB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBsZWZ0OiA1MHB4O1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICB0b3A6IDA7XG4gICAgd2lkdGg6IDI1JTtcbiAgICBzcGFuIHtcbiAgICAgIGhlaWdodDogNjRweDtcbiAgICAgIGlucHV0IHtcbiAgICAgICAgZm9udC1zaXplOiAzMHB4O1xuICAgICAgICBoZWlnaHQ6IDY0cHg7XG4gICAgICB9XG4gICAgICBpIHtcbiAgICAgICAgZm9udC1zaXplOiAzMHB4O1xuICAgICAgfVxuICAgIH1cbiAgfVxuICAuZml4LXJpZ2h0IGJ1dHRvbiB7XG4gICAgd2lkdGg6IDE1MHB4O1xuICAgIGhlaWdodDogMTUwcHg7XG4gICAgZm9udC1zaXplOiAxMDBweDtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmO1xuICAgIGNvbG9yOiAjNTJjNDFhO1xuICB9XG4gIC5maXgtcmlnaHQgYnV0dG9uW2Rpc2FibGVkXSB7XG4gICAgY29sb3I6ICNlN2U4ZTk7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgYm9yZGVyOiBub25lO1xuICAgIGZvbnQtc2l6ZTogMTUwcHg7XG4gIH1cbiAgLmZpeC1yaWdodCBidXR0b246YWN0aXZlIHtcbiAgICBjb2xvcjogI2ZmZjtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjNTJjNDFhO1xuICB9XG5cbiAgLm1lc3NhZ2Uge1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDY4cHg7XG4gICAgbGVmdDogMDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBoZWlnaHQ6IGNhbGMoMTAwJSAtIDkycHgpO1xuICAgIGZvbnQtc2l6ZTogNGVtO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICB0cmFuc2l0aW9uOiBvcGFjaXR5IDFzO1xuICAgIC13ZWJraXQtdHJhbnNpdGlvbjogb3BhY2l0eSAxcztcbiAgfVxuICAubWVzc2FnZUluIHtcbiAgICBvcGFjaXR5OiAxO1xuICAgIHBvaW50ZXItZXZlbnRzOiB1bnNldDtcbiAgfVxuICAubWVzc2FnZU91dCB7XG4gICAgb3BhY2l0eTogMDtcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgfVxuICAubWVzc2FnZUluZ3Jlc3NvIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiBtZWRpdW1zZWFncmVlbjtcbiAgfVxuICAubWVzc2FnZVVzY2l0YSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2FhM2MzYzsgIFxuICB9XG59XG5cbi5hbnQtbWVzc2FnZSB7XG4gIGZvbnQtc2l6ZTogM2VtICFpbXBvcnRhbnQ7XG4gIGkge1xuICAgIGZvbnQtc2l6ZTogM2VtO1xuICB9XG59XG5cbi5idXR0b24tbGluZSB7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgLmFudC1idG4ge1xuICAgIGhlaWdodDogMjAwcHg7XG4gICAgbWluLXdpZHRoOiA2MDBweDtcbiAgfVxuICAuYW50LWJ0bjpob3ZlciB7XG4gICAgY29sb3I6IzMwMzAzMDtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiBtZWRpdW1zZWFncmVlbjtcbiAgfVxufVxuXG4ubm9zZWxlY3Qge1xuICAtd2Via2l0LXRvdWNoLWNhbGxvdXQ6IG5vbmU7IC8qIGlPUyBTYWZhcmkgKi9cbiAgICAtd2Via2l0LXVzZXItc2VsZWN0OiBub25lOyAvKiBTYWZhcmkgKi9cbiAgICAgLWtodG1sLXVzZXItc2VsZWN0OiBub25lOyAvKiBLb25xdWVyb3IgSFRNTCAqL1xuICAgICAgIC1tb3otdXNlci1zZWxlY3Q6IG5vbmU7IC8qIE9sZCB2ZXJzaW9ucyBvZiBGaXJlZm94ICovXG4gICAgICAgIC1tcy11c2VyLXNlbGVjdDogbm9uZTsgLyogSW50ZXJuZXQgRXhwbG9yZXIvRWRnZSAqL1xuICAgICAgICAgICAgdXNlci1zZWxlY3Q6IG5vbmU7IC8qIE5vbi1wcmVmaXhlZCB2ZXJzaW9uLCBjdXJyZW50bHlcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBzdXBwb3J0ZWQgYnkgQ2hyb21lLCBPcGVyYSBhbmQgRmlyZWZveCAqL1xufSIsIjpob3N0IDo6bmctZGVlcCB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cbjpob3N0IDo6bmctZGVlcCAuYW50LWxheW91dCB7XG4gIGhlaWdodDogMTAwJTtcbn1cbjpob3N0IDo6bmctZGVlcCAuYW50LWxheW91dC1oZWFkZXIge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZTliOTBlO1xufVxuOmhvc3QgOjpuZy1kZWVwIC50aXRsZSB7XG4gIGZvbnQtc2l6ZTogMmVtO1xuICBjb2xvcjogIzMwMzAzMDtcbiAgZm9udC1mYW1pbHk6IFJvYm90bztcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG59XG46aG9zdCA6Om5nLWRlZXAgYnV0dG9uIHtcbiAgZm9udC1zaXplOiA1MHB4O1xuICBsaW5lLWhlaWdodDogNTBweDtcbiAgbWluLWhlaWdodDogMTAwcHg7XG4gIG1pbi13aWR0aDogMTAwcHg7XG4gIG1hcmdpbjogMTBweCAyMHB4O1xuICBib3JkZXItcmFkaXVzOiAxMHB4O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5kb3VibGUge1xuICBtaW4td2lkdGg6IDI0MHB4O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5rZXlwYWQtaW5wdXQgaW5wdXQge1xuICBtYXJnaW46IDIwcHg7XG4gIGZvbnQtc2l6ZTogNjBweDtcbiAgbGluZS1oZWlnaHQ6IDYwcHg7XG4gIHdpZHRoOiAzNzBweDtcbiAgaGVpZ2h0OiAxMDBweDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBib3JkZXItcmFkaXVzOiAxMHB4O1xuICBsZXR0ZXItc3BhY2luZzogNXB4O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5rZXlwYWQtaW5wdXQgLmFudC1pbnB1dC1kaXNhYmxlZCB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmZmY2ZDY7XG4gIGNvbG9yOiAjMzAzMDMwO1xufVxuOmhvc3QgOjpuZy1kZWVwIC5maXgtcmlnaHQge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGhlaWdodDogMTAwJTtcbiAgcmlnaHQ6IDUwcHg7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHRvcDogMDtcbn1cbjpob3N0IDo6bmctZGVlcCAuZml4LWxlZnQge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGhlaWdodDogMTAwJTtcbiAgbGVmdDogNTBweDtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgdG9wOiAwO1xuICB3aWR0aDogMjUlO1xufVxuOmhvc3QgOjpuZy1kZWVwIC5maXgtbGVmdCBzcGFuIHtcbiAgaGVpZ2h0OiA2NHB4O1xufVxuOmhvc3QgOjpuZy1kZWVwIC5maXgtbGVmdCBzcGFuIGlucHV0IHtcbiAgZm9udC1zaXplOiAzMHB4O1xuICBoZWlnaHQ6IDY0cHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLmZpeC1sZWZ0IHNwYW4gaSB7XG4gIGZvbnQtc2l6ZTogMzBweDtcbn1cbjpob3N0IDo6bmctZGVlcCAuZml4LXJpZ2h0IGJ1dHRvbiB7XG4gIHdpZHRoOiAxNTBweDtcbiAgaGVpZ2h0OiAxNTBweDtcbiAgZm9udC1zaXplOiAxMDBweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZjtcbiAgY29sb3I6ICM1MmM0MWE7XG59XG46aG9zdCA6Om5nLWRlZXAgLmZpeC1yaWdodCBidXR0b25bZGlzYWJsZWRdIHtcbiAgY29sb3I6ICNlN2U4ZTk7XG4gIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuICBib3JkZXI6IG5vbmU7XG4gIGZvbnQtc2l6ZTogMTUwcHg7XG59XG46aG9zdCA6Om5nLWRlZXAgLmZpeC1yaWdodCBidXR0b246YWN0aXZlIHtcbiAgY29sb3I6ICNmZmY7XG4gIGJhY2tncm91bmQtY29sb3I6ICM1MmM0MWE7XG59XG46aG9zdCA6Om5nLWRlZXAgLm1lc3NhZ2Uge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogNjhweDtcbiAgbGVmdDogMDtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogY2FsYygxMDAlIC0gOTJweCk7XG4gIGZvbnQtc2l6ZTogNGVtO1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICB0cmFuc2l0aW9uOiBvcGFjaXR5IDFzO1xuICAtd2Via2l0LXRyYW5zaXRpb246IG9wYWNpdHkgMXM7XG59XG46aG9zdCA6Om5nLWRlZXAgLm1lc3NhZ2VJbiB7XG4gIG9wYWNpdHk6IDE7XG4gIHBvaW50ZXItZXZlbnRzOiB1bnNldDtcbn1cbjpob3N0IDo6bmctZGVlcCAubWVzc2FnZU91dCB7XG4gIG9wYWNpdHk6IDA7XG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xufVxuOmhvc3QgOjpuZy1kZWVwIC5tZXNzYWdlSW5ncmVzc28ge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiBtZWRpdW1zZWFncmVlbjtcbn1cbjpob3N0IDo6bmctZGVlcCAubWVzc2FnZVVzY2l0YSB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNhYTNjM2M7XG59XG5cbi5hbnQtbWVzc2FnZSB7XG4gIGZvbnQtc2l6ZTogM2VtICFpbXBvcnRhbnQ7XG59XG4uYW50LW1lc3NhZ2UgaSB7XG4gIGZvbnQtc2l6ZTogM2VtO1xufVxuXG4uYnV0dG9uLWxpbmUge1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG59XG4uYnV0dG9uLWxpbmUgLmFudC1idG4ge1xuICBoZWlnaHQ6IDIwMHB4O1xuICBtaW4td2lkdGg6IDYwMHB4O1xufVxuLmJ1dHRvbi1saW5lIC5hbnQtYnRuOmhvdmVyIHtcbiAgY29sb3I6ICMzMDMwMzA7XG4gIGJhY2tncm91bmQtY29sb3I6IG1lZGl1bXNlYWdyZWVuO1xufVxuXG4ubm9zZWxlY3Qge1xuICAtd2Via2l0LXRvdWNoLWNhbGxvdXQ6IG5vbmU7XG4gIC8qIGlPUyBTYWZhcmkgKi9cbiAgLXdlYmtpdC11c2VyLXNlbGVjdDogbm9uZTtcbiAgLyogU2FmYXJpICovXG4gIC1raHRtbC11c2VyLXNlbGVjdDogbm9uZTtcbiAgLyogS29ucXVlcm9yIEhUTUwgKi9cbiAgLW1vei11c2VyLXNlbGVjdDogbm9uZTtcbiAgLyogT2xkIHZlcnNpb25zIG9mIEZpcmVmb3ggKi9cbiAgLW1zLXVzZXItc2VsZWN0OiBub25lO1xuICAvKiBJbnRlcm5ldCBFeHBsb3Jlci9FZGdlICovXG4gIHVzZXItc2VsZWN0OiBub25lO1xuICAvKiBOb24tcHJlZml4ZWQgdmVyc2lvbiwgY3VycmVudGx5XG4gICAgIHN1cHBvcnRlZCBieSBDaHJvbWUsIE9wZXJhIGFuZCBGaXJlZm94ICovXG59Il19 */");

/***/ }),

/***/ "./src/track/utente/utente.component.ts":
/*!**********************************************!*\
  !*** ./src/track/utente/utente.component.ts ***!
  \**********************************************/
/*! exports provided: UtenteComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UtenteComponent", function() { return UtenteComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _environments_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/global */ "./src/environments/global.ts");





let UtenteComponent = class UtenteComponent {
    // ################################################
    // CLASS: CONSTRUCTOR
    constructor(router, g, message) {
        this.router = router;
        this.g = g;
        this.message = message;
        this.code = "";
        this.isLoading = true;
        this.rfid = "";
        this.showIngresso = false;
        this.showUscita = false;
        this.totAllHrs = 0;
        // ##################### DEBUG
        this.code = "99999";
        this.loginRfid(false);
        // ###########################
    }
    // ################################################
    // CLASS: ON INIT
    ngOnInit() {
        this.g.trackTitle =
            '<i nz-icon nzType="lock"></i> Inserire il codice di accesso';
    }
    handleKeyboardEvent(event) {
        // AVOIT OVERLAPPING REGISTRATION
        if (this.showIngresso || this.showUscita) {
            return;
        }
        // console.log(event.key);
        if (event.key === "Enter") {
            this.loginRfid();
        }
        else if (event.key === "Escape") {
            this.loginRfid(false);
        }
        else if (event.key === "Backspace") {
            if (this.rfid.length > 0) {
                this.rfid = this.rfid.substring(0, this.rfid.length - 1);
            }
        }
        else {
            const key = event.key.replace(/[^0-9]/g, "");
            this.rfid += key;
        }
    }
    addNumber(num) {
        if (this.code.length < 5) {
            this.code += num;
        }
    }
    delNumber() {
        if (this.code.length > 0) {
            this.code = this.code.substring(0, this.code.length - 1);
        }
    }
    loginUtente() {
        this.g.loginUtente(this.code, this.rfid).subscribe((res) => {
            this.process(res);
            // if (res.error === false) {
            //     this.message.success('Codice accettato', { nzDuration: 2000 });
            //     this.isLoading = true;
            //     this.g.userData = res.data;
            //     const query: string = 'SELECT * from chk_orders WHERE `company`="' + this.g.userData.company + '" and `status` = true ORDER BY `code` DESC';
            //     this.g.mysql(query)
            //         .subscribe((resOrders: Result) => {
            //             this.isLoading = false;
            //             this.g.userData.ordini = resOrders.data;
            //             this.router.navigateByUrl('/track/(trackContent:ordine)');
            //         }, (error: HttpErrorResponse) => {
            //             this.isLoading = false;
            //             this.message.error('Si è vericato un errore non previsto:<br>' + error.statusText, { nzDuration: 5000 });
            //         });
            // } else {
            //     this.message.warning(res.message, { nzDuration: 5000 });
            //     this.code = '';
            //     this.rfid = '';
            // }
        }, (error) => {
            this.code = "";
            this.rfid = "";
            this.message.warning('Si è vericato un errore non previsto:<br>"' + error.statusText + '"');
        });
    }
    loginRfid(bUpdate = true) {
        this.g.loginUtente(this.code, this.rfid).subscribe((res) => {
            if (bUpdate) {
                this.process(res);
            }
            else {
                this.noProcess(res);
            }
        }, (error) => {
            this.code = "";
            this.rfid = "";
            this.message.warning('Si è vericato un errore non previsto:<br>"' + error.statusText + '"');
        });
    }
    process(res) {
        if (res.error === false) {
            this.message.success("Codice accettato", { nzDuration: 1000 });
            this.isLoading = true;
            this.g.userData = res.data;
            const timeStamp = new Date().getTime();
            let query = "SELECT * from chk_rfid WHERE `code`=" +
                this.g.userData.code +
                " AND `marked`= 0 ORDER BY `time_enter` DESC";
            this.g.mysql(query).subscribe((resOrders) => {
                this.isLoading = false;
                // tslint:disable-next-line:label-position
                const data = resOrders.data;
                if (data === null || data.length === 0 || data[0].time_exit !== 0) {
                    // ENTRATA
                    query =
                        "INSERT into chk_rfid (`code`, `time_enter`) VALUES (" +
                            '"' +
                            this.g.userData.code +
                            '",' +
                            timeStamp +
                            ")";
                    this.isLoading = true;
                    this.g.mysql(query).subscribe((resQuery) => {
                        this.showIngresso = true;
                        setTimeout(() => {
                            this.showIngresso = false;
                        }, 3000);
                    });
                }
                else {
                    query =
                        "UPDATE chk_rfid SET `time_exit` = " +
                            timeStamp +
                            " WHERE `code` = " +
                            this.g.userData.code +
                            " AND " +
                            "`time_enter` = " +
                            data[0].time_enter;
                    this.g.mysql(query).subscribe((resQuery) => {
                        // USCITA
                        this.showUscita = true;
                        data[0].time_exit = timeStamp;
                        this.calc(data);
                    });
                }
                // localStorage.setItem("webcheck", JSON.stringify(this.g.userData.ordini));
                // this.router.navigateByUrl('/track/(trackContent:ordine)');
            }, (error) => {
                this.isLoading = false;
                this.message.error("Si è vericato un errore non previsto:<br>" + error.statusText, { nzDuration: 5000 });
            });
            this.code = "";
            this.rfid = "";
        }
        else {
            this.message.warning(res.message, { nzDuration: 5000 });
            this.code = "";
            this.rfid = "";
        }
    }
    noProcess(res) {
        if (res.error === false) {
            this.message.success("Codice accettato", { nzDuration: 1000 });
            this.isLoading = true;
            this.g.userData = res.data;
            const timeStamp = new Date().getTime();
            const query = "SELECT * from chk_rfid WHERE `code`=" +
                this.g.userData.code +
                " AND `marked`= 0 ORDER BY `time_enter` DESC";
            // console.log(query);
            this.g.mysql(query).subscribe((resOrders) => {
                this.isLoading = false;
                const data = resOrders.data;
                this.showUscita = true;
                if (data[0].time_exit <= 0) {
                    data[0].time_exit = timeStamp;
                }
                this.calc(data);
            }, (error) => {
                this.isLoading = false;
                this.message.error("Si è vericato un errore non previsto:<br>" + error.statusText, { nzDuration: 5000 });
            });
            this.code = "";
            this.rfid = "";
        }
        else {
            this.message.warning(res.message, { nzDuration: 5000 });
            this.code = "";
            this.rfid = "";
        }
    }
    calc(data) {
        let lastEnter = 0;
        let totHrs = 0;
        let totAllHrsRaw = 0;
        this.totAllHrs = 0;
        this.g.userData.times = [];
        let newEnter;
        let t;
        let enters = [];
        let dtDiff = 0;
        data.forEach((d) => {
            if (d.time_exit !== 0) {
                dtDiff = this.g.diffTimeRaw(d.time_enter, d.time_exit); // diff grezza in ore
            }
            else {
                dtDiff = 0;
            }
            newEnter = new Date(d.time_enter).setHours(0, 0, 0, 0);
            if (lastEnter !== newEnter) {
                if (totHrs !== 0) {
                    t = { time: lastEnter, totH: totHrs, enters: enters };
                    this.g.userData.times.push(t);
                }
                enters = [];
                enters.push(d.time_enter);
                lastEnter = newEnter;
                totHrs = dtDiff;
            }
            else {
                enters.push(d.time_enter);
                totHrs += dtDiff;
            }
            // console.log('DIFF', d.time_enter, d.time_exit, dtDiff);
            totAllHrsRaw += dtDiff;
        });
        if (totHrs !== 0) {
            t = { time: lastEnter, totH: totHrs, enters: enters };
            this.g.userData.times.push(t);
        }
        this.totAllHrs = this.g.roundToHalfDown(totAllHrsRaw);
        // console.log('TOTH', this.totAllHrs);
    }
    continue() {
        this.showUscita = false;
    }
    edit() {
        this.router.navigateByUrl("/track/(trackContent:insert)");
    }
};
UtenteComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _environments_global__WEBPACK_IMPORTED_MODULE_4__["GlobalComponent"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])("document:keydown", ["$event"])
], UtenteComponent.prototype, "handleKeyboardEvent", null);
UtenteComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-data",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./utente.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/track/utente/utente.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./utente.component.scss */ "./src/track/utente/utente.component.scss")).default]
    })
], UtenteComponent);



/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\Users\Sources\WebCheck\webcheck.emsoft.it\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.9cf63cf787e60508cf50.js.map